const resources = {
  translation: {
    FORMS: {
      OPTIONAL: '(Volitelný)',
      BUILDING_COMPANY_ADDRESS: 'Řádek adresy 1',
      BUILDING_COMPANY_ADDRESS2: '2. řádek adresy (volitelné)',
      BUILDING_DETAILS: 'Podrobnosti o budově',
      CITY: 'Město',
      USER_ADDRESS_1: '1. řádek adresy společnosti',
      USER_ADDRESS_2: '2. řádek adresy společnosti',
      COMPANY_NAME: 'Název společnosti',
      CONFIRM_PASSWORD: 'Potvrďte heslo',
      COUNTRY: 'Země *',
      HELPING_TEXT: 'Pole s hvězdičkou (*) jsou povinná',
      FIRST_NAME: 'Křestní jméno',
      LAST_NAME: 'Příjmení',
      LOCAL_PRIMARY_EMAIL: 'E-mailová adresa místního primárního kontaktu',
      LOCAL_PRIMARY_CONTACT_INFO: 'Místní primární kontaktní informace',
      LOCAL_SECONDARY_EMAIL: 'Místní sekundární kontaktní e-mailová adresa',
      LOCAL_SECONDARY_CONTACT_INFO: 'Místní sekundární kontaktní informace',
      ORGANIZATION_ADDRESS_HEADER: 'Adresa organizace',
      COMPANY_ADDRESS: 'Řádek adresy organizace 1',
      ADDRESS_LINE_2: 'Řádek adresy organizace 2',
      ORGANIZATION_DETAILS_HEADER: 'Podrobnosti o organizaci',
      PASSWORD: 'Heslo',
      PASS_MATCH_ERROR: 'Hesla se neshodují',
      PHONE_NUMBER: 'Telefonní číslo',
      INVALID_CUSTOMER_NUMBER: 'Uveďte prosím platné zákaznické číslo',
      INVALID_EMAIL_ERROR: 'Zadejte prosím platnou e-mailovou adresu',
      INVALID_DETAILS: 'Zadejte prosím platné vstupní parametry',
      INVALID_PHONE_NUMBER: 'Uveďte prosím platné telefonní číslo',
      INVALID_POSTAL_CODE: 'Uveďte prosím platné PSČ',
      INVALID_SLA_NUMBER: 'Zadejte platné číslo smlouvy SLA o délce alespoň 8 znaků',
      POSTAL_CODE: 'PSČ',
      PRIMARY_CONTACT_INFORMATION: 'Primární kontaktní informace',
      RESET_PASSWORD: 'Obnovit heslo',
      TOGGLE_PASSWORD_VISIBILITY: 'Přepnout viditelnost hesla',
      VERIFICATION_CODE: 'Ověřovací kód',
},
    DUALSMART: {
      DS_LUMINARIES_FOUND: 'Nalezeno  svítidel',
      DS_CIRCUIT_READY: ' Okruh připraven',
      DS_COMMUNICATION_FAILURE: ' Selhání komunikace',
      DS_DIMM_ERROR: ' Dimm Error',
      DS_OVERCURRENT: 'Nadproud',
      DS_SAVE_UPDATE_BUTTON: ' Uložit aktualizaci',
      DS_SYNC_DATE_AND_TIME: 'Plán testu synchronizace',
      DS_CONNECTED_POWER_INFO: '10W / 15VA',
      DS_SYSTEM_COMPONENTS_COUNT: '7 Komponenty',
      DS_LUMINARIES_FOUND_TITLE: 'Na tomto systému byla nalezena svítidla.',
      DS_AE_ERROR: 'Ae Chyba',
      DS_ALL_STATUSES: 'Všechny stavy',
      DS_ALL_TESTS_PASSED: 'Všechny testy prošly',
      DS_ESTIMED_GUIDELINE_ONE: 'Přibližně 10 let při 20 °C',
      DS_ESTIMED_GUIDELINE_THREE: 'Přibližně 5 let při 30 °C',
      DS_ESTIMED_GUIDELINE_TWO: 'Přibližně 7 let při 25 °C',
      DS_BATTERY_CHARGER: 'Baterie / nabíječka',
      DS_BATTERY_CHARGE: 'Nabíjení baterie',
      DS_BATTERY_OPERATION: 'Provoz na baterie',
      DS_BLOCK_DEVICE: 'Blokovat zařízení',
      DS_BLOCK_DEVICE_INFO: 'Block Device Blokuje nouzovou funkci a vypíná okruh',
      DS_BLOCK_SUCCESS: 'Blokování bylo úspěšně provedeno',
      DS_BULB_ERROR_AC: 'Chyba žárovky AC',
      DS_BULB_ERROR_DC: 'Chyba žárovky DC',
      DS_CAPACITY: 'Kapacita',
      DS_CHARGER_LEVEL: 'Úroveň nabití:',
      DS_CHARGING_ERROR: 'Chyba nabíjení',
      DS_FUNCTIONAL_GUIDELINE: 'Zvolte dobu mezi 20 - 800 sekund, po kterou má systém komunikovat při přepnutí na bateriový provoz za účelem testu.',
      DS_CIRCUIT: 'Obvod',
      DS_CIRCUIT_FAILURE: 'Porucha obvodu',
      DS_CIRCUITS_INFO_HEADER: 'Informace o okruhu:',
      DS_CIRCUITS_NO: 'Obvod č.',
      DS_CIRCUITS: 'Obvody',
      DS_COMPONENTS_DETAIL: 'Podrobnosti součásti',
      DS_CONNECTED_POWER: 'Připojené napájení:',
      DS_CRYSTALWAY: 'CrystalWay 20m',
      DS_DAYS_BETWEEN_THE_TEST: 'Dny mezi testy',
      DS_DC1: 'DC1',
      DS_DC2: 'DC2',
      DS_KEEP_DEEP_DISCHARGE: 'Aktivní ochrana proti hlubokému vybití',
      DS_DELAY_ON_MAINS_RETURN: 'Zpoždění návratu do sítě',
      DS_ESTIMED_GUIDELINE: 'V závislosti na okolní teplotě a podmínkách na místě:',
      DS_DESCRIPTION: 'Popis',
      DS_END_DURATION_TEST_POPUP: 'Chcete zastavit testu baterií?',
      DS_DOUBLE_ADDRESS: 'Dvojitá adresa',
      DS_DT_FORERUN: 'DT Pre-Run',
      DS_DEVICE_COMMISSIONING: 'Duální chytré uvedení do provozu',
      DS_PASSWORD: 'Duální chytré heslo',
      DS_DURATION: 'Trvání',
      DS_DURATION_TEST: 'Test provozu z baterie',
      DS_DURATION_TEST_SCHEDULE: 'Plánování testu provozu z baterií',
      DS_EDIT_BATTERY_DETAILS: 'Upravit podrobnosti o baterii',
      DS_DASH_EMPTY: 'Prázdný',
      DS_ESTIMED_LIFESPAN: 'Odhadovaná životnost',
      DS_EXIT_SIGN: 'Exit Sign',
      DS_FAN_OPERATING_HOURS: 'Provozní hodiny ventilátoru',
      DS_FOUND: 'Nalezeno',
      DS_FT_FORERUN: 'FT Pre-Run',
      DS_FUNCTIONAL: 'Funkční',
      DS_FUNCTIONAL_LEAD_AND_TIME: 'Funkční dodací lhůta',
      DS_FUNCTION_TEST: 'Funkční test',
      DS_FUNCTIONAL_TEST_SCHEDULE: 'Harmonogram funkčních testů',
      DS_SYNC_DATE_AND_TIME_SUBTITLE: 'Hlavní kancelář G-North',
      DS_CIRCUITS_DESCRIPTION: 'Pomozte mi s popisem',
      DS_SEARCH_LUM_INFO_TEXT: 'Pokud potřebujete pouze přidat svítidla, použijte prosím možnost Vyhledat nová svítidla',
      DS_SEARCH_LUMS_POPUP_SUB_TITLE: 'Pokud potřebujete pouze přidat nová svítidla, použijte prosím možnost Hledat nová svítidla.',
      DS_INSTALLATION_DATE: 'Datum instalace',
      DS_INTERVAL: 'Interval',
      DS_CIRCUITS_INFO: 'Klíč potřeba. Omezený prostor! Registrace nutná.',
      DS_LAST_DURATION_TEST_TIME: 'Poslední zkušební doba trvání',
      DS_LIGHTANDBUILDING: 'Světlo a budova 2024',
      DS_LUMINAIRE_FAILURE: 'Selhání svítidla',
      DS_LUMINAIRE_NAME: 'Název svítidla',
      DS_LUMINARIES: 'svítidla',
      DS_MAINS_OPERATION: 'Provoz ze sítě',
      DS_NEXT_TEST_DATE: 'Datum příští zkoušky',
      DS_NO_OPERATION_POSSIBLE: 'Není možná žádná operace',
      DS_NORMAL_OPERATION: 'Normální provoz',
      DS_OPERATION_FAILED: 'Operace se nezdařila',
      DS_OVERTEMPERATURE: 'Nadměrná teplota',
      DS_OVERVOLTAGE: 'Přepětí',
      DS_PREV: 'Předchozí',
      DS_READY_ON: 'Připraveno',
      DS_RELEASE_DEVICE: 'Uvolněte zařízení',
      DS_RELEASE_DEVICE_INFO: 'Uvolnit zařízení Přepne zpět do provozu.',
      DS_RELASE_SUCCESS: 'Uvolnění proběhlo úspěšně',
      DS_SEARCH_LUM_WARNING_TEXT: 'Načítání dat. Počkejte několik sekund a zkuste vyjmout nebo zkopírovat znovu.',
      DS_CIRCUIT_LUMINARIES_DESC: 'Načítání dat. Počkejte několik sekund a zkuste vyjmout nebo zkopírovat znovu.',
      DS_SEARCH_COMPLETE: 'Hledání dokončeno',
      DS_SEARCH_GUIDLINE_ONE_TEXT: 'Vyhledejte všechna nainstalovaná a adresovaná svítidla',
      DS_SEARCH_ALL_LUMINARIES: 'Hledat všechna svítidla',
      DS_SEARCH_LUM_TEXT: 'Funkce Search for All Luminaries vytvoří novou konfiguraci následujícím způsobem:',
      DS_SEARCH_LUMS_POPUP_TITLE: 'Spuštěním vyhledávání se z vaší konfigurace odstraní všechna aktivovaná svítidla s vadou.',
      DS_SEARCH_GUIDLINE_TWO_TEXT: 'Zahájení vyhledávání smaže všechny aktivované. vadná svítidla z vaší konfigurace',
      DS_STARTS: 'Začíná',
      DS_SUMMARY_FT: 'Shrnutí funkčního testu',
      DS_SYSTEM_COMPONENTS: 'Systémové komponenty',
      DS_SYNC_DATE_AND_TIME_TITLE: 'Termíny a časy testů',
      DS_TEST_INTERVAL: 'Testovací interval',
      DS_TEST_LENGTH: 'Délka testu',
      DS_VIEW_CIRCUITS: 'Zobrazit podle okruhu',
      DS_W: 'W:',
      DS_SEARCH_FOR_NEW_LUMINARIES: 'Hledání nových svítidel',
      DS_SEARCH_LUM_NEW_TEXT: 'Vyhledejte nová svítidla, která chcete přidat do své konfigurace osvětlení:',
      DS_SEARCH_NEW_LUM_GUIDLINE_ONE_TEXT: 'Tím se automaticky přiřadí adresy novým nebo vyměněným svítidlům do vaší konfigurace osvětlení.',
      DS_SEARCH_NEW_LUM_INFO_TEXT: 'Pokud potřebujete pouze přidat svítidla, použijte prosím možnost Vyhledat nová svítidla',
      DS_NEW: 'Nový',
      DS_MODULE_TYPE: 'Typ modulu',
      DS_SEARCH_IO_MODULES: 'Prohledejte moduly I-Bus',
      DS_SEARCH_FOR_IO_MODULES: 'Vyhledejte moduly IO',
      DS_SEARCH_IO_MODULES_TEXT: 'Vyhledejte moduly IO a vytvořte novou konfiguraci takto:',
      DS_SEARCH_GUIDELINE_IO_MODULES_TEXT: 'Vyhledejte všechny nainstalované moduly na sběrnici, abyste je mohli nakonfigurovat a naprogramovat.',
      DS_SEARCH_IO_MODULES_BTN_TEXT: 'Vyhledejte moduly IO',
      DS_SEARCH_IO_MODULES_POPUP_TITLE: 'Pokud moduly nejsou správně připojeny, trvale změní vaši použitou konfiguraci.',
      DS_SEARCH_IO_MODULES_POPUP_SUB_TITLE: 'Před zahájením vyhledávání se ujistěte, že jsou všechna připojení správná.',
      DS_PHYSICAL_MODULES: 'Fyzické moduly',
      DS_SUBSCRIBED_MODULES: 'Předplaceno',
      DS_MODULES_FOUND: 'Moduly nalezeny',
      DS_MODULE_NUMBER: 'Modul č.',
      DS_SEARCHING: 'Hledání...',
      DS_TIMER: 'Časovač',
      DS_SET_TIMER: 'Nastavit časovač',
      DS_SUBMIT_CHANGES: 'Odeslat změny',
      DS_TIMER_1: 'Časovač 1',
      DS_TIMER_2: 'Časovač 2',
      DS_TIME_TITLE: 'Název časovače (volitelné)',
      DS_DAYS: 'Dny v týdnu a čas',
      DS_ACTIVE_DAYS: 'Vyberte dny v týdnu, kdy má být ___ aktivní.',
      DS_START_TIME: 'Čas zahájení',
      DS_END_TIME: 'Čas ukončení',
      DS_SET_RELAY_BUZZER: 'Nastavte Bzučák relé',
      DS_RESET_TO_DEFAULT_VALUES: 'Obnovit výchozí hodnoty',
      DS_RESET_TO_DEFAULT_VALUES_INFO: 'Vyberte výstup, kterému chcete přiřadit jeho funkce. Po dokončení klepněte na „Uložit“.',
      DS_SEARCH_NEW_LUMINARIES_INFO: 'Tyto výsledky použijte k vytvoření a sdílení nové konfigurace osvětlení pomocí „Exportovat“.',
      DS_RELAY_NO: 'Relé č.',
      DS_RESET_RELAY_BUZZER_POPUP_TITLE: 'Prosím potvrďte',
      DS_RESET_RELAY_ONE_TO_DEFAULT: 'Resetujte relé 1 na výchozí',
      DS_RESET_RELAY_BUZZER_TO_DEFAULT: 'Resetujte relé a bzučák na výchozí',
      DS_UNSAVED_CHANGES_POPUP_TITLE: 'Existují neuložené změny',
      DS_UNSAVED_CHANGES_POPUP_SUB_TITLE: 'Neuložili jste změny do relé 1. Chcete uložit?',
      DS_DISCARED_CHANGES: 'Zahodit změny',
      DS_CIRCUIT_TITLE: 'Svítidla, která jsou v tomto okně zapnuta/vypnuta, se vrátí do svého nakonfigurovaného stavu poté, co systém dokončí svou další spínací operaci.',
      DS_EMPTY: 'Prázdný / Selhání',
      LUM_TITLE: 'Klepnutím na svítidla je zapněte a vypněte',
      ALL_OFF: 'Vše vypnuto',
      DS_RESET_TITLE: 'Obnovit výchozí',
      DS_CONTROL_LUM: 'Ovládací svítidla',
      DS_LUM_BUTTON: 'Zapnutí/vypnutí svítidel',
      DS_APPLY: 'Použít',
      DS_SET_IO_BUS_MODULES_TITLE: 'Nastavení modulů I-Bus',
      DS_NEXT_MODULE: 'Uložit a přesunout do dalšího modulu',
      DS_MODULE_DETAILS: 'Podrobnosti modulu',
      DS_MODULE_NAME: 'Název modulu',
      DS_LOCAL_ONLY: 'Pouze místní',
      DS_PUBLISH: 'Publikovat',
      DS_SUBSCRIBE: 'Upsat',
      DS_ACU_BUS_ID: 'ID sběrnice ACU',
      DS_BUS_MODULE: 'Sběrnicový modul',
      DS_INPUTS: 'Vstupy',
      DS_CONFIGURED_MODULE_TITLE: 'Na tomto modulu nejsou aktuálně nakonfigurovány žádné vstupy pro monitorování fáze.',
      DS_CONFIGURE_INPUTS: 'Konfigurace vstupů',
      DS_BLOCK: 'Blok',
      DS_RELEASE: 'Uvolnění',
      DS_BLOCK_GUIDLINE: 'Tím se zablokuje nouzová funkce a obvody se vypnou.',
      DS_RUN_TESTS: 'Spustit testy',
      DS_LUMINARIE_CONTROLS: 'Ovládání svítidel',
      DS_LUMINARIE_CONTROLS_GUIDELINE: 'Tyto funkce vám umožňují přepsat nakonfigurované programování svítidla, dokud je nevypnete.',
      DS_ALL_LUMINARIES_ON: 'Všechna svítidla zapnuta',
      DS_INACTIVE: 'Neaktivní',
      DS_MAINTAINED_LUMINARIES_OFF: 'Vypnutá udržovaná svítidla',
      DS_NON_MAINTAINED_LUMINARIES_OFF: 'Neudržovaná svítidla zapnuta',
      DS_RESET_SYSTEM_STATE: 'Resetovat stav systému',
      DS_MANUAL_RESET: 'Ruční reset',
      DS_RESET_ISO_FAILURE: 'Chyba resetování ISO',
      DS_RECHARGE_DEEP_DISCHARGE_PROTECTION: 'Resetujte ochranu proti hlubokému vybití',
      DS_SIMULATE_MAINS_FAILURE: 'Simulovat výpadek sítě',
      DS_SEARCH_ISO_FAILURE: 'Hledání selhání ISO',
      DS_SET_I_BUS_MODULES: 'Nastavení modulů I-Bus',
      DS_COMMISSIONING: 'Uvedení do provozu',
      DS_DATE_AND_TIME: 'Datum a čas',
      DS_RESET_SERVICE_CENTER: 'Resetujte počítadlo služeb',
      DS_ALERT_LEVEL: 'Úroveň výstrahy',
      DS_DRY_CONTACT: 'Suchý kontakt',
      DS_BUILDING_MANAGMENT_SYSTEM: 'Systém správy budov (BMS)',
      DS_MODBUS: 'Modbus',
      MANAGE_INTERNET_CONNECTION: 'Správa připojení k internetu',
      INTERNET_CONNECTION: 'Připojení k internetu',
      SUB_LOCATION: 'Dílčí umístění',
      TIME_PERIOD_NINTY_DAYS: 'Každých 90 dní',
      DS_SEARCH_ISO_FAILURE_TITLE: 'Hledat selhání izolace?',
      DS_SEARCH_ISO_FAILURE_BODY: 'Pokud se vám zobrazuje zpráva o selhání ISO, stiskněte „Hledat“ pro určení dotčených obvodů.',
      DS_SEARCH: 'Vyhledávání',
      DS_MAIN_FAILURE_MSG: 'To bude simulovat DC provoz a bude trvat přibližně 5 sekund, než se přepne zpět do normálního provozu.',
      DS_START: 'Start',
      DS_DEEP_DISCHARGE: 'Potvrzení ochrany proti hlubokému vybití',
      DS_DEEP_DISCHARGE_MSG: 'Výběrem „Potvrdit“ potvrzujete, že jste byli svědky toho, že baterie systému přešly do stavu hlubokého vybití',
      DS_ACKNOWLEDGE: 'Potvrdit',
      DS_RESET_ISO: 'Resetovat selhání izolace?',
      DS_RESET_ISO_MSG: 'Tím se resetuje zpráva o selhání izolace.\n\nPokud se chyba ISO objeví znovu a po kontrole konečných obvodů nelze zjistit žádnou příčinu, kontaktujte prosím servisní oddělení',
      DS_RESET: 'Resetovat',
      DS_MANUAL_RESET_TITLE: 'Provést ruční reset?',
      DS_MANUAL_RESET_MSG: 'Všechna bezpečnostní svítidla se přepnou zpět do normálního provozu na základě jejich naprogramování',
      DS_BLOCK_TITLE: 'Zablokovat systém a ukončit test trvání?',
      DS_CONFIRM_BLOCK: 'Potvrdit a zablokovat',
      DS_BLOCK_TEXT: 'Před provedením dalšího testu trvání bude baterie potřebovat k dobití alespoň 24 hodin.',
      TRIGGERS: 'Spouštěče',
      DEFAULT_TRIGGERS

   : 'Výchozí spouštěče',
      OPTIONAL_TRIGGERS: 'Volitelné spouštěče',
      ADD_TRIGGER: 'Přidat spouštěč',
      SELECT_TRIGGERS: 'Vyberte Spouštěče',
      ASSIGN_TRIGGERS: 'Přiřadit spouštěče',
      SELECTED: 'Vybraný',
      INSTALLED: 'Instalováno',
      SCENARIO: 'Scénář',
      LUMINARIES_COUNT: '10 z 10 svítidel',
      DS_INPUT_OF_PHASE_MONITOR: 'Vstup fázového monitoru',
      DS_CIRCUIT_TRIGGERS_SUCCESSFULLY_LINE: 'Spouštěče okruhu č. 1 byly úspěšně nakonfigurovány.',
      DS_SET_OTHER_CIRCUIT_TRIGGERS: 'Nastavte další spouštěče okruhu',
      DS_ASSIGN_DEFAULT_TRIGGERS_GUIDELINE: 'Klepnutím nebo přetažením svítidla je přiřadíte tomuto spouštěči.',
      DS_ASSIGN_TRIGGERS_GUIDELINE_TWO: 'Potvrďte prosím každý spouštěč pro okruh 1.',
      DS_NON_MAINTAINED_LIGHT: 'Neudržované světlo',
      DS_MAINTAINED_LIGHT: 'Udržované světlo',
      DS_INSTALLED_LUMINARIES: 'Instalovaná svítidla',
      DS_TIMER_SCHEDULE: 'Harmonogram pracovních dnů',
      DS_DEEP_DISCHARGE_TITLE: 'Hluboké vybití',
      DS_STIMULATE_MAIN_FAILURE: 'Stimulujte hlavní poruchu',
      DS_START_FUNCTIONAL_TEST: 'Spusťte funkční test',
      DS_SHORT_LEAD_TIME: 'Použijte krátkou dodací lhůtu',
      DS_ASSIGNED_PHASE_MONITORING_INPUT: 'Přiřazené vstupy monitorování fáze',
      DS_INPUT_CONFIGURATION_TITLE: 'Konfigurace vstupu',
      DS_ASSIGNED_FUNCTION: 'Přiřazená funkce',
      DS_PHASE_MONITORING_INPUT: 'Vstupy monitorování fáze L1/L2/L3',
      DS_RESET_OPTION: 'Možnost resetování',
      DS_LENGTH_OF_TIME: 'Délka času (minuta)',
      DS_PHASE_MONITOR: ': Monitor fáze',
      NO_FUNCTION: 'Žádná funkce',
      ALL_LUM_ON: 'Všechna svítidla zapnuta',
      MANNUAL_RESET: 'Ruční reset',
      INVERSE_SWWITCH: 'inverzní spínač',
      SWITCH_OFF_MAINTAINED_LIGHT: 'vypněte udržované světlo',
      ALL_LUMINARIES_ON: 'všechna svítidla zapnuta',
      VENTILATION_MONITORING: 'monitorování ventilace',
      EXT_MONITOR: 'Ext. Monitor',
      SWITCH: 'přepínač',
      DELAY_ON_MAINS_RETURN: 'Zpoždění návratu do sítě',
      VIA_THE_APP: 'Prostřednictvím aplikace',
      DS_INPUT_NAME: 'Název vstupu',
      DS_VALIDATION_TXT_MSG_FOR_SETIOBUS: 'Vyplňte prosím povinná pole: název modulu, typ konfigurace a konfigurační vstupy.',
      DS_VALIDATION_TXT_MSG_FOR_INPUT_CONFIG: 'Vyplňte prosím povinná pole: názvy vstupů, název fáze, přiřazené funkce, možnost resetování a délka času.',
      DS_SET_IO_MODULES_LIST_SUBTITLE: '10 modulů bylo úspěšně nakonfigurováno.',
      DS_CONFIGURATION_TYPE_ERROR_MSG: 'není vybrán typ konfigurace',
      DS_INPUT_NAME_ERROR_MSG: 'InputName je v indexu prázdný',
      DS_ASSIGNED_FUCNTION_ERROR_MSG: 'AssignedFunctionValue je v indexu prázdný',
      DS_PHASE_MONITORING_INPUT_NAME_ERROR_MSG: 'Název vstupu monitorování fáze je prázdný.',
      DS_RESET_OPTION_ERROR_MSG: 'Hodnota možnosti Reset je prázdná.',
       DS_LENGTH_OF_TIME_ERROR_MSG: 'Délka časové hodnoty je prázdná.',
      DURATION_TEST_COMPLETE: 'Test provozu z baterií ukončen',
      FUNCTIONAL_TEST_COMPLETE: 'Funkční test dokončen',
      MODBUS: {
        MANUAL_RESET: 'Ruční reset',
        RESET_DEEP_DISCHRGE_PROTECTION: 'Resetujte ochranu proti hlubokému vybití',
},
      DS_FINISH: 'Dokončit',
      DS_EXT_MONITOR: 'Ext. Monitor',
      NORMAL_OPERATION: 'Normální provoz',
      CIRCUIT_FAILURE: 'Porucha obvodu',
      DEEP_DISCHARGE: 'Hluboké vybití',
      DS_BATTERY: 'Baterie',
      DS_SERIAL_NUMBER: 'sériové číslo',
      DS_SET_INPUT_CONFIG: {
        ASSIGNED_FUNCTION: {
          NO_FUNCTION: 'Žádná funkce',
          ALL_LUM_ON: 'Všechna svítidla zapnuta',
          MANNUAL_RESET: 'Ruční reset',
          INVERSE_SWWITCH: 'inverzní spínač',
          SWITCH_OFF_MAINTAINED_LIGHT: 'vypněte udržované světlo',
          VENTILATION_MONITORING: 'monitorování ventilace',
          EXT_MONITOR: 'Ext. Monitor',
          SWITCH: 'přepínač',
},
        RESET_OPTION: {
          MANNUAL_RESET: 'Ruční reset',
          DELAY_ON_MAINS_RETURN: 'Zpoždění návratu do sítě',
},
        LENGTH_OF_TIME: {
          VIA_THE_APP: 'Prostřednictvím aplikace',
},
},
      BUZZER: {
        NORMAL_OPERATION: 'Normální provoz',
        CIRCUIT_FAILURE: 'Porucha obvodu',
        DEEP_DISCHARGE: 'Hluboké vybití',
},
      DS_SYSTEM_MODULE_TYPE: 'Typ',
      DS_SYSTEM_MODULE_INPUT_NAME: 'Název vstupu',
      EMPTY: 'Prázdný',
      DS_BLOCKED: 'Blokováno',
      DS_NAME: 'Jméno',
},
    DEVICE_DETAILS: {
      USERS_ADMINS: ' admin',
      USERS_VIEWER: 'uživatel',
      FIRMWARE_AVAILABLE_GUIDE_LINK: '(Průvodce)',
      USERS_COUNTS: '{{adminCount}} admin, {{viewerCount}} uživatel',
      FIRMWARE_AVAILABLE_GUIDE: '{{availableVersion}} Dostupný',
      LUMINARY_ATSD: 'ATSD #',
      CONNECTION_TYPE_BLE: 'BLE',
      BLOCK: 'Blokováno',
      BUILDING: 'Budova',
      CONNECTION_TYPE_CELLULAR: 'Mobilní síť',
      LUMINARY_CIRCUIT: 'Obvod',
      LUMINARY_CIRCUIT_HASH: 'Okruh č.',
      CITY: 'Město',
      CONNECTED: 'Připojeno',
      CONNECTION_TYPE: 'Typ připojení',
      DATE_COMMISSIONED: 'Datum uvedení do provozu',
      DEVICE_MODEL: 'Model zařízení',
      DEVICE_SERIAL: 'Sériové číslo zařízení',
      DURATION_TEST: 'Test provozu z baterie',
      DURATION_TEST_DURATION: 'Délka testu provozu na baterie',
      ERROR: 'Chyba',
      CHANNEL_DATA_ERROR: 'Chyba při načítání dat kanálu',
      DEVICE_CONNECTION_ERROR: 'Chyba při načítání dat připojení',
      DEVICE_DETAILS_ERROR: 'Chyba při načítání podrobností o zařízení',
      CONNECTION_TYPE_ETHERNET: 'Ethernet',
      EVENT: 'Událost',
      FIRMWARE_VERSION: 'Verze firmwaru',
      FUNCTIONAL_TEST: 'Funkční test',
      DELAY_FUNCTIONAL_TEST: 'Zpoždění funkčního testu',
      GATEWAY_ADDRESS: 'Adresa brány',
      GATEWAY_NAME: 'Název brány',
      GATEWAY_COUNT: 'Brána systému {{systemCount}}',
      GATEWAY_COUNT_SYSTEMS: 'Brána systémů {{systemCount}}',
      GATEWAYS: 'Brány',
      HOSTNAME: 'Název hostitele',
      LUMINARY_DETAIL_INFO: 'Info',
      IPADDRESS: 'IP adresa',
      LAST_DATA: 'Poslední údaje',
      LUMINAIRE: 'Svítidlo',
      LUMINARY_ADDRESS: 'Adresa svítidla',
      LUMINAIRES: 'Svítidla',
      LUMINARIES_COUNTS: 'Svítidla',
      MAC_ADDRESS: 'Mac adresa',
      CONNECTION_TYPE_MODBUS: 'Modbus',
      LUMINARY_MODEL: 'Model',
      CONNECTION_TYPE_MQTT: 'MQTT',
      LUMINARY_NAME: 'Jméno',
      NAME: 'Jméno',
      NETWORK_DETAILS: 'Podrobnosti o síti',
      NEXT: 'Další',
      LUMINARY_DISCRIPTION: 'Spustí se další test trvání',
      NEXT_DURATION_TEST: 'Spustí se další test trvání',
      NEXT_FUNCTIONAL_TEST: 'Spustí se další funkční test',
      NO_CHANNEL_DATA: 'Žádná data kanálu',
      NO_DEVICE_CONNECTION: 'Žádná data připojení zařízení',
      NO_DEVICE_DETAILS: 'Žádná data podrobností o zařízení',
      OFFLINE: 'Offline',
      ONLINE: 'Online',
      ORGANIZATION: 'Organizace',
      PART_NUMBER: 'Číslo dílu',
      PREVIOUS: 'Předchozí',
      PREVIOUS_DURATION_TEST: 'Předchozí test trvání byl zahájen',
      PREVIOUS_FUNCTIONAL_TEST: 'Byl zahájen předchozí funkční test',
      READY: 'Připraveno',
      CONNECTION_TYPE_RS485: 'RS485',
      SERIAL_NUMBER: 'sériové číslo',
      GATEWAY_SHOW_ALL: 'Zobrazit vše',
      STATUS: 'Postavení',
      LUMINARY_STATUS: 'Postavení',
      SUBNET_MASK: 'Maska podsítě',
      SYSTEM: 'SYSTÉM',
      SYSTEMS: 'Systémy',
      LUMINARY_DETAIL_TEST: 'Testy',
      TYPE: 'Typ',
      LUMINARY_TYPE: 'Typ',
      UPDATE_REQUIRED: 'JE VYŽADOVÁNA AKTUALIZACE',
      USERS: 'Uživatelé',
      WARNING: 'Varování',
      CONNECTION_TYPE_WIFI: 'WiFi',
      CONNECTION_TYPE_WIREPASS: 'Wirepas',
      UNASSIGNED: 'Nepřiřazeno',
},
    LOGBOOK_DETAILS: {
      LABEL_EVENT_AGO: ' před',
      PART_NUMBER: 'PN:',
      SERIAL_NUMBER: ' SN:',
      ADD_COMMENTS: '+ Přidat komentáře...',
      REQUIRES_FIRMWARE_UPDATE: '1 VYŽADUJE AKTUALIZACI FIRMWARU',
      ACKNOWLEDGE: 'Potvrdit',
      ACKNOWLEDGED: 'Potvrzeno',
      ACKNOWLEDGED_BY: 'Potvrzeno přes',
      PREVIOUS_ACKNOWLEDGED_BY: 'Potvrzeno přes:',
      ACTIVE: 'Aktivní',
      ACTIVE_ACKNOWLEDGED: 'Aktivní . Uznáno',
      AT: 'na',
      LABEL_CLOSED: 'zamčeno',
      CLOSED: 'Zamčeno',
      COMMENTS: 'Komentáře',
      DESCRIPTION: 'Popis',
      DEVICE: 'Zařízení',
      EDIT: 'Upravit',
      EVENT: 'Událost',
      LABEL_EVENT_BEGAN : 'Akce začala:',
      LABEL_EVENT_CLOSE: 'Událost uzavřena:',
      LOGBOOKDETAIL: 'LogBookDetail',
      NO_PREVIOUS_LOG_TITLE: 'Žádná předchozí položka protokolu v tomto systému',
      PARTNO: 'PN:',
      PREVIOUS_LOG_ITEM: 'Předchozí položka protokolu v tomto systému',
      PREVIOUS_LOG_TITLE: 'Předchozí položka protokolu v tomto systému',
      SERIALNO: 'SN:',
      STATUS: 'Postavení',
      SYSTEM: 'Systém',
      TIMESTAMP: 'Časové razítko',
      SYSTEM_TYPE : 'Typ:',
},
    ORGANIZATION_MANAGE: {
      BUILDING_COUNT: ' Budova',
      BUILDING_COUNT_S: ' Budovy',
      ORGANIZATION_MANAGE: ' Budovy',
      ADMIN_COUNT: 'Organizace administrátor',
      ADMIN_COUNT_S: 'Organizace administrátoři',
      VIEWER_COUNT: 'Organizace uživatel',
      VIEWER_COUNT_S: 'Organizace uživatelé',
      SYSTEM_COUNT: 'Systém',
      SYSTEM_COUNT_S: ' Systémy',
      ADD_NEW_BUILDING: '+ Přidat novou budovu',
      CREATE_ORGANIZATION: '+ Vytvořit organizaci',
      ERROR_ADD_NEW_SYSTEM_ACTION: 'Přidat nové systémy',
      ALL: 'Vše',
      SORT_TYPE_NAME: 'Abeceda',
      SORT_TYPE_CITY: 'Město',
      COMMENTS_HELPER: 'Komentáře, které pomohou technikům dorazit na místo.',
      ORGANIZATION_NAME_HELPER: 'Pouze písmena, číslice, podtržítka a pomlčky',
      MARK_AS_FAV_API_FAILURE_MESSAGE: 'Označit jako neúspěšné',
      ERROR_NO_BUILDING_FOUND: 'Nebyla nalezena žádná budova',
      ERROR_NO_GATEWAY_FOUND: 'Nebyla nalezena žádná brána',
      ERROR_NO_LOGS_TITLE: 'Žádné protokoly během tohoto období',
      ERROR_NO_LUMINARY_FOUND: 'Nebyla nalezena žádná svítidla',
      ERROR_NO_ORG_FOUND: 'Nebyla nalezena žádná organizace',
      ERROR_NO_REPORT_FOUND: 'Nebyly nalezeny žádné zprávy',
      ERROR_NO_SYSTEM_FOUND: 'Nebyl nalezen žádný systém',
      ERROR_NO_USER_FOUND: 'Nebyl nalezen žádný uživatel',
      SORT_TYPE_NUMBER_OF_SYSTEMS: 'Počet systémů',
      QUIT_EDIT_USER_DETAILS: 'Ukončete úpravy',
      QUIT_TITLE: 'Ukončit úpravy „{{orgName}}“?',
      ERROR_READ_INSTALLATION_MANUALS_ACTION: 'Přečtěte si instalační manuály',
      SEARCH: 'Vyhledávání',
      SEARCH_BUILDINGS: 'Vyhledávání',
      SEARCH_BUILDINGS_DASHBOARD: 'Prohledejte budovy',
      SEARCH_SYSTEM_DASHBOARD: 'Vyhledávací systémy',
      SORT_BY_HEADER: 'ŘADIT PODLE',
      STARRED_ORGANIZATIONS: 'Organizace označené hvězdičkou',
      VIEW_ORGANIZATION: 'Zobrazit organizaci',
      ERROR_NO_DEVICE_TITLE: 'V této organizaci zatím nemáte žádné prostředky.',
      ERROR_NO_DEVICE_DESCRIPTION: 'Jakmile začnete přidávat aktiva (systémy) do této organizace, zobrazí se informace o stavu vašich nouzových světel.',
      QUIT_MESSAGE: 'Vaše neuložené změny budou ztraceny.',
},
    ADD_BUILDING: {
      BLDG_ORG_CONTACT: 'Kontakty',
      INVERTED_COMMAS_S: '’s',
      BLDG_ORG_CONTACTS: '’s Kontakty',
      BLDG_ADDITIONAL_DESC: 'Přidejte volitelné další komentáře, které pomohou vašemu servisnímu týmu',
      BLDG_ADD_DESCRIPTION: 'Další popisy',
      BLDG_ADDRESS: 'adresa',
      BLDG_CREATTION: 'Budova vytvořena',
      BUILD_CREATE_SUCESS: 'Budova byla úspěšně vytvořena',
      BLDG_HEADER: 'Vytvořit novou budovu pro',
      BLDG_LOCATION_MESSAGE: 'Přetažením mapy umístěte špendlík poblíž místa, kde se nachází budova. To pomáhá polním inženýrům v budoucnu rychle dorazit na místo.',
      BLDG_EDIT_BTN: 'Upravit kontaktní údaje',
      BLDG_NAMELENGTH: 'Např. hlavní kancelář, sklad',
      BLDG_INITILIZING_NETWORK: 'Inicializace sítě...',
      BLDG_INSIDE: 'uvnitř',
      BLDG_LOCAL_CONTACT: 'Místní stavební kontakt',
      BLDG_CONTACT_TITLE: 'Kontaktní údaje místní budovy',
      BLDG_LOCATE_ON_MAP: 'Místo toho vyhledejte na mapě',
      BLDG_LOCATION: 'Umístění',
      BLDG_ADDTIONAL_DETAILS: 'Nyní přidáme další podrobnosti k dokončení nastavení',
      ORG_CREATE_SUCESS: 'Organizace byla úspěšně vytvořena',
      BLDG_ADDITION_ERROR: 'Zadejte platnou adresu.',
      BLDG_PRIMARYCONTACT: 'Primární kontakt',
      BLDG_PRIMARY_LOCAL_CONTACT: 'Primární místní kontakt',
      BLDG_SECONDARYCONTACT: 'Sekundární kontakt (volitelné)',
      BLDG_SECONDARY_LOCAL_CONTACT: 'Sekundární místní kontakt',
      BLDG_NO_POSTAL_ADDRESS: 'Tuto možnost vyberte, pokud poštovní adresa není k dispozici',
      BLDG_CREATED_MESSAGE: 'Úspěšně vytvořeno',
      BLDG_ORGANIZATION_FOR: 'Použijte organizaci',
      BLDG_ADD_CONTACT: 'Komu mohou elektrikáři oslovit "Hlavní kancelář"',
      SAVE_CHANGES_MSG: 'Vaše změny byly uloženy',
},
    USER_SETTINGS: {
       AUTOMATIC_LOGOUT_SUBTITLE: ' Deaktivujte automatické vypršení relace po 15 minutách',
      ALARMS: '.',
      PHONE_NO_TEXT: 'Aby bylo možné přijímat upozornění prostřednictvím SMS, je vyžadováno mobilní číslo',
      ACCOUNT: 'Účet',
      ACCOUNT_CREATED_DATE: 'Účet vytvořen',
      ADDRESS: 'Adresa',
      ALARMS_TITLE: 'Alarmy',
      APPLICATION_THEME_COLOR: 'Barva motivu aplikace',
      AUTOMATIC_LOGOUT: 'Automatické odhlášení',
      UNITS_DESCRIPTION: 'Britské imperiální jednotky',
      BUILDING_NAME: 'Název budovy',
      TIMEZONE_DESCRIPTION: 'Středoevropský čas (GMT-1:00)',
      CHANGE_PASSWORD: 'Změnit heslo',
      COMPANY_ADDRESS: 'Adresa společnosti',
      COMPANY_NAME: 'Název společnosti',
      COMPANY_PHONE_NUMBER: 'Telefonní číslo společnosti',
      DATE_FORMAT: 'Formát data',
      DATEFORMAT_DESCRIPTION: 'DD/MM/RRRR',
      DELETE_ACCOUNT: 'Smazat účet',
      STATUS_UPDATES: 'Zařízení je v blokovacím režimu, nouzovém režimu, je vyžadována údržba',
      AUTOMATIC_LOGOUT_TITLE: 'Zakázat automatické odhlášení',
      EMAIL: 'E-mailová adresa',
      EMAIL_NOTIFICATION: 'E-mailová upozornění',
      TEXT_NOTIFICATION_TITLE: 'Povolit textová upozornění (SMS)',
      ENABLED: 'Povoleno',
      TEXT_NOTIFICATION_BODY: 'Povolení upozornění pomocí SMS může vašemu poskytovateli mobilních služeb způsobit další poplatky za textové zprávy. Tyto poplatky nejsou zahrnuty ve smlouvě o poskytování služeb Eaton.',
      LANGUAGE_DESCRIPTION: 'Angličtina - Velká Británie',
      HEALTH_REPORT_TITLE: 'Zpráva o zdraví',
      LANGUAGE: 'Jazyk',
      HEALTH_REPORT: 'Měsíční reporting',
      PRODUCT_UPDATES: 'Nové verze, k dispozici aktualizace firmwaru',
      NOTIFICATIONS_HEADER: 'Oznámení',
      APP_THEME_DESCRIPTION: 'Téma operačního systému',
      ORGANIZATION: 'Organizace',
      ORGANIZATION_NAME: 'Název organizace',
      PASSWORD: 'Heslo',
      PHONE_NUMBER: 'Telefonní číslo',
      PREFERENCES_HEADER: 'Předvolby',
      PRODUCT_UPDATES_TITLE: 'Aktualizace produktu',
      STATUS_UPDATES_TITLE: 'Aktualizace stavu',
      TEXT_NOTIFICATION: 'Textová upozornění (SMS)',
      AUTOMATIC_LOGOUT_BODY: 'Tím se přepíše standardní bezpečnostní funkce obsažená v aplikaci, aby se zabránilo přístupu k opuštěné relaci. Uvědomte si prosím, že uživatel bude odpovědný za ochranu neoprávněného přístupu k tomuto systému a nikdy by tuto aplikaci neměl nechávat otevřenou bez dozoru.',
      TIME_ZONE: 'Časové pásmo',
      UNITS: 'Jednotky',
      ORG_ADDRESS: 'Použijte adresu organizace',
      ORG_CONTACT_DETAILS: 'Použijte kontaktní údaje organizace',
      EDIT_USER_DETAILS: 'Podrobnosti o uživateli',
      NAME: 'Uživatelské jméno',
      USER_NAME: 'Uživatelské jméno',
      WARNING: 'VAROVÁNÍ',
},
    EDITUSER: {
       PROMOTE_CONFIRMATION: ' Pokud to bylo zamýšleno, odešlete svou změnu.',
      DEMOTE_CONFIRMATION: 'Pokud to bylo zamýšleno, proveďte úpravy níže v části Role/Umístění tohoto formuláře.',
      DEMOTE: 'Změnili jste roli tohoto správce organizace. Pokud jste to neměli v úmyslu - vyberte zrušit.',
      PROMOTE: 'Povýšili jste tohoto uživatele na správce organizace. Pokud jste to neměli v úmyslu - vyberte zrušit.',
},
    ADDUSER: {
      INVITEUSER: ' Pozvat uživatele',
      TITLE: 'Přidat uživatele',
      ASTERIKSINFO: 'Pole označená hvězdičkou (*) jsou povinná pole nezbytná k pozvání uživatele.',
      INVITESUCCESS: 'Pozvánka byla úspěšná!',
      SELECTROLE: 'Vyberte roli pro umístění',
      ACCOUNTCREATED: 'Pozvánka k vytvoření účtu byla úspěšně zahájena.',
      EMAILRECEIVE: 'Uživatel obdrží e-mailovou pozvánku k vytvoření účtu za 5–10 minut. Jejich stav neuvidíte, dokud pozvánku nepřijmou.',
      ADDUSERINFORMATION: 'Informace o profilu uživatelského účtu',
},
    GATEWAY: {
      MANAGE_CELLULAR_CONNECTION: ' Správa mobilního připojení',
      TRANSFER_SYSTEM: {
        TRANSFER_SYSTEM_SELECTION_PAGE_TITLE: '{{gatewayName}} Gateway Systémy ({{systemCount}})',
        TRANSFER_SYSTEM_USERCONFIRMATION_TITLE: '{{gatewayName}} Systémy budou převedeny na následující uživatele:',
        ADD_ANOTHER_USER: 'Přidat dalšího uživatele',
        ADMIN_RIGHT_REQUIRED: 'K pozvání uživatele jsou vyžadována administrátorská práva',
        REGISTER_USER_REQUIRED: 'K převodu je nutný alespoň jeden registrovaný uživatel',
        EMAIL_ID_DUPLICATE: 'EmailId je duplicitní nebo neplatný vstup',
        ADMIN_RIGHT_REQUIRED_FOR_SYSTEM_TRANSFER: 'K přenosu uživatelských entit jsou vyžadována administrátorská práva',
        DUPLICATE_ENTITY_ID: 'EntityId je duplicitní nebo neplatný vstup',
        TRANSFER_SYSTEM_EXISTING_USER: 'Stávající uživatelé',
        INVALID_ENTITY_TYPE: 'Neplatný typ entity. Zadejte prosím platný typ entity',
        TRANSFER_SYSTEM_LOGED_IN_USER_MSG: 'Neplatný uživatel, přidejte dalšího uživatele.',
        INVITE_AS_COLLEAGUE: 'Pozvat jako kolegu',
        TRANSFER_SYSTEM_NEW_USER: 'Noví uživatelé',
        TRANSFER_SYSTEM_ADD_EXISTING_USER: 'Přidejte alespoň jednoho stávajícího uživatele k přenosu entit.',
        INVALID_EMAIL_ADDRESS: 'Zadejte prosím platnou e-mailovou adresu',
        INVALID_GATEWAY_ID: 'Uveďte prosím platné ID brány',
        TRANSFER_SYSTEM_INFO: 'Vyberte stávajícího uživatele nebo přidejte nového.',
        TRANSFER_SYSTEM_SYSTEM_SELECTION_HEADER: 'Vyberte systém(y), který chcete převést.',
        NO_DATA_FOUND: 'Požadovaná data nebyla nalezena',
        TRANSFER_SYSTEM_SYSTEM_TRANSFER: 'Přenos systému',
        TRANSFER_SYSTEM_CONFIRMATION_NEW_USER: 'Tento uživatel nemůže monitorovat systémy, dokud nepřijme pozvání na uvedený e-mail.',
        TRANSFER_SYSTEM_PRIVILEGES: 'Oprávnění systému přenosu',
        TRANSFER_TO: 'Přenést do',
        TRANSFER_USER_ALREADY_ADDED: 'Uživatel již přidán',
        TRANSFER_SYSTEM_ALREADY_ADDED_USER: 'Uživatel již byl přidán do seznamu. Přidejte dalšího uživatele.',
        TRANSFER_SYSTEM_USER_SELECTION_HEADER: 'Na koho chcete tyto systémy převést?',
        ADD_USERS: 'Přidat uživatele',
},
      ENTRY_PASSWORD_TITLE: 'Přístup pro',
      ADD_GATEWAYS: 'Přidat zařízení',
      ADDING_GATEWAY_TITLE: 'Přidávání „{{gatewayName}}“ do {{orgName}}',
      CONNECT_TO_ELSYSTEM_FAILED_UREACHABLE_MSG: 'Brána se pokouší připojit k systému a může to trvat déle, zkontrolujte stav na kartě Systém',
      RESET_GATEWAY_PASSWORD_SUCCESS: 'Heslo brány bylo úspěšně resetováno.',
      BLE: {
        ERROR: {
          INVALID_IP_AADRESS: 'Neplatná adresa IP',
          CHANGE_FAILURE_MESSAGE: 'Při změně parametrů došlo k chybě',
          NOT_FETCHING_SYSTEM_DETAILS: 'Nelze načíst podrobnosti o systému',
          BUILDING_ALREADY_EXISTS: 'Název budovy již existuje',
          RESET_PASSWORD_FAILED: 'Požadavek na resetování hesla se nezdařil. Zkuste to prosím znovu',
          INVALID_CONNECTION_STRING: 'Neplatný připojovací řetězec',
          INVALID_UUID: 'Neplatné UUID',
          ORGANIZATION_ALREADY_EXISTS: 'Název organizace již existuje',
          REQUEST_FAILED_TITLE: 'Požadavek se nezdařil',
          REQUEST_FAILED_GATEWAY_ADD: 'Požadavek na přidání brány se nezdařil.',
          REQUEST_FAILED_MESSAGE: 'Operaci nebylo možné dokončit. Počkejte prosím několik minut a zkuste to znovu.',
          UNAUTHORIZED_ACCESS: 'Neoprávněný přístup Přihlaste se prosím znovu',
          INVALID_DEVICE: 'Neplatné zařízení',
          GATEWAY_UNRECHABLE: 'Systém nedostupný',
          MAX_LIMIT_SYSTEM_REACHED_TITLE: 'Byl dosažen maximální limit systému',
          REQUEST_FAILED_WIRELESS_GATEWAY_ADD: 'Požadavek se nezdařil přidat bezdrátovou bránu.',
          REQUEST_FAILED_LP_SMART_ADD: 'Požadavek se nepodařilo přidat Dualsmart.',
          REQUEST_SUCCESS_BLE_DEVICE_ADD: 'Požadavek na přidání zařízení se nezdařil',
          DUPLICATE_SYSTEM_TITLE: 'Duplicitní systém',
},
        DEVICE_STATUS: {
          ALARM: 'Poplach',
          BLOCKED: 'Blokováno',
          NOT_PROVISIONED: 'Není zajištěno',
          OFFLINE: 'Offline',
          ONLINE: 'Online',
          PROVISIONED: 'Poskytováno',
          READY: 'Připraveno',
          READY_FOR_COMMISSION: 'Připraveno k uvedení do provozu',
          WARNING: 'Varování',
},
        DEVICE_TYPE: {
          ATPLUS_CONTROLLER: 'Ovladač AT+',
          COMMON_GATEWAY: 'Společná brána',
          DGS: 'DGS',
          LPSMART: 'LPSmart',
          WIRELESS_GATEWAY: 'Bezdrátová brána',
},
        SET_PASSWORD_STATUS: {
          INVALID_LENGTH: 'Neplatná délka',
          INVALID_PASSWORD: 'Neplatné heslo',
          PASSWORD_CHANGE_FAILURE: 'Změna hesla se nezdařila',
          PASSWORD_CHANGE_SUCCESS: 'Změna hesla úspěšná',
          PASSWORD_COMPARISON_FAIL: 'Porovnání hesel se nezdařilo',
},
        DEFAULT_LOGIN_STATUS: {
          LOGIN_DEFAULT_SUCCESS: 'Přihlášení výchozí úspěšné',
          LOGIN_FAILURE: 'Selhání přihlášení',
          LOGIN_MAX_ATTEMPTS_EXCEEDED: 'Byl překročen maximální počet pokusů o přihlášení',
          LOGIN_SUCCESS_ADMIN: 'Úspěšné přihlášení admin',
          LOGIN_SUCCESS_SERVICE: 'Úspěšného přihlášení servis',
          LOGIN_SUCCESS_USER: 'Úspěšné přihlášení uživatele',
          LOGOUT: 'Odhlášení',
},
        NULL_VALUE: 'Žádná odezva',
        TURN_ON_BLE_MSG: 'Zapněte Bluetooth, abyste umožnili „Building Safety Manager“ přístup k místním systémům.',
        DISCONNECT_ALERT_SUBTITILE: 'Nejste již připojeni k "{{gatewayName}}" Bluetooth. Chcete-li pokračovat, ujistěte se, že jste v dosahu Bluetooth.,',
        SUCCESS: {
          REQUEST_SUCCESS_GATEWAY_ADD: 'Brána byla úspěšně přidána',
          REQUEST_SUCCESS_WIRELESS_GATEWAY_ADD: 'Bezdrátová brána byla úspěšně přidána',
          REQUEST_SUCCESS_LP_SMART_ADD: 'Dualsmart úspěšně přidán',
          REQUEST_SUCCESS_BLE_DEVICE_ADD: 'Zařízení bylo úspěšně přidáno',
},
        LOST_BLE_CONNECTION: 'Ztratilo se připojení Bluetooth',
},
      INVALID_SYSTEM_NUMBER: 'Neplatné systémové číslo',
      INVALID_USER_ACCESS_SYSTEM_UNLINK: 'Neplatný uživatel. Nemáte přístup k odpojení systému.',
      GATEWAY_DISCONNECT_ALERT: 'Opravdu se chcete odpojit?',
      DISCARD_CHANGES_ALERT: 'Opravdu chcete zahodit změny?',
      UNLINKEXISTING_SYSTEM_ALERT: 'Opravdu chcete odpojit existující systém?',
      GATEWAY_UNREGISTER_ALERT: 'Opravdu chcete zrušit registraci brány?',
      AUTOMATICALLY_CONFIG_IP: 'Automaticky konfigurovat IP adresu',
      BACKUP_CONNECTION: 'Záložní připojení',
      TIMELINE_VIEW: {
        BUILDING: 'Budova',
        OPTINAL: 'Volitelný',
        ORGANIZATION: 'Organizace',
        SELECT_BUILDING: 'Vyberte prosím budovu',
        SELECT_ORGANIZATION: 'Vyberte organizaci',
        SUB_LOCATION: 'Dílčí umístění',
        SET_BACKUP_INTERNET_TITLE: 'Nastavte záložní přístup k internetu',
        SET_PRIMARY_INTERNET_TITLE: 'Nastavte primární přístup k internetu',
        INTERNET_CONNECTION_LABLE: 'Vyberte prosím…',
        SET_INTERNET_CONNECTION_MSG: 'Nejprve se prosím připojte k internetu',
        SUB_LOCATION_LABLE: 'Název dílčího umístění…',
        DESCRIPTION_LABLE: 'Pište poznámky pro svůj tým…',
        SEARCH_ALL_LUMINAIRES_TITLE: 'Hledat všechna svítidla',
},
      BLUETOOTH_SCAN_ERROR: 'Nemůžete najít svou bránu? Kontrola',
      CARRIER_NAME: 'Jméno dopravce',
      CELLULAR: 'Mobilní síť',
      CELLULAR_PROCESS_FAILED_MSG: 'Proces konfigurace mobilní sítě se nezdařil. Zkuste to prosím znovu.',
      CELLULAR_PROCESS_SUCCESS_MSG: 'Mobilní síť byla úspěšně nakonfigurována.',
      CELLULAR_CONNECTION: 'Mobilní připojení',
      NO_BLUETOOTH_SUPPORT: 'Bluetooth není na tomto zařízení podporováno',
      CHANGE_CONNECTION_METHOD: 'Změňte způsob připojení',
      CHECK_FOR_UPDATES: 'Zkontrolujte aktualizace',
      CONFIGURE_WI_FI_CONNECTION: 'Nakonfigurujte nastavení sítě Ethernet',
      CONFIGURE_CELLEULAR_CONNECTION: 'Nakonfigurujte toto mobilní připojení',
      COMMISSION_NEW_GATEWAY: 'Připojte se k Eaton\nnouzovému osvětlení.',
      CONNECT_TO_ELSYSTEM_FAILED_MSG: 'Proces připojení k systému NO se nezdařil. Zkuste to prosím znovu.',
      CONNECTED: 'PŘIPOJENO',
      CONNECTED_TO: 'připojen k',
      CONNECTION_METHOD: 'Způsob připojení',
      GATEWAY_CONNECTION_PRIORITY: 'Priorita připojení',
      CONNECTIONS: 'Spojení',
      GATEWAY_ADD_BUILDING_VALUE: 'Vytvořte novou budovu',
      GATEWAY_ADD_ORGANIZATION_VALUE: 'Vytvořte novou organizaci',
      SET_DATE_TIME_SUCCESS: 'Datum a čas jsou úspěšně nastaveny',
      DEFAULT_PASSWORD_ADMIN_CHANGED: 'DEFAULT_PASSWORD_ADMIN_CHANGED',
      DEFAULT_PASSWORD_USER_CHANGED: 'DEFAULT_PASSWORD_USER_CHANGED',
      DISCONNECTED: 'Zařízení je odpojeno nebo se nelze připojit, zkuste to znovu',
      DISCONNECTED_SUCCESS: 'Zařízení bylo úspěšně odpojeno',
      GATEWAY_UNREGISTER_SUCCESS: 'Údaje o registraci zařízení byly úspěšně smazány',
      GATEWAY_UNREGISTER_FAILURE: 'Údaje o registraci zařízení byly úspěšně smazány',
      DGS_NOT_COMMUNICATING: 'DGS nekomunikuje',
      DGS_UNREACHABLE: 'DGS Nedosažitelné',
      DHCP: 'DHCP',
      DISABLE_WIFI_RATIO_STATUS: 'Zakázání Wi-Fi pro bránu',
      DNS: 'DNS',
      CONNECT_TO_ELSYSTEM_SUCCESS_MSG: 'Systém EL byl úspěšně propojen.',
      ENABLE_LOCATION_FOR_MAP: 'Povolte vyhledání vaší aktuální polohy, povolte ji pro načtení zobrazení mapy',
      ENABLE_WIFI_RATIO_STATUS: 'Povolení Wi-Fi pro bránu',
      WIFI_CREDENTIALS_MESSAGE: 'Zadejte Správné heslo',
      ENTER_WIFI_CREDENTIALS: 'Zadejte přihlašovací údaje Wi-Fi',
      RESET_GATEWAY_PASSWORD: 'Opravdu chcete resetovat heslo brány?',
      INVALID_EPAS_SERIAL_NUMBER: 'Sériové číslo EPAS je neplatné',
      ETHERNET: 'Ethernet',
      ETHERNET_CONFIGURATION: 'Konfigurace Ethernetu',
      ETHERNET_PROCESS_FAILED_MSG: 'Proces konfigurace Ethernetu se nezdařil. Zkuste to prosím znovu.',
      ETHERNET_CONNECTION: 'Připojení Ethernet',
      FAIL_LINK_SYSTEM: 'Nepodařilo se propojit systém z brány',
      FAIL_UNLINK_SYSTEM: 'Nepodařilo se odpojit systém od brány',
      FAIL_UNREGISTER_GATEWAY: 'Nepodařilo se zrušit registraci brány',
      FINISH: 'Dokončit',
      CHANGE_PASSWORD_INFO: 'Z bezpečnostních důvodů změňte výchozí heslo.',
      GATEWAY_ACTIVATED: 'Úspěch',
      GATEWAY_ADDED: 'Brána přidána',
      GATEWAY_COMMISSIONING: 'Uvedení brány do provozu',
      GATEWAY_CONNECTED: 'Brána připojena',
      GATEWAY_DETAILS: 'Podrobnosti brány',
      GATEWAY_NAME: 'Název brány *',
      GATEWAY_PASSWORD: 'Heslo brány',
      GATEWAY_PASSWORD_INCORRECT: 'Nesprávné heslo brány',
      GATEWAY_NAME_DESCRIPTION: 'Dejte této bráně lepší jméno\na popis',
      SUCCESSFULLY_ADDED: 'byl úspěšně přidán.',
      INCOMPLETE_SETUP: 'Neúplné nastavení',
      INTERNET_SETTINGS: 'Nastavení internetu',
      INVALID_GUID: 'Neplatné ID zařízení, zadejte prosím platný GUID',
      FACTORY_RESET: 'Obnovení továrního nastavení',
      FACTORY_RESET_SUCCESS: 'Příkaz k obnovení továrního nastavení byl úspěšně proveden',
      FACTORY_RESET_FAILURE: 'Příkaz k obnovení továrního nastavení se nezdařil. Zkuste to prosím znovu',
      GATEWAY_FACTORY_RESET_ALERT: 'Opravdu chcete provést obnovení továrního nastavení pro bránu?',
      LAST_CONNECTED: 'Naposledy připojeno: 12:34:56 12. května 2024',
      CELLULAR_CONNECTION_TYPE_LTE: 'LTE',
      CELLULAR_CONNECTION_TYPE_NON_LTE: 'NON-LTE',
      INVALID_LATITUDE: 'Neplatná zeměpisná šířka. Zadejte prosím platnou zeměpisnou šířku',
      INVALID_LONGITUDE: 'Neplatná zeměpisná délka. Uveďte prosím platnou zeměpisnou délku',
      INVALID_USER: 'Neplatný uživatel',
      SUBLOCATION_NAME_LENGTH: 'Pouze písmena, pomlčky, číslice',
      LINK_NEW_DEVICE: 'Připojte nové zařízení',
      LINK_NEW_SYSTEM: 'Propojit nový systém',
      LINK_SYSTEM: 'PROPOJTE SYSTÉM',
      LINK_ANOTHER_SYSTEM: 'Propojit jiný systém',
      LINK_MORE_SYSTEM: 'Propojit více systémů',
      LINK_SYSTEM_MSG: 'Probíhá propojení systému s \'{{gatewayName}}\'',
      LINK_SYSTEMS: 'Link Systems',
      LOCATION: 'Umístění',
      DENIED_LOCATION_PERMISSION: 'Oprávnění k poloze odepřeno, povolte jej, chcete-li získat kontrolu Bluetooth pro zařízení v okolí',
      DENIED_LOCATION_PERMISSION_FOR_MAP: 'Oprávnění k poloze odepřeno, povolte mu načítání zobrazení mapy',
      CONNECTION_TYPE_VALUE: 'LTE/WCDMA/GSM',
      MANAGE_ETHERNET_CONNECTION: 'Správa ethernetového připojení',
      MANAGE_WIFI_CONNECTION: 'Správa připojení Wifi',
      MANUALLY_CONFIG_IP: 'Ručně zadejte IP adresu',
      SET_NAME_DESCRIPTION_SUCCESS: 'Název a popis úspěšně nastaven',
      NO_DEVICE_FOUND: 'Nebyla nalezena žádná zařízení',
      UNLINK_SYSTEM_ERROR: 'Žádná brána pro zrušení registrace',
      NO_GATEWAY_NAME_FOUND: 'Nebylo nalezeno žádné jméno',
      NO_SYSTEM_YET: 'Zatím žádné systémy',
      WIFI_NETWORK_NOT_AVAILABLE: 'Není k dispozici žádná wifi síť',
      DHCP_OFF: 'Vypnuto',
      DHCP_ON: 'Na',
      NO_SYSTEM_YET_DESCRIPTION: 'Jakmile připojíte své systémy k této bráně, zobrazí se zde seznam systémů. Přeformuluj mě.',
      ONLINE_TEXT: 'online.',
      ORGANIZATION_TREE: 'Organizační strom',
      OTHER_NETWORK: 'Jiná síť..',
      BLUETOOTH_INSTRUCTIONS: 'naše pokyny',
      CHOOSE_GATEWAY_CONNECTION_METHOD: 'Vyberte způsob připojení brány',
      CONFIRM_SELECTION: 'Prosím potvrďte výběr',
      ENTER_ADMIN_CHANGE_PASSWORD: 'Zadejte heslo změněné správcem',
      ENTRY_GATEWAY_CHANGED_PASSORD: 'Zadejte změněné heslo brány pro',
      ENTRY_GATEWAY_DEFAULT_PASSORD: 'Zadejte výchozí heslo brány pro',
      ENTRY_PASSWORD: 'Zadejte heslo brány pro',
      PLEASE_ENTER_NEW_PASSWORD_AGAIN_RECONNECT: 'Zadejte prosím nové heslo znovu do\nznovu se připojte k bráně.',
      MOVE_CAMERA_OVER_QR_CODE: 'Přesuňte fotoaparát\n přes QR kód',
      INVALID_BUILDING_ID: 'Uveďte prosím platné ID budovy',
      INVALID_DEVICE_ID: 'Uveďte prosím platné ID zařízení',
      INVALID_DEVICE_NAME: 'Zadejte prosím platný název zařízení',
      INVALID_DEVICE_STATUS: 'Uveďte prosím platný stav zařízení',
      INVALID_DEVICE_TYPE: 'Uveďte prosím platný typ zařízení',
      INVALID_PROJECT_ID: 'Uveďte prosím platné ID projektu',
      INVALID_SYSTEM_ID: 'Uveďte prosím platné ID systému',
      PLEASE_WAIT: 'Čekejte prosím',
      PRIMARY_CONNECTION: 'Primární připojení',
      GATEWAY_PRIORITY: 'Přednost',
      PROXY: 'Proxy (volitelné)',
      PULL_REFRESH_TEXT: 'Zatažením dolů obnovte',
      QUATERNARY_CONNECTION: 'Kvartérní spojení',
      REMOVE_CONNECTION: 'Odebrat připojení',
      REMOVE_PRIMARY_CONNECTION: 'Odebrat primární připojení',
      REQUIRE_GATEWAY_CONNECTED_TO_INTERNET: 'Vyžaduje bránu připojenou k internetu',
      SAVE_TO_CLOUD: 'Uložit do cloudu',
      SAVE_WI_FI_CREDENTIALS: 'Uložte si přihlašovací údaje k Wi-Fi pro další\nzařízení',
      SCAN_QR_CODE: 'Naskenujte QR kód',
      QR_CODE_SCAN: 'Naskenujte QR kód',
      SCANNING_FOR_NEAR_BY_BLE: 'Vyhledávání blízkých Ble zařízení...',
      SCANNING_FOR_NEAR_BY_WIFI: 'Vyhledávání WIFI v okolí...',
      SEARCH_ALL_LUMINARIES: 'Prohledat všechna svítidla',
      SEARCH_VIA_BLUETOOTH: 'Vyhledávání přes Bluetooth',
      SEARCHING_FOR_NEARBY_WIFI: 'Vyhledávání Wi-Fi v okolí...',
      SEARCH_VIA_BLUETOOTH_EllIPSE: 'Vyhledávání přes Bluetooth...',
      SECONDARY_CONNECTION: 'Sekundární připojení',
      SELECT_PRIMARY_CONNECTION: 'Vyberte primární způsob připojení',
      SERIAL_NUMBER_NULL_OR_EMPTY: 'Sériové číslo nesmí být prázdné ani prázdné',
      SET_DATE_TIME_CONFIG: 'Nastavit datum a čas Nesprávná konfigurace',
      SET_DATE_TIME_FAILURE: 'Nastavení data a času selhalo při konfiguraci',
      SET_NAME_DESCRIPTION_INCORRECT_CONFIG: 'Název a popis nastavení Nesprávná konfigurace',
      SET_NAME_DESCRIPTION_FAILURE: 'Set Name & Description je chyba konfigurace',
      SET_EL_SYSTEM_PORT: 'Nastavte EL System Port',
      SET_GATEWAY_PORT: 'Nastavte port brány',
      STATIC: 'Statický',
      STATUS: 'Postavení',
      STEP_THREE_OF_THREE: 'Krok 3 ze 3',
      SYNC_DATE_TIME: 'Synchronizace data a času',
      SYSTEM_UNLINK_SUCCESS: 'Systém byl úspěšně odpojen',
      SYSTEM_UNLINKED: 'Systém odpojen',
      SYSTEMS: 'Systémy',
      UNLINK_SYSTEM_SUCCESS: 'Systémy byly úspěšně odhlášeny.',
      TERTIARY_CONNECTION: 'Terciární připojení',
      GATEWAY_NOT_EXISTS: 'Brána neexistuje',
      ADDING_GATEWAY_SUBTITITLE: 'Tento proces může trvat až 2 minuty.',
      UNLINK_ANOTHER_SYSTEM: 'Odpojit jiný systém',
      UNLINK_EXISTING_SYSTEM: 'Odpojit stávající systém',
      UNLINK_EXIST_SYSTEM: 'Zrušte registraci brány',
      USE_WI_FI_PASSWORD: 'Použijte heslo Wi-Fi',
      USE_WPA2_KEY: 'Použijte klíč WPA2',
      SCANNING_FAILED_TRY_AGAIN: 'Ověřování zařízení...',
      CARRIER_NAME_VALUE: 'Vodafone NL 3G',
      WI_FI: 'Wi-Fi',
      WIFI_PROCESS_FAILED_MSG: 'Proces konfigurace Wifi se nezdařil. Zkuste to prosím znovu.',
      GATEWAY_WIFI_CONFIG: 'Konfigurace Wifi',
      WI_FI_NETWORK: 'Wi-Fi síť',
      WI_FI_NETWORK_NAME: 'Název sítě Wi-Fi',
      WI_FI_PASSWORD: 'Heslo Wi-Fi',
      GATEWY_INTERNET_SETTING_OPTIONAL_FIELD_MSG: 'Kterýkoli z těchto kroků můžete přeskočit, ale bude nutné je dokončit později, aby bylo možné dokončit nastavení.',
      VERIFYING_DEVICE: 'Ověřování zařízení...',
      GATEWAY_OF: 'Brána',
      SYSTEM_LOCATION: 'Umístění systému',
      LOCATION_PERMISSION_TITLE: 'Povolení k umístění',
      LOCATION_REQUIRED_MESSAGE: 'Tato aplikace potřebuje přístup k vaší poloze',
      PERMISSION_DENIED_TITLE: 'Povolení odepřeno',
      PERMISSION_DENIED_MULTIPLE_MSG: 'Několikrát jste odepřeli oprávnění k umístění. Bez něj nemusí aplikace správně fungovat.',
      MAINTAINED_MODE: 'Udržovaný režim',
      NON_MAINTAINED_MODE: 'Neudržovaný režim',
      UNREGISTER_GATEWAY: 'Zrušte registraci brány',
      CHOOSE_CONNECTION_TYPE: 'Jaký typ připojení použijete pro \n systém DGS?',
      REACHED_MAXIMUM_SUPPORTED_SYSTEM_ERROR_MSG: 'Nelze přidat další systémy. Bylo dosaženo limitu pro maximální počet podporovaných systémů na bráně',
      DUALSMART_NAME: 'Jméno Dualsmart *',
      WIRELESS_GATEWAY_NAME: 'Název bezdrátové brány *',
      DUPLICATE_SYSTEM_ERROR_MSG: 'Systém s touto IP adresou je již propojen s bránou.',
      DIRECT_CONNECT_OPTION_SELECT_MSG: 'Ujistěte se, že IP Address of the System je nastavena na IP Address a DHCP je zakázáno',
      DESCRIPTION: 'Popis',
},
    ERROR_MESSAGES: {
      GENERIC_ERROR_CONTACT_DETAILS: 'nebo volejte na',
      GENERIC_ERROR: 'Došlo k nespecifikované chybě. Pokud tento problém přetrvává, kontaktujte prosím podporu Eaton na adrese',
      9003: 'Požadovanou operaci nelze provést, kontaktujte prosím svého správce',
      2002: 'Odkaz na registraci uživatele vypršel nebo je již uplatněn.',
      2018: 'Nemůžeme dokončit vaši registraci. Vaše organizace překročila počet přidělených uživatelů pro vaše předplatné. Pokud vaše organizace vyžaduje další uživatele, kontaktujte podporu CST prostřednictvím e-mailu na adrese',
},
    FORGOT_PASSWORD: {
      INSTRUCTIONS: '" \'Zadejte e-mail účtu přidružený k účtu. <br/><br/>\' +\n„Pokud má tento e-mail účet se systémem řízení bezpečnosti, obdržíte odpověď do <3>jednoho pracovního dne</3>.<br/><br/>“ +\n"V případě naléhavých problémů s účtem zavolejte prosím"',
      ERROR: 'V tuto chvíli nelze obnovit heslo.',
      RESET_CODE_ERROR: 'U vašeho resetovacího kódu došlo k chybě.',
},
    ACCOUNT_SETTING: {
      UPDATES_AVAILABLE: ' AKTUALIZACE K DISPOZICI',
      ACCOUNT_CREATED: 'Účet vytvořen',
      ACCOUNT_PREFERENCES: 'Předvolby účtu',
      ADDRESS_LINE2: '2. řádek adresy (volitelné)',
      ALARAM: 'Alarmy',
      ALL_BUILDINGS: 'Všechny budovy',
      ALL_SYSTEM_FIRMWARE: 'Veškerý systémový firmware',
      ALL_SYSTEMS: 'Všechny systémy',
      APPLICATION_THEME_COLOR: 'Barva motivu aplikace',
      AUTOMATIC_LOG_OUT: 'Automatické odhlášení',
      AUTOMATIC_UPDATES: 'Automatické aktualizace',
      AUTOMATIC_UPDATES_INFO: 'Automaticky stáhněte nejnovější verzi firmwaru do vašeho zařízení.',
      CHANGE_PASSWORD: 'Změnit heslo',
      STORAGE_FIRMWAREFILE_INFO: 'Vyberte způsob ukládání souborů firmwaru do zařízení',
      CITY: 'Město',
      COMPANY_ADDRESS: 'Adresa společnosti',
      COMP_ADDRESS: 'Adresa společnosti*',
      COMPANY_DETAILS: 'Podrobnosti o společnosti',
      COMPANY_NAME: 'Název společnosti',
      COMP_NAME: 'Název společnosti',
      COMPANY_PHONE_NUMBER: 'Telefonní číslo společnosti',
      CODE: 'Kód',
      DATE_FORMAT: 'Formát data',
      DELETE_ACCOUNT: 'Smazat účet',
      DELETE_CUSTOMER: 'Smazat zákazníka',
      DEVICE_BLOCKING: 'Zařízení je v blokovacím režimu, nouzovém režimu, je vyžadována údržba',
      EDIT_CUSTOMER_INFO: 'Upravit informace o zákazníkovi',
      EMAIL: 'E-mail',
      EMAIL_ADDRESS: 'E-mailová adresa',
      REQUIRED_FIELD: 'Pole s hvězdičkou (*) jsou vyžadována pro pokračování.',
      FIRMWARE_FILE: 'Soubory firmwaru',
      FIRMWARE_UPDATES: 'Aktualizace firmwaru',
      FIRST_NAME: 'Křestní jméno',
      FT_DT_FAIL: 'FT selhalo, DT selhalo, odpojeno, porucha baterie, porucha lampy, porucha ATSD',
      HEALTH_REPORT: 'Zpráva o zdraví',
      LANGUAGE: 'Jazyk',
      LAST_NAME: 'Příjmení',
      MONTHLY_REPORTING: 'Měsíční výkazy',
      NEW_RELEASE_FIRMWARE_UPDATE: 'Nové verze, k dispozici aktualizace firmwaru',
      NOTIFICATIONS: 'Oznámení',
      ORGAN_UPDATED_SUCCESSFULLY: 'Organizace byla úspěšně aktualizována',
      PASSWORD: 'Heslo',
      PERSONAL_DETAILS: 'Osobní údaje',
      PHONE_NUMBER: 'Telefonní číslo',
      VALID_FIRSTNAME_ERROR: 'Zadejte křestní jméno',
      POSTAL_CODE: 'PSČ',
      PREFERENCES: 'Předvolby',
      PRIMARY_CONTACT: 'Primární kontakt',
      PRIMARY_CONTACT_EMAIL_ADDRESS: 'E-mailová adresa primárního kontaktu',
      PRIMARY_CONTACT_PHONE_NUMBER: 'Telefonní číslo primárního kontaktu',
      PRIMARY_EMAIL_ADDRESS: 'Primární e-mailová adresa',
      PRIMARY_PHONE_NUMBER: 'Primární telefonní číslo',
      PRODUCT_UPDATE: 'Aktualizace produktu',
      SAVE_CHANGES: 'Uložit změny',
      SECONDARY_CONTACT: 'Sekundární kontakt',
      SECONDARY_CONTACT_EMAIL_ADDRESS: 'Sekundární kontaktní e-mailová adresa',
      SECONDARY_CONTACT_PHONE_NUMBER: 'Sekundární kontaktní telefonní číslo',
      SECONDARY_EMAIL_ADDRESS: 'Sekundární e-mailová adresa',
      SECONDARY_PHONE_NUMBER: 'Sekundární telefonní číslo',
      SLA_DETAILS: 'Podrobnosti SLA',
      STATUS_UPDATE: 'Aktualizace stavu',
      STORAGE: 'Skladování',
      TIME_ZONE: 'Časové pásmo',
      UNITS: 'Jednotky',
      USER_NAME: 'Uživatelské jméno',
      USER_UPDATED_SUCCESSFULLY: 'Uživatel byl úspěšně aktualizován',
      VERSION: 'Verze',
      EST: 'EST',
      DD_MM_YYYY: 'DD',
      OFFLINE_MODE_ENABLED: 'Povoleno',
      OPERATING_SYSTEM_THEME: 'Téma operačního systému',
},
    CHANGE_PASSWORD: {
      EMAIL_CONFIRM_MESSAGE: ' Poslali jsme potvrzovací e-mail na adresu {{email}}',
      PROBLEM_OCCURRED: 'Vyskytl se problém:',
      PASSWORD: 'Změnit heslo',
      OLD_PASSWORD: 'Staré heslo',
      PASSWORD_CHANGED: 'Heslo změněno',
      PASSWORD_INFO: 'Heslo musí být dlouhé alespoň 8 znaků, obsahovat alespoň jedno velké písmeno, jedno malé písmeno, jedno číslo a jeden speciální znak.',
      ERROR_MESSAGR: 'Vaše informace neodpovídaly našim záznamům. Chcete-li to zkusit znovu, zadejte své údaje znovu.',
      SUCCESS_MESSAGE: 'Vaše heslo bylo úspěšně aktualizováno! Pro zajištění bezpečnosti vašeho účtu se budete muset přihlásit do aplikace pomocí vašich aktualizovaných přihlašovacích údajů.',
},
    SYSTEM_DETAIL: {
      GUIDE: '(Průvodce)',
      USERS_DATA: '5 adminů, 1 uživatel',
      ACTIVATE_CONNECTIONS: 'Aktivujte připojení v cloudu',
      ADD_ANOTHER_CELLULAR: 'Přidat záložní mobilní připojení',
      ADD_SLA: 'Přidat SLA',
       SYSTEM_DETAILS_TITLE: 'Podrobnosti o systému',
      ALL_CONTACTS: 'Všechny kontakty',
      ALL_PEOPLE_IN_THIS_BUILDING: 'Všichni lidé v této budově',
      ALL_SYSTEMS_IN_THIS_BUILDING: 'Všechny systémy v této budově',
      BOTH_PORTS_CANNOT_BE_ON_SAME_SUBNET: 'Oba porty nemohou být ve stejné podsíti',
      BUILDING: 'Budova',
      BUILDING_INFO: 'Informace o budově',
      BUILDING_TYPE: 'Typ budovy',
      BUYER: 'Kupující',
      CONNECTION_TYPE: 'Typ připojení',
      CONTACT_PERSON_Onsite: 'Kontaktní osoba na místě',
      CONTACT_TYPE: 'Typ kontaktu',
      CUSTOMER_DETAILS: 'Podrobnosti o zákazníkovi',
      CUSTOMER_INFO: 'Informace o zákazníkovi',
      CUSTOMER_NUMBER: 'Zákaznické číslo',
      DATE_COMMISSIONED: 'Datum uvedení do provozu',
      DISABLE: 'Zakázat',
      DURATION_TEST: 'Test provozu z baterie',
      DURATION_TEST_FAILED: 'Chyba testu provozu z baterie',
      DURATION_TEST_PASSED: 'Test provozu z baterie úspěšný',
      ENABLED: 'Povoleno',
      ENTER_VALID_GATEWAY_ADDRESS: 'Zadejte platnou adresu brány',
      ENTER_VALID_IP_ADDRESS: 'Zadejte platnou adresu IP',
      ENTER_VALID_SUBNET_MASK: 'Zadejte platnou masku podsítě',
      ETHERNET_PORT_ONE: 'Ethernetový port A',
      ETHERNET_PORT_TWO: 'Ethernetový port B',
      EXPIRY_DATE: 'Datum vypršení platnosti',
      FIRMWARE_VERSION: 'Verze firmwaru',
      FOR_BUILDINGS: 'Pro budovy',
      FOR_SYSTEMS: 'Pro systémy',
      FUNCTIONAL_TEST: 'Funkční test',
      FUNCTIONAL_TEST_FAILED: 'Funkční test se nezdařil',
      FUNCTIONAL_TEST_PASSED: 'Funkční test prošel',
      GATEWAY: 'Brána',
      GATEWAY_ADDRESS: 'Adresa brány',
      GATEWAY_ADDRESS_REQUIRED: 'Adresa brány*',
      GATEWAY_NAME: 'Název brány',
      SYSTEM_UNLINKED_GATEWAY: 'byl\nodpojeno od ',
      SYSTEM_LINKED_GATEWAY: 'byl propojen\ndo ',
      HOST_NAME: 'Název hostitele',
      INTIALIZE_CONNECTION: 'Inicializujte připojení',
      INTIALIZE_NETWORK: 'Inicializace sítě...',
      IP_ADDRESS: 'IP adresa',
      IP_ADDRESS_REQUIRED: 'IP adresa*',
      IP_GATEWAY_NOT_IN_SAME_SUBNET: 'IP a brána nemají stejnou masku podsítě',
      ETHERNET_CONNECTED: 'je teď\npřipojen k internetu',
      SYSTEM_LINKING_TITLE: 'Tohle je váš systém?\npropojení?',
      SYSTEM_UNLINKING_TITLE: 'Tohle je váš systém?\nodpojit?',
      SYSTEM_LINK_TITLE: 'Propojit systém s',
      LUMINAIRES: 'Svítidla',
      LUMINARIES_LIST: 'Seznam svítidel',
      MAC_ADDRESS: 'Mac adresa',
      MAIN_CONTACT: 'Hlavní kontakt',
      NETWORK_INFORMATION: 'Informace o síti',
      NO_SYSTEM_FOUND: 'Není k dispozici žádný systém',
      OFFICE: 'Kancelář',
      ORGANIZATION: 'Organizace',
      OTHER_STEPS: 'V případě potřeby další kroky',
      OTHER_SYSTEMS: 'Jiné systémy',
      PART_NUMBER: 'Číslo dílu',
      SETPORT_SYSTEM_DETAILS_DESCRIPTION: 'Dokončete konfiguraci Ethernetu\npodrobnosti.',
      SYSTEM_DETAILS_DESCRIPTION: 'Najděte prosím tyto podrobnosti na obrazovce HMI\nvaši systémovou skříň.',
      PORT_NUMBER: 'Číslo portu',
      PREV: 'Předchozí',
      PROJECT_LEAD: 'Vedoucí projektu',
      REGISTER_ACTIVATE_GATEWAY: 'Zaregistrujte se a aktivujte bránu',
      SERIALNO_VALUE: 'S3ri4l-Num63r',
      SERIAL_NUMBER: 'sériové číslo',
      SETPORT_SYSTEM_LINK_TITLE: 'Nastavte port pro připojení systému',
      SLA_NUMBER_TITLE: 'SLA #',
      SLAVE_NUMBER: 'Číslo otroka',
      SUBNET_MASK: 'Maska podsítě',
      SUBNET_MASK_REQUIRED: 'Maska podsítě',
      SYN_DATE_TIME: 'Synchronizujte datum a čas',
      SYSTEM: 'Systém',
      SYSTEM_NAME: 'Název systému',
      SYSTEM_TYPE: 'Typ systému',
      TECHNICAL_PERSON: 'Technická osoba',
      STATUS_DESCRIPTION: 'Toto je dlouhý popis. Může popisovat umístění zařízení a s kým mluvit.',
      TOTAL_SLA: 'Celková SLA',
      TRANSFER_ORGANIZATION: 'Převést tuto organizaci a její majetek \n na jiného uživatele (volitelné)',
      SYSTEM_UNLINK_TITLE: 'Odpojit systém od',
      UPDATE_REQUIRED: 'nutná aktualizace',
      UPLOAD_DETAILS: 'Nahrajte podrobnosti přes bluetooth',
      FIRMWARE_VERSION_VALUE: 'v12.34-56',
      VERSION_AVAILABLE: 'v123.457 K dispozici',
      VIEW_ALL: 'Zobrazit vše',
      VIEW_ALL_LUMINARIES: 'Zobrazit všechna svítidla',
      PARTNO_VALUE: 'xx xx xx xx',
      ETHERNET_SUBTITLE: 'Nyní můžete přistupovat ke své bráně přes web. Přeformuluj mě.',
      NO_CUSTOMER_TEXT: 'Tento systém nebyl propojen se zákazníkem',
      LINK_TO_CUSTOMER_BUTTON: 'Odkaz na zákazníka',
},
    USER_INVITATION_MANAGEMENT: {
      YOU: '(Vy)',
      INVITATION_MESSAGE_UPDATE_COUNT: '{{updatedInvitationCount}} pozvánky byly {{inviteStatus}} úspěšně, {{rejectedInvitationCount}} ipozvánky nebyly {{inviteStatus}}.',
      SUCCESS_COUNT: '{{updatedInvitationCount}} pozvánky byly {{inviteStatus}} úspěšně.',
      INVITE_ACCEPT: 'Přijmout',
      INVITE_ACCEPT_INVITATION: 'Přijměte pozvání',
      INVITE_ACCEPTED: 'přijato',
      INVITE_ACCEPTED_BUTTON: 'Přijato',
      INVITE_ACCEPT_INVITATION_DESCRIPTION_1: 'Přijetím této pozvánky se do vašeho profilu přidá následující položka:',
      ADMIN_APPROVE: 'Schválit žádost',
      COMPANY: 'Společnost',
      DECLINE_INVITATION: 'Odmítnout pozvánku',
      TABLE_HEADER_DENIED_TITLE: 'Zamítnuto mnou ({{count}})',
      INVITE_DENIED: 'Duplikát',
      INVITE_DENY: 'Denny',
      ADMIN_DECLINE_INVITATION: 'Zamítnout požadavek',
      TABLE_HEADER_EXPIRED_AT: 'Vypršení platnosti',
      TABLE_HEADER_EXPIRED_TITLE: 'Pozvánky, jejichž platnost vypršela ({{count}})',
      INVITE_HISTORY: 'Historie pozvánek',
      INVITATION_SUCCESS_MESSAGE: 'Pozvánka byla úspěšně {{inviteStatus}}.',
      JOIN: 'Připojte se',
      JOINALL: 'Připojit se ke všem',
      LEAVE_ORGANIZATION: 'Opustit organizaci',
      TABLE_HEADER_NAME: 'Jméno',
      INVITE_PENDING: 'Čeká na vyřízení',
      INVITE_REQUEST_ACCESS_DESCRIPTION_2: 'Chcete-li přidat tuto položku do svého profilu, požádejte o přístup od správce',
      TABLE_HEADER_INVITE_DATE: 'Přijato',
      REMOVE_USER: 'Odebrat uživatele',
      INVITE_REQUEST: 'Žádost',
      INVITE_REQUEST_ACCESS: 'Žádost o přístup',
      REQUESTEDBY: 'Vyžádáno uživatelem',
      INSTRUCTIONS: 'Vyberte, zda chcete přidat položky do svého profilu, nebo odmítnout pozvání k jejich přidání do profilu.',
      ADMIN_INSTRUCTIONS: 'Vyberte, zda chcete schválit nebo zamítnout jejich žádost o přístup:',
      SENTBY: 'Odeslal',
      TABLE_HEADER_INVITE_BY: 'Odeslal',
      TABLE_HEADER_TOTAL_ACCEPTED_NO_DATA_FOUND: 'Momentálně nejsou žádné přijaté pozvánky.',
      TABLE_HEADER_DENIED_NO_DATA_FOUND: 'V tuto chvíli nejsou žádné odmítnuté pozvánky.',
      TABLE_HEADER_EXPIRED_NO_DATA_FOUND: 'V tuto chvíli nejsou žádné pozvánky, jejichž platnost vypršela.',
      INVITATION_TEXT: 'K opětovnému připojení budou potřebovat pozvánku.',
      INVITE_REQUEST_ACCESS_DESCRIPTION_1: 'Platnost této pozvánky vypršela a již ji nelze přidat do vašeho profilu.',
      TABLE_HEADER_TOTAL_COUNT: 'Celkový počet přijatých pozvánek ({{count}})',
      TABLE_HEADER_TOTAL_ACCEPTED_COUNT: 'Celkový počet přijatých pozvánek ({{count}})',
      SUCCESS_MESSAGE: 'Úspěšné pozvání uživatele {{count}}',
      ERROR_MESSAGE: 'Požadavek uživatele na aktualizaci pozvánky se nezdařil',
      VIEW_ALL_ACCESS_RIGHTS: 'Zobrazit všechna přístupová práva',
      TITLE: 'Vítejte, {{username}}',
      SUBTITLE: 'Byli jste pozváni do následujících projektů:',
      ADMIN_SUBTITLE: 'Máte žádosti o přístup k pozvánkám, jejichž platnost vypršela:',
},
    DASHBOARD: {
      LOCATION_CARD: {
        HEADER: {
          INFO: {
            SEPARATOR : ',',
            DEVICE: '{{count}} Jednotka',
            DEVICE_plural: '{{count}} Jednotky',
            SITE: '{{count}} Síť',
            SITE_plural                    : '{{count}} Sítě',
            DEVICE_noData: '0 Zařízení',
            SITE_noData  : '0 sítí',
},
          SUBTITLE: {
            ALARM: '{{count}} Alarm',
            ALARM_plural: '{{count}} Alarmy',
            ALARM_noData: '0 Alarmy',
            NORMAL: 'Normální',
},
},
        BODY: {
          ALARMS: '{{count}} Alarm',
          ALARMS_plural: '{{count}} Alarmy',
          EVENTS: '{{count}} Událost',
          EVENTS_plural: '{{count}} Události',
          ALARMS_noData: '0 Alarmy',
          EVENTS_noData: '0 událostí',
},
        FOOTER: {
          VIEW_LOCATION: 'Zobrazit umístění',
},
},
      SITE_CARD: {
        BODY: {
          ALARMS: '{{count}} Alarm',
          ALARMS_plural: '{{count}} Alarmy',
          EVENTS: '{{count}} Událost',
          EVENTS_plural: '{{count}} Události',
          ALARMS_noData: '0 Alarmy',
          EVENTS_noData: '0 událostí',
          OFFLINE: 'Offline',
          ONLINE: 'Online',
},
        HEADER: {
          INFO: {
            DEVICE: '{{count}} Jednotka',
            DEVICE_plural: '{{count}} Jednotky',
            DEVICE_noData: '0 Zařízení',
},
},
        FOOTER: {
          VIEW_LOCATION: 'Zobrazit web',
},
},
      TIMELINE_DETAILS: {
        ACKNOWLEDGED: 'POTVRZENO',
        OPEN: 'AKTIVNÍ',
        CLOSED: 'ZAMČENO',
        EARLIER: 'Dříve',
        FUTURE: 'Budoucnost',
        INACTIVE: 'NEAKTIVNÍ',
        LAST_WEEK: 'Minulý týden',
        THIS_WEEK: 'Tento týden',
        TIMELINE: 'Časová osa',
        TODAY: 'Dnes',
        UNACKNOWLEDGED: 'NEPŘÍZNĚNO',
        YESTERDAY: 'Včera',
},
      ADD_BUILDING: 'Přidat budovu do',
      AUTO_REDIRECT_BANNER: {
        ADD_LOCATION_BUTTON: 'Přidat umístění',
        DISMISS: 'Propustit',
        MESSAGE: 'Byli jste automaticky přesměrováni do {{location}}, protože nemáte žádná další místa nejvyšší úrovně.',
},
      USERS_ADMIN: 'Admin',
      USERS_ADMIN_S: 'Správci',
      ADMINS_TITLE: 'Správci',
      SITE_DETAILS: {
        READING_CARDS: {
          ALARM: 'Poplach',
          BATTERY: 'Baterie',
          FULL: 'Plný',
          OFFLINE: 'Offline',
          ONLINE: 'Online',
          PENDING: 'Čeká na vyřízení',
          UNKNOWN: 'Neznámý',
          VIEW_ALL: 'Zobrazit vše',
},
        ALL_DETAILS: 'Všechny podrobnosti',
        ALL_DEVICES: 'Všechna zařízení',
        TRENDS_CARD: {
          CHANNELS: 'Kanály',
          DAY: 'Den',
          DAYS: 'Dny',
          TITLE: 'Trendy',
          TRENDVIEWER: 'Prohlížeč trendů',
          VIEW_ALL: 'Zobrazit celý Trendviewer',
},
        DEVICES_CARD: {
          TITLE: 'Zařízení',
          VIEW_ALL: 'Zobrazit všechna zařízení',
},
        TIMELINE_CARD: {
          TITLE: 'Časová osa',
          VIEW_ALL_EVENTS: 'Zobrazit všechny události',
},
},
      ALL_BUILDINGS_COUNT: 'Všechny budovy ({{count}})',
      ALL_LOCATIONS: 'Všechny lokality',
      ALL_ORGANIZATION: 'Všechny organizace',
      ALL_DEVICES_COUNT: 'Všechny systémy ({{count}})',
      ADMINS_AND: 'a',
      DASHBOARD_ASSETS_TITLE: 'Aktiva',
      STATUS_BLOCKED: 'Blokováno',
      STATUS_COUNT_BLOCKED: 'Blokováno ({{count}})',
      BUILDING_CONTACT: 'Kontakt na budovu',
      BUILDING_CONTACT_DETAILS_LABEL: 'Kontaktní údaje budovy',
      CHOOSE_LOCATION: 'Vyberte umístění',
      CONTACT_MANAGER: 'Kontaktujte svého account managera popř',
      ADD_ORGANIZATION: 'Vytvořit organizaci',
      OVERVIEW_TITLE: 'Dashboard',
      DASHBOARD_TITLE: 'Dashboard',
      DEVICES_TITLE: 'Zařízení',
      EARLIER: 'Dříve',
      EDIT_CONTACT_BUTTON: 'Upravit kontaktní údaje',
      BUILDING_DETAIL_EMAIL: 'E-mail',
      STATUS_EMPTY: 'Prázdný',
      STATUS_COUNT_EMPTY: 'Prázdné ({{count}})',
      ERROR_LOADING_CHANNELS: 'Chyba při načítání kanálů',
      ERROR_LOADING_DATA: 'Chyba při načítání dat',
      ERROR_LOADING_DEVICES: 'Chyba při načítání zařízení',
      ERROR_LOADING_EVENT: 'Chyba při načítání události',
      ERROR_LOADING_EVENTS: 'Chyba při načítání událostí',
      ERROR_LOADING_LOCATION: 'Chyba při načítání umístění',
      ERROR_LOADING_LOCATIONS: 'Chyba při načítání umístění',
      ERROR_LOADING_ORGANIZATION: 'Chyba při načítání organizace',
      ERROR_LOADING_SITE: 'Chyba při načítání webu',
      ERROR_LOADING_SITES: 'Chyba při načítání stránek',
      ERROR_LOADING_TRENDS: 'Chyba při načítání trendů',
      EVENT_NOT_FOUND: 'Událost nenalezena',
      STATUS_ANOMALY: 'V anomálii',
      STATUS_COUNT_ANOMALY: 'V anomálii ({{count}})',
      LAST_90_DAYS: 'Posledních 90 dní',
      LATEST_LOGS: 'Nejnovější protokoly',
      LOCATION_NOT_FOUND: 'Místo nenalezeno',
      LOCATIONS_TITLE: 'Místa',
      LOCATION: 'umístění',
      DASHBOARD_LOGBOOK_TITLE: 'Deník',
      MAIN_CONTACT_LABEL: 'Kontakt na hlavní budovu',
      ADMINS_MORE: 'více',
      DASHBOARD_MANAGE_ORGANIZATION_TITLE: 'Moje organizace',
      NO_FOUND: 'Nebyla nalezena žádná {{entity}}',
      NO_EVENTS: 'Žádné alarmy',
      NO_CHANNELS: 'Žádné kanály',
      NO_CHANNELS_ENABLED: 'Nejsou povoleny žádné kanály',
      NO_DATA: 'Žádná data',
      NO_DATA_POINTS: 'Nebyla zadána žádná data pro časové období',
      NO_DEVICES: 'Žádná zařízení',
      NO_LOCATION_SELECTED: 'Není vybráno žádné místo',
      NO_LOCATIONS: 'Žádná místa',
      NO_ORGANIZATION_SELECTED: 'Není vybrána žádná organizace',
      NO_SITES: 'Žádné stránky',
      NO_TRENDS: 'Žádné trendy',
      NO_USER_DATA: 'Žádná uživatelská data',
      STATUS_COUNT_OFFLINE: 'OFFLINE ({{count}})',
      ORGANIZATION_TITLE: 'ORGANIZACE',
      ORGANIZATION_NOT_FOUND: 'Organizace nenalezena',
      ORGANIZATION: 'organizací',
      BUILDING_DETAIL_PHONE: 'Telefon',
      PLATFORM_USER_DASHBOARD_WARNING: 'Otevřete webovou aplikaci a prozkoumejte všechny její funkce',
      PROJECT: 'PROJEKT',
      STATUS_READY: 'Připraveno',
      STATUS_COUNT_READY: 'Připraveno ({{count}})',
      DASHBOARD_REPORTS_TITLE: 'Zprávy',
      SAVE_USER_DETAILS: 'Uložit detaily uživatele',
      SECONDARY_CONTACT_LABEL: 'Kontakt na sekundární budovu',
      SITE_NOT_FOUND: 'Stránka nenalezena',
      SITE: 'stránky',
      TIMELINE_TITLE: 'Časová osa',
      NEW_SITE: 'připojit nebo vytvořit nový {{entity}}.',
      UNKNOWN_DEVICE_TYPE: 'Neznámý',
      EDIT_USER_DETAILS: 'Podrobnosti o uživateli',
      USERS_TITLE: 'Uživatelé',
      VIEW_LOGBOOK: 'Zobrazit deník',
      USERS_VIEWER: 'Prohlížeč',
      USERS_VIEWER_S: 'Prohlížeč',
      NOT_ACCESS: 'Zatím nemáte přístup k žádné {{entity}}.',
      STARRED_ORGANIZATIONS: 'Zobrazit pouze organizace označené hvězdičkou',
},
    INACTIVITY: {
      LOGOUT: ', budete odhlášeni.',
      INACTIVE_LOGOUT: 'Odhlášen z důvodu nečinnosti',
      TITLE: 'Časový limit relace',
      WARNING : 'Toto okno bylo neaktivní po dobu 15 minut. Pokud nebude provedena žádná akce',
},
    ATPLUS: {
      ATPLUS_FAILURE_COUNT: '{{count}} Chyba',
      ATPLUS_DATETIME_TWENTYFOUR_HOUR: '24hodinová doba',
      ATPLUS_TWO_MINUTE_AGO: 'před 2 min',
      ATPLUS_ACTIVATION: 'Aktivace',
      ADMIN: 'Admin',
      ADMINVIEWER: 'Správce & Uživatel',
      ATPLUS_ADMIN_ACCESS: 'Přístup správce',
      ATPLUS_ALERT_LEVEL: 'Úroveň výstrahy',
      ATPLUS_ALERTSETTING_HEADER: 'Nastavení úrovně upozornění',
      ATPLUS_SEARCHLUMINAIRE_WARNING: 'Všem svítidlům bude přidělena nová adresa a bude vytvořena nová konfigurace.',
      ATPLUS_LOGIN_FAILURE: 'Při změně parametrů došlo k chybě',
      ATPLUS_DATETIME_AUTO_DATE_TIME_HEADER: 'Automatické datum a čas',
      ATPLUS_AUTOMATIC_RESET: 'Automatický klidový režim',
      ATPLUS_AUTOMATIC_REST_MODE_MSG: 'Automatický klidový režim uvede svítidla do klidového stavu, pokud je místní síť vypnuta.',
      ATPLUS_BATTERYFAILURE: 'Selhání baterie',
      ATPLUS_CHANGE_ADMIN_PASSWORD: 'Změnit heslo správce',
      ATPLUS_CHANGE_PASSWORD_FAILURE: 'Chyba změny hesla',
      ATPLUS_CHANGE_PASSWORD_SUCCESS: 'Změna hesla Úspěšná',
      ATPLUS_CHANGE_SERVICE_PARTNER_PASSWORD: 'Změňte heslo servisního partnera',
      ATPLUS_CHANGE_PASSWORD: 'Změňte systémové heslo',
      SYSTEMPASSWORD: 'Změňte systémová hesla',
      ATPLUS_CHANGE_VIEWER_PASSWORD: 'Změnit heslo prohlížeče',
      ATPLUS_SYNC_TEST_SCHEDULE_INFO: 'Kliknutím na „Sync Test Schedule“ nastavíte funkční testy na přesně 7 dní a Trvání za 10 týdnů.',
      ATPLUS_INFO_TAG_CLOSED: 'ZAMČENO',
      ATPLUS_COMISSIONING: 'Uvedení do provozu',
      ATPLUS_COMMANDS: 'Příkazy',
      ATPLUS_COMMSFAILURE: 'Selhání komunikace',
      ATPLUS_CONFIGRATION_CREATED: 'Konfigurace vytvořena',
      ATPLUS_CONFIGRATION_DETAIL: 'Podrobnosti konfigurace',
      ATPLUS_CONFIGRATION_NAME: 'Název konfigurace',
      ATPLUS_CREATE_CONFIGRATION: 'Vytvořit konfiguraci',
      ATPLUS_DATETIME_CURRENT_TIME: 'Aktuální datum a čas',
      ATPLUS_DEVICE_DATETIME_CURRENT_TIME: 'Aktuální datum a čas mobilního zařízení',
      ATPLUS_CURRENT_TEST_SCHEDULE: 'Aktuální harmonogram zkoušek',
      ATPLUS_REFRESH_LUMINAIRES: 'Momentálně získáváme nejnovější stav všech svítidel v budově {{atplus}}.',
      ATPLUS_DATETIME: 'Datum a čas',
      ATPLUS_DRYCONTACT_DEFAULT_SETTINGS: 'Výchozí nastavení',
      ATPLUS_DETAILS: 'Podrobnosti',
      ATPLUS_DRY_CONTACT: 'Suchý kontakt',
      ATPLUS_DRYCONTACT_INPUT: 'Vstup suchého kontaktu',
      ATPLUS_ALERTSETTING_DRY_CONTACT_INPUT: 'Vstup suchého kontaktu aktivován',
      ATPLUS_DRYCONTACT_OUTPUT: 'Suchý kontaktní výstup',
      ATPLUS_ALERTSETTING_DRY_CONTACT_OUTPUT: 'Výstup suchého kontaktu aktivován',
      ATPLUS_DRYCONTACT_HEADER: 'Nastavení suchého kontaktu',
      ATPLUS_DRYCONTACT_STATUS: 'Stav suchého kontaktu',
      ATPLUS_DURATION_TEST_TITLE: 'Trvání \n Test',
      ATPLUS_DTSUCCESS: 'Test provozu z baterií ukončen',
      ATPLUS_DTFAILEDTITLE: 'Chyba testu provozu z baterie',
      ATPLUS_DTINPROGRESS: 'Zkouška životnosti baterie probíhá',
      SERVICE: 'Servis Eaton',
      ATPLUS_ELSYSTEM_SYSTEM_TIME: 'Místní čas systému EL',
      ATPLUS_EMC_HEADER: 'Test EMC',
      ATPLUS_EMERGENCY: 'Stav nouze',
      ATPLUS_FW_UPDATE_EROOR: 'Chyba při aktualizaci firmwaru, zkuste to znovu',
      ATPLUS_EXPORT_CONFIG: 'Export konfigurace',
      ATPLUS_EXPORT_CONFIGRATION_FAIL: 'Proces exportu konfigurace se nezdařil',
      ATPLUS_FAILED_LUMINAIRE: 'Nefunkční svítidla',
      ATPLUS_DRYCONTACT_FAILURE_THRESHOLD: 'Překročena prahová hodnota selhání',
      ATPLUS_FAILURETYPE: 'Typy poruch',
      ATPLUS_FILE_ALREADY_EXIST_TITLE: 'Soubor již existuje',
      ATPLUS_FILE_ALREADY_EXIST_MSG: 'Soubor se stejným názvem již existuje, změňte název souboru',
      ATPLUS_FIRMWARE_FILE_FOR: 'Soubor firmwaru pro verzi',
      ATPLUS_FIRMWARE_UPDATE: 'Aktualizace firmwaru',
      ATPLUS_FW_UPDATE_COMPLETE: 'Aktualizace firmwaru dokončena',
      ATPLUS_FW_UPDATE_INPROGRESS: 'Probíhá aktualizace firmwaru',
      ATPLUS_FUNCTIONAL_TEST_TITLE: 'Funkční \n Test',
      ATPLUS_FTSUCCESS: 'Funkční test dokončen',
      ATPLUS_FTINPROGRESS: 'Probíhá funkční test...',
      CHANGEPASSWORDFOR: 'Potřebuji změnit heslo pro',
      ATPLUS_IMPORT_CONFIG: 'Importovat konfiguraci',
      ATPLUS_INEMERGENCYMODE: 'V nouzovém režimu',
      ATPLUS_INFAILURE: 'V selhání',
      ATPLUS_INRESTMODE: 'V klidovém režimu',
      ATPLUS_INTESTMODE: 'V testovacím režimu',
      ATPLUS_REFRESH_INCOMPLETE: 'Neúplné údaje',
      ATPLUS_CHANGE_PASSWORD_INCORRECT_PASSWORD: 'Nesprávné aktuální heslo',
      ATPLUS_DRYCONTACT_STATUS_INPUT: 'Vstup',
      ATPLUS_EXPORT_CONFIGRATION_INVALID_NAME: 'Neplatný název konfigurace',
      GWCDATPLUSHEADER: 'Je to toto zařízení NO, které uvádíte do provozu?',
      ATPLUS_LAMPFAILURE: 'Selhání lampy',
      ATPLUS_CONFIGRATION_FILE_TITLE_INFO: 'Pouze písmena, číslice, podtržítka a pomlčky',
      ATPLUS_ALERTSETTING_LOCAL_MAIN_FAILURE: 'Místní hlavní porucha',
      ATPLUS_LOAST_CONNECTION: 'Ztráta připojení – zkuste to znovu',
      ATPLUS_ALERTSETTING_LUMINAIRE_ALERTS: 'Upozornění na svítidla',
      ATPLUS_DTFAILEDDESCRIPTION: 'Selhání svítidla',
      ATPLUS_LUMINAIRE: 'Svítidla',
      ATPLUS_FOUNDLUMINAIRE: 'Svítidla nalezena...',
      ATPLUS_FOUNDWERELUMINAIRE: 'Svítidla byla nalezena.',
      ATPLUS_MAIN_OFFICE: 'Hlavní kancelář',
      ATPLUS_DRYCONTACT_SUBHEADER: 'Hlavní kancelář',
      ATPLUS_MANAGE_CONFIG: 'Spravovat konfigurace',
      ATPLUS_LOGIN_MAX_ATTEMPTS_EXCEEDED: 'Bylo dosaženo maximálního počtu pokusů',
      ATPLUS_MINIMIZE: 'Minimalizovat',
      ATPLUS_MULTIPLE_FAILURES: 'Vícenásobná selhání',
      ATPLUS_FOUNDNEWLUMINAIRE: 'byla nalezena nová svítidla.',
      ATPLUS_NEW_TEST_SCHEDULE: 'Nový rozvrh zkoušek',
      ATPLUS_DATETIME_SELECTED_TZ_PLACEHOLDER: 'New York',
      ATPLUS_NEXT_SCHEDULES_DTTEST: 'Další test plánovaného trvání',
      ATPLUS_NEXT_SCHEDULES_FTTEST: 'Další plánovaný funkční test',
      ATPLUS_NO_FW_FILES: 'Pro verzi není k dispozici žádný soubor firmwaru',
      ATPLUS_NO_LUMINAIRES_INSTALLED: 'Nejsou nainstalována žádná svítidla',
      ATPLUS_NO_LUMINAIRES_YET: 'Zatím žádná svítidla',
      ATPLUS_DRYCONTACT_RADIO_CLOSED: 'Normálně zavřeno',
      ATPLUS_DRYCONTACT_RADIO_OPEN: 'Normálně otevřeno',
      ATPLUS_NEWLUMINAIRES_HEADLINE: 'Vyhledejte pouze nově přidaná nebo vyměněná svítidla v „Hlavní kanceláři“, abyste jim automaticky přiřadili adresy.',
      ATPLUS_OPENSNACK: 'OTEVŘENO',
      ATPLUS_OPERATIONS: 'Operace',
      ATPLUS_ALERTSETTING_OTHER_ALERTS: 'Další upozornění',
      ATPLUS_DRYCONTACT_STATUS_OUTPUT: 'Výstup',
      ATPLUS_DRYCONTACT_OUTPUT_DEFAULT_SETTINGS: 'Výchozí nastavení výstupu',
      ATPLUS_ALERTSETTING_CHOOSE_NUMBER: 'Vyberte si prosím mezi 1-10 svítidly',
      ATPLUS_ADDITIONALPASSWORDINSTRUCTION: 'Vytvořte prosím nová hesla pro uživatele s přístupem k tomuto telepříkazu na úrovni služby, správce a diváka.',
      ATPLUS_DONT_MOVE: 'Prosím, neodstěhujte se',
      ATPLUS_DOWNLOAD_FW_FILES: 'Prosím stáhněte si soubor znovu a zkuste...',
      ATPLUS_BLE_DISCONNECT_SUBTITILE: 'Ujistěte se, že jste v dosahu Bluetooth a zkuste to znovu.',
      ATPLUS_RELOGINPASSWORDINSTRUCTION: 'Chcete-li se znovu připojit, zadejte nové heslo znovu',
      ATPLUS_RELOGIN_MESSAGE: 'Chcete-li se znovu připojit, zadejte nové heslo znovu.',
      ATPLUS_ENTRY_MESSAGE: 'Chcete-li změnit následující hesla, zadejte své přihlašovací údaje.',
      ATPLUS_EXPORT_CONFIGRATION_INFO: 'Pojmenujte soubor, do kterého chcete uložit a exportovat naposledy vytvořenou konfiguraci.',
      ATPLUS_STAY_WHERE: 'Prosím, zůstaňte, kde jste',
      ATPLUS_ALERTSETTING_NOTIFY: 'K přizpůsobení předvoleb upozornění použijte následující nastavení.',
      ATPLUS_REFRESH_COMPLETE: 'Obnovení dokončeno',
      ATPLUS_REFRESHLUMINAIRE_TEST: 'Obnovit svítidla',
      ATPLUS_REFRESH_LUMINAIRES_PAGETITLE: 'Obnovit svítidla',
      ATPLUS_REFRESH_LUMINAIRES_PROGRESS: 'Probíhá aktualizace svítidel...',
      ATPLUS_USE_RELIGHT: 'Relight je k dispozici pouze pro svítidla, která jsou aktuálně v klidovém režimu.',
      ATPLUS_DRYCONTACT_INPUT_RELIGHT: 'Znovu zapálit JOUR',
      ATPLUS_RELIGHT_SUCCESS: 'Režim Relight byl úspěšně aktivován.',
      ATPLUS_RESTMODE: 'Odpočinek',
      ATPLUS_REST_SUCCESS: 'Odpočinkový režim byl úspěšně aktivován.',
      ATPLUS_DURATION_TEST: 'Spustit test trvání',
      ATPLUS_FUNCTIONAL_TEST: 'Spusťte funkční test',
      ATPLUS_SEARCHALL_LUMINAIRE: 'Prohledat všechna svítidla',
      ATPLUS_SEARCH_ALL_LUMINAIRES: 'Hledat všechna svítidla',
      ATPLUS_SEARCH_NEWLUMINAIRES: 'Hledání nových svítidel',
      ATPLUS_SEARCHNEW_LUMINAIRE: 'Hledat Nová svítidla',
      ATPLUS_SERVICE_ACCESS: 'Přístup ke službě',
      ATPLUS_SERVICEPARTNERPASSWORD: 'Servisní partner',
      ATPLUS_CHANGEPASSWORD_INSTRUCTION: 'Nastavte heslo pro uživatele s',
      ATPLUS_ADDITIONALPASSWORD: 'Nastavte další hesla',
      ATPLUS_DATE_TIME: 'Nastavte datum a čas',
      ATPLUS_DATETIME_HEADER: 'Nastavte datum a čas',
      ATPLUS_ALERTSETTING_LUMINAIRE_ALERTS_INFO: 'Nastavte počet vadných svítidel, kterých musí systém dosáhnout, aby se aktivovalo upozornění.',
      ATPLUS_SHOW_CONNECTED_LUMINAIRE: 'Zobrazit připojená svítidla',
      ATPLUS_SHOW_REGISTERED_LUMINAIRE: 'Zobrazit registrovaná svítidla',
      SIGN_IN: 'Přihlaste se',
      SIGN_IN_AS: 'Přihlásit se jako...',
      ATPLUS_RELIGHT: 'Spusťte režim Relight',
      ATPLUS_REST: 'Spusťte režim odpočinku',
      ATPLUS_STARTSEARCH: 'Spusťte vyhledávání',
      ATPLUS_START_TEST: 'Spustit test',
      ATPLUS_VISIBILITY_TEST: 'Spusťte Visibility Plus',
      ATPLUS_DRYCONTACT_INPUT_VISIBILITY: 'Spusťte Visibility+',
      ATPLUS_STARTDT: 'Spuštění testu výdrže baterií',
      ATPLUS_STARTFT: 'Spouštění funkčního testu...',
      ATPLUS_STARTDTSNACK: 'Zastavit test',
      ATPLUS_EMC: 'Přepněte na test EMC',
      ATPLUS_SYNCH_TEST: 'Plán testu synchronizace',
      ATPLUS_SYNC_TEST_SCHEDULE: 'Plán testu synchronizace',
      ATPLUS_SYNC_TEST_SCHEDULED_INFO: 'Synchronizujte plán testu pro test funkčnosti a trvání pro všechna svítidla v budově',
      TELECOMMANDPASSWORD: 'Heslo Telecommand',
      ATPLUS_TEST: 'Test',
      ATPLUS_SYNC_TEST_TIME: 'Doba testu:',
      ATPLUS_DRYCONTACT_INPUT_READONLY: 'Vstup suchého kontaktu je pouze pro čtení, ale lze jej nakonfigurovat ručně na přepínači DIP.',
      ATPLUS_DRYCONTACT_STATUS_READONLY: 'Stav je pouze pro čtení, ale lze jej nakonfigurovat ručně pomocí přepínače DIP.',
      ATPLUS_LUMINAIRE_INSTALL: 'Tato akce rozbliká všechna svítidla v instalaci.',
      ATPLUS_SHOW_CONNECTED_LUMINAIRE_INFO: 'Tato akce rozbliká každé svítidlo, které je správně zapojeno a připojeno k ovladači.',
      ATPLUS_SEARCHLUMINAIRE_HEADLINE: 'Tato akce vytvoří novou konfiguraci pomocí všech připojených svítidel.',
      ATPLUS_SHOW_REGISTERED_LUMINAIRE_INFO: 'Tato akce rozbliká pouze svítidla, která jsou součástí vaší konfigurace osvětlení.',
      ATPLUSSYNC_TEST_SCHEDULED_TIME_INFO: 'Tato akce synchronizuje další funkční test přesně na 1 týden a testy trvání na 10 týdnů.',
      ATPLUS_AUTOMATIC_REST_MODE_INFO: 'Tyto informace jsou pouze pro čtení, ale lze je nakonfigurovat ručně na přepínači DIP.',
      ATPLUS_LOAST_CONNECTION_INFO: 'Toto mobilní zařízení musí během funkčního testu zůstat v dosahu Bluetooth a musí být připojeno k systému AT+.',
      ATPLUS_DEVICE_RANGE: 'Pro tuto operaci musí toto mobilní zařízení zůstat v dosahu Bluetooth G-North TLAT+. \n Tento proces může trvat několik minut.',
      ATPLUS_TOMANYLUMINAIREHEADER: 'Tento systém může podporovat pouze 64 svítidel. Součástí vaší konfigurace bude pouze prvních 64 detekovaných zařízení.\nK vyhledání svítidel, která nejsou součástí vaší konfigurace, použijte funkci „Vyhledat registrovaná svítidla“ v okně Uvedení do provozu.',
      ATPLUS_CURRENT_LUMINAIRES_CONFIGURATION: 'To nahradí vaši současnou konfiguraci svítidla',
      ATPLUS_TIMEREMAINS: 'Časový odhad,',
      ATPLUS_TIMEREMAINING: 'Zbývající čas,',
      ATPLUS_DATETIME_TIMEZONE: 'Časové pásmo',
      ATPLUS_TIMEZONE_HEADER: 'Časové pásmo',
      TLU_ATPLUS_PASSWORD_INCORRECT: 'Nesprávné heslo TLU AT+',
      ATPLUS_TOMANYLUMINAIRE: 'Bylo nalezeno příliš mnoho svítidel',
      ATPLUS_FIRMWARE_UPDATING: 'Aktualizace firmwaru...',
      ATPLUS_USE_REST: 'Použijte Rest pro svítidla, která již nejsou připojena k hlavnímu napájení.',
      ATPLUS_FINISHSEARCH: 'Tyto výsledky použijte k vytvoření a sdílení nové konfigurace pomocí možnosti Exportovat.',
      ATPLUS_DATETIME_AUTO_DATE_TIME_SUBTEXT: 'Použijte datum, čas a časové pásmo svého mobilního zařízení k automatické synchronizaci se systémem TLAT+. Chcete-li ručně nastavit datum, čas a časové pásmo, vypněte tuto funkci.',
      ATPLUS_VIEWLOGBOOK: 'Zobrazit deník',
      VIEWER: 'Prohlížeč',
      ATPLUS_VIEWER_ACCESS: 'Přístup diváka',
      ATPLUS_LOGIN_MAX_ATTEMPTS_EXCEEDED_BODY: 'Můžete se zkusit přihlásit do tohoto',
      ATPLUS_DT_DIALOG: 'Pokud se během testu trvání příliš vzdálíte od systému AT+, můžete ztratit data.\n\nOdhadovaný zbývající čas, 01:00:00',
      ATPLUS_FT_DIALOG: 'Pokud se během funkčního testu příliš vzdálíte od systému AT+, můžete ztratit data.\n\nOdhadovaný zbývající čas, 00:02:00',
      ATPLUS_NO_LUMINAIRES_YET_DESCRIPTION: 'Chcete-li zde vidět svá svítidla, budete muset použít funkci „Vyhledat všechna svítidla“ a aktivovat TLAT+.',
      ATPLUS_CONFIGRATION_CREATED_MESSAGE: 'Vaše konfigurace byla úspěšně vytvořena.',
      ATPLUS_RELOGIN_SUCCESS_MESSAGE: 'Vaše nová hesla byla uložena.',
      ATPLUS_DEVICE_UNREGISTERED: 'Toto zařízení není registrováno',
      ATPLUS_DEVICE_NEEDCOMMISSIONIG: 'Toto zařízení není registrováno v cloudu a je třeba jej znovu uvést do provozu',
      SAVE_TO_CLOUD: 'Uložit do cloudu',
      EXPORT: 'Vývozní',
      ATPLUS_IMPORT_CONFIG_SETTING_DEVICE_NAME: 'Nastavení názvu zařízení',
      TPLUS_IMPORT_CONFIG_LOADING_LUM_CONFIGRATION: 'Načítání konfigurace svítidla...',
      ATPLUS_IMPORT_CONFIG_SETTING_DRY_CONTACT_CONFIGURATION: 'Nastavení konfigurace suchého kontaktu',
      ATPLUS_IMPORT_CONFIG_PROGRESS_ALERT_TITLE: 'Ukončit a ztratit pokrok?',
      TPLUS_IMPORT_CONFIG_PROGRESS_ALERT_SUBTITLE: 'Opuštěním této obrazovky se proces importu zruší a budete muset proces spustit znovu.',
      ATPLUS_START_VISIBILITY_PLUS: 'Spusťte Visibility Plus',
      ATPLUS_VISIBILITY_PLUS: 'Viditelnost Plus',
      ATPLUS_VISIBILITY_PLUS_FAILED: 'Viditelnost Plus se nezdařila',
      ATPLUS_IN_ALARM: 'V poplachu',
      LAMP_FAILURE_TEXT: 'Selhání lampy',
      SAFETY_LUMINARIE: 'Bezpečnostní svítidlo',
      LUMINARY_ADDRESS: '<adresa>',
      DS_SEARCH_FOR_IO_MODULES: 'Prohledejte moduly I-Bus',
      ATplUS_ACTIVATION_PENDING: 'Čeká na vyřízení',
      ATPLUS_ALERTSETTING_ZONE_ALERTS_INFO: 'Nastavte počet vadných svítidel, kterých musí systém dosáhnout, aby se aktivovalo upozornění.',
      ATPLUS_ALERTSETTING_LINE_ALERTS_INFO: 'Nastavte počet vadných svítidel, kterých musí systém dosáhnout, aby se aktivovalo upozornění.',
      ATPLUS_IDENTIFICATION_CONNECTED_LUMINAIRE_INFO: 'Tato akce rozbliká každé svítidlo, které je správně zapojeno a připojeno k ovladači.',
      ATPLUS_IDENTIFICATION_REGISTERED_LUMINAIRE_INFO: 'Tato akce rozbliká pouze svítidla, která jsou součástí vaší konfigurace osvětlení.',
      ATPLUS_SPEC_DATE_COMMISSIONED: 'Datum uvedení do provozu',
      ATPLUS_SPEC_TOTAL_LUMINAIRES: 'Celkem svítidel',
      ATPLUS_SPEC_LUMINAIRE: 'Svítidla',
},
    USERLIST: {
      DELETECONFIRMATION: '{{email}} Účet a všechna jeho data budou trvale odstraněny. Smazání tohoto účtu neovlivní organizaci, zařízení ani žádná související historická data.',
      ACCOUNT_DELETE: 'Účet smazán',
      ALL_LOCATION: 'Všechny lokality',
      DELETEACCOUNT: 'Smazat tento účet?',
      COL_EMAIL: 'E-mail',
      COL_LOCATION: 'Umístění',
      COL_ROLE: 'Role',
      COL_STATUS: 'Postavení',
      DELETE_SUCCESS: 'Uživatelský účet pro {{email}} byl úspěšně smazán.',
      COL_USERNAME: 'Uživatelské jméno',
},
    REPORTS: {
      ISSUES: '{{issueCount}} problémů',
      MONTHLY_REPORT: 'Měsíční zpráva',
      NO_ISSUES: 'Během tohoto období žádné problémy',
      REPORT_DOWNLOAD_FAILED: 'Stažení souboru zprávy se nezdařilo',
      REPORT_DOWNLOAD_SUCCESSFULLY: 'Soubor zprávy byl úspěšně stažen',
},
    MAP: {
      MAP_COORDINATES: '{{latitude}} N, {{longitude}} E',
      BLOCKED: 'BLOKOVÁNO',
      MAP_COORDINATES_LABEL: 'Souřadnice',
       MAP_ADDRESS_DISPLAY: 'Zobrazit adresu na mapě',
      MAP_DRAG_MARKER: 'Špendlík umístěte přetažením na mapu',
      ERROR: 'CHYBA',
      OFFLINE: 'OFFLINE',
      READY: 'PŘIPRAVEN',
      MAP_ENABLE_ON_COUNTRY: 'Vyberte zemi pro aktivaci mapy',
      SYSTEM: 'Systém',
      SYSTEMS: 'Systémy',
      WARNING: 'VAROVÁNÍ',
},
    MAINTENANCE_DETAILS: {
      ADD_DOC: '+ Přidat dokument',
      ADD_NOTES: '+ Přidat poznámky',
      ADD_DOCUMENT_BUTTON: '+ Přidat dokument nebo fotografii',
      NEW_MAINTENANCE: '+ Nová údržba',
      CREATE_MAINTAINENCE_BUTTON: 'Přiřadit a upozornit',
      TECHNICIAN_INPUT_LABEL: 'Přiřazeno komu',
      STATUS_COMPLETED: 'Dokončeno',
      CUSTOMER_CONTACT: 'Kontakty na zákazníky',
      DATE_CREATED: 'Datum vytvoření',
      DELETE_REQ: 'Smazat požadavek',
      COMMENTS_LABEL: 'Popis (volitelné)',
      DOCUMENTATION: 'Dokumentace',
      STATUS_DUE: 'Splatné',
      EMERGENCY: 'Stav nouze',
      STATUS_EXPIRED: 'Platnost vypršela',
      HIGH: 'Vysoký',
      IN_DUE: 'ZA {{differenceInDays}} DNŮ',
      UPLOAD_DOCUMENT_ERROR_MESSAGE_INVALID_TYPE: 'Neplatný typ souboru. Povoleny jsou pouze PDF, JPEG a PNG.',
      SUPPORT_TYPE_INPUT_LABEL: 'Typ problému',
      LIFECYCLE_MAINTAINANCE: 'Údržba životního cyklu',
      LIFECYCLE_MAINTENANCE: 'Údržba životního cyklu',
      LOCATION: 'místa',
      LOW: 'Nízký',
      MAINTENANCE_HISTORY: 'Historie údržby',
      MAINTENANCE_REQUEST: 'Požadavek na údržbu',
      MEDIUM: 'Střední',
      NO_CUSTOMER_LINKED: 'Žádný zákazník propojen',
      NO_DOC_ADDED: 'Nebyla přidána žádná dokumentace',
      NO_MAINTENACE_FOUND: 'Nebyla nalezena žádná údržba',
      NO_NOTES_ADDED: 'Nebyly přidány žádné poznámky',
      NOTES: 'Poznámky',
      UPLOAD_DOCUMENT_ERROR_MESSAGE_INVALID_FILE_SIZE: 'Jeden nebo více souborů překračuje limit velikosti 2 MB.',
      PAST_DUE: 'Po splatnosti',
      PRIORITY: 'Přednost',
      STATUS_REJECTED: 'Odmítnuto',
      REOPEN_SERVICE_TICKET: 'Znovu otevřete servisní lístek',
      REQUEST_PRIORITY_INPUT_LABEL: 'Priorita požadavku',
      REQ_MAINTENANCE: 'Požadovaná údržba',
      REQUESTED_MAINTAINANCE: 'Požadovaná údržba',
      SCHEDULED: 'Naplánováno',
      STATUS_SCHEDULED: 'Naplánováno',
      SCH_SERVICE_DATE: 'Datum plánovaného servisu',
      SEARCH: 'Hledejte podle čísla lístku',
      SERVICE_DATE: 'Servisní datum',
      SERVICE_TICKET_NO: 'Číslo servisního lístku',
      SERVICE_TYPE: 'Typ služby',
      SUPPORT_TECHNICIAN: 'Technik podpory',
      SYS_FAILURE: 'Selhání systému',
      SYSTEM_FAILURE: 'Selhání systému',
      TICKET_CLOSED: 'Ticket uzavřen',
      TICKET_NO: 'Číslo ticketu',
      STATUS: 'Stav ticketu: Vše',
      TODAY: 'DNES',
      UPLOAD_DOCUMENT_ERROR_MESSAGE_MAX_3_FILES: 'Můžete vybrat pouze 3 soubory.',
      EDIT_SERVICE_TICKET: 'Upravit servisní lístek',
      MAINTENANCE_OPERATIONS: 'Operace údržby',
      SCHEDULED_MAINTENANCE: 'Plánovaná údržba',
      RECENT_MAINTENANCE: 'Nedávná údržba',
      CLOSE_SERVICE_TICKET: 'Zavřít servisní lístek',
      CLOSE_TICKET: 'Zavřít vstupenku',
      DESCRIBE_ACTION: 'Popište kroky podniknuté k vyřešení problému',
      TICKET_RESOLUTION: 'Rozlišení lístků',
      CLOSED_BY: 'Zavřeno',
},
    ASSETS_DETAILS: {
      ADD_BUILDINGS: '+ Přidat budovu',
      ADD_SYSTEMS: '+ Přidat systém',
      NEW_MAINTAINENCE: '+ Nová údržba',
      BUILDINGS: 'Budovy',
      CUSTOMER_MAINTAINENCE_HEADER: 'Podrobnosti o zákazníkovi',
      CUSTOMER_INFO_HEADER: 'Informace o zákazníkovi',
      DOWNLOAD_AS: 'Stáhnout jako…',
      FIRMWARE: 'Firmware',
      GATEWAYS: 'Brány',
      LINK_TO_CUSTOMER_BUTTON: 'Odkaz na zákazníka',
      MAIN_CONTACT: 'Hlavní kontakt',
      RIGHT_MAINTAINENCE_HEADER: 'Podrobnosti o údržbě',
      MOST_RECENT_STATUS: 'Nejnovější stav',
      NOTIFY_USERS_MAINTAINENCE_HEADER: 'Upozornit uživatele:',
      SUBHEADER_TEXT_MAINTAINENCE: 'Zkontrolujte informace, přidělte technika a uveďte jakékoli užitečné podrobnosti pro vyřešení problému.',
      PREVIOUS_SYSTEM_STATUS: 'Předchozí stav systému',
      CREATE_MAINTAINENCE_HEADER: 'Naplánujte novou operaci údržby',
      ADD_BUILDING_ASSET: 'Vyberte organizaci pro vytvoření budovy',
      SELECT_ORGANIZATION_LABEL: 'Vyberte organizaci',
      SHOW_FAVORITE_BUILDINGS: 'Zobrazit pouze budovy označené hvězdičkou',
      SHOW_FAVORITE_GATEWAYS: 'Zobrazit pouze brány označené hvězdičkou',
      SHOW_FAVORITE_SYSTEMS: 'Zobrazit pouze systémy označené hvězdičkou',
      SLA_SUBTITLE: 'SLA #',
      LEFT_MAINTAINENCE_HEADER: 'Podrobnosti o systému',
      SYSTEM_NAME_TYPE_SUBTITLE: 'Název a typ systému',
      SYSTEMS: 'Systémy',
      HELPER_TEXT_MAINTAINENCE: 'Tento požadavek upozorní {{customerName}} primární a sekundární kontakty. Ve výchozím nastavení bude obsahovat relevantní informace o poloze, zařízení, poplachu a události.',
      NO_CUSTOMER_TEXT: 'Tento systém nebyl propojen se zákazníkem',
},
    COMMON: {
      SYNC_NOW_TIME: '=--před minutou',
      REQUIRES_FIRMWARE_UPDATE: '1 vyžaduje aktualizaci firmwaru',
      NOTIFICATION_REPORT_MESSAGE_BODY: 'Je k dispozici nový měsíční přehled pro: \n {{bodytext}}',
      ACCESS: 'Přístup',
      ACTIVE: 'Aktivní',
      ALERT: 'Upozornění!',
      DOWNLOAD_PERMISSION: 'Povolte oprávnění k uložení souboru do vašeho zařízení',
      GO_BACK: 'ZPĚT',
      NOTIFICATION_EVENT_OCCURED: 'U následujícího systému došlo k {{logType}}',
      ASSETS: 'Aktiva',
      BACK: 'Zpět',
      BLOCKED: 'BLOKOVÁNO',
      CANCEL: 'Zrušit',
      CANNOT_REFRESH_TOKEN: 'Nelze obnovit token',
      CLOSE: 'Zamknout',
      SET_ETHERNET: 'Nakonfigurujte nastavení portu',
      CONFIRM: 'Potvrdit',
      CONNECT: 'Připojit',
      CONNECTION: 'Spojení',
      CSV: 'CSV',
      DASHBOARD: 'Dashboard',
      DESCRIPTION: 'Popis',
      DISCARD: 'Vyřadit',
      DISCARD_UNSAVED_CHANGE: 'Zahodit neuložené změny?',
      DONE: 'Hotovo',
      DOWNLOAD: 'Stáhnout',
      DOWNLOAD_FAILED: 'Stahování se nezdařilo, zkuste to prosím znovu',
      COMPANY: 'Eaton',
      EDIT: 'Upravit',
      APP_NAME: 'Manažer bezpečnosti budovy',
      EMPTY: 'PRÁZDNÝ',
      EXCEL: 'Soubor Excel',
      EXIT: 'Výstup',
      EXTEND: 'Rozšířit',
      DOWNLOAD_SUCCESS: 'Soubor byl úspěšně stažen.',
      ANOMALY: 'V ANOMÁLII',
      INACTIVE: 'Neaktivní',
      INCOMPLETE: 'Neúplný',
      INFO: 'Info',
      INTERVAL: 'Interval',
      KEEP_EDITING: 'Pokračujte v úpravách',
      LAST_RETREIVED: 'Naposledy načteno:',
      LAST_RETRIEVED: 'Naposledy načteno: -- před min',
      LINK: 'Odkaz',
      LOCATE: 'Lokalizovat',
      LOGBOOK: 'Deník',
      LOGGED_IN_SUCCESSFULLY: 'Úspěšně přihlášen',
      NOTIFICATION_NEW_REPORT_AVAILABLE: 'K dispozici nová zpráva',
      NEWUSER: 'Nový uživatel',
      NEXT: 'Další',
      NODATA: 'Žádná data',
      OFF: 'vypnuto',
      OFFLINE: 'Offline',
      OK: 'Dobře',
      ON: 'na',
      PASSWORD: 'Heslo',
      PDF: 'PDF',
      SELECT_PREFERRED_LANGUAGE: 'Vyberte prosím svůj \npreferovaný jazyk',
      POWERED_BY_BRIGHTLAYER: 'Běží na Brightlayer',
      READY: 'PŘIPRAVEN',
      RECOONECTTOGATWAY: 'Znovu se připojte k bráně',
      REFRESH: 'Obnovit',
      REMOVE: 'Odstranit',
      RETURNTODASHBOARD: 'Návrat na řídicí panel',
      NAVIGATION_HEADER: 'Systém řízení bezpečnosti',
      SAVE: 'Uložit',
      REFRESH_TOKEN_ERROR: 'Bezpečnostní token nesmí být prázdný ani prázdný',
      SESSION_ALERT_TITLE: 'Časový limit relace',
      SET: 'Soubor',
      SETTINGS: 'Nastavení',
      VIEW_ALL_SYSTEM: 'Zobrazit vše',
      SKIP: 'Přeskočit',
      STOP: 'Zastávka',
      PERMISSION_ERROR: 'Nebylo uděleno oprávnění k ukládání',
      SYNC: 'Synchronizovat',
      SYNCH_OFFLINE_DATABASE: 'Synchronizace offline databáze',
      SYSTEM: 'Systém',
      SESSION_ALERT_SUBTITLE: 'Toto okno bylo neaktivní po dobu 15 minut. Pokud během {{extendTime}} neprovedete žádnou akci, budete odhlášeni.',
      TIME: 'Čas',
      TRYAGAIN: 'Zkuste to znovu',
      DOWNLOAD_FAIL: 'Nelze stáhnout, zkuste to znovu.',
      UNAUTHORIZED_ACCESS: 'Neoprávněný přístup',
      UNLINK: 'Odpojit',
      USERS: 'Uživatelé',
      VIEW: 'Pohled',
      WELCOME: 'Vítejte',
      YES: 'Ano',
      EMPTY_SYSTEM_TITLE: 'V této organizaci zatím nemáte žádné prostředky.',
      EMPTY_SYSTEM_SUBTITLE: 'Jakmile začnete přidávat aktiva (systémy) do této organizace, zobrazí se informace o stavu vašich nouzových světel.',
      ERROR_OCCURED: 'Došlo k chybě v',
      OOPS: 'Jejda!',
      THERE_IS_ERROR: 'Došlo k chybě',
      NEW_VERSION_AVAILABLE: 'Nová verze aplikace dostupná v',
      UNDER_MAINTENANCE: 'Aplikace je momentálně v údržbě.',
      UNDER_MAINTENANCE_TITLE: 'Aplikace pod údržbou',
      UPDATE_AVAILABLE_TITLE: 'Aktualizace k dispozici',
      UPDATE_REQUIRED_TITLE: 'Je vyžadována aktualizace',
      UPDATE_NOW: 'Aktualizujte nyní',
      ASK_ME_LATER: 'Zeptejte se mě později',
      EMPTY_TRIGGERS_LINE: 'Nebyly nakonfigurovány žádné volitelné spouštěče.',
      ASSIGN: 'Přiřadit',
      OKTA_LOGOUT_ALERT: 'Opravdu se chcete odhlásit z okta?',
      OKTA_LOGIN_BUTTON: 'Přihlaste se pomocí Okta',
      CANNOT_PROCCED_LOGIN: 'Jste neoprávněný uživatel. Prosím zaregistrujte se.',
      UNAUTHORIZED_ACCESS_OKTA: 'Chyba autorizace',
      SCAN: 'Skenovat',
      NO: 'Žádný',
      ACKNOWLEDGE: 'Potvrdit',
      DAYS: 'Dny',
      VALID_EMAIL_ERROR: 'Zadejte prosím platný e-mail',
      TRANSFER_LUMINARIES: 'Převod',
      TRIGGERS: 'Spouštěče',
      SELECTED: 'Vybraný',
      NAME: 'Jméno',
},
    PASSWORD_REQUIREMENTS: {
      LENGTH: '8-16 znaků',
      LOWER: 'Jedno malé písmeno',
      NUMBERS: 'Jedno číslo',
      SPECIAL: 'Jedna speciální postava',
      UPPER: 'Jedno velké písmeno',
},
    AUTH_TRANSLATION: {
      FORGOT_PASSWORD: {
        LINK_SENT_ALT: 'Odkaz na resetování hesla byl odeslán na adresu <1>{{email}}</1>.',
        LINK_SENT: 'Odkaz na resetování hesla byl odeslán na adresu <b>{{email}}</b>.',
        ERROR: 'V tuto chvíli nelze obnovit heslo.',
        INSTRUCTIONS_ALT: 'Zadejte e-mail účtu přidružený k účtu',
        INSTRUCTIONS: 'Zadejte e-mail účtu přidružený k účtu.\nPokud má tento e-mail účet u společnosti Eaton, obdržíte odpověď do <b>jednoho pracovního dne</b>.\nV případě naléhavých problémů s účtem zavolejte \n{{telefon}}.',
        RESET_CODE_ERROR: 'U vašeho resetovacího kódu došlo k chybě.',
},
      MESSAGES: {
        USER_PHONE_NUMBER_INVALID: 'Telefonní číslo je neplatné',
        CONGRATS: 'Gratuluji!',
        CONTACT: 'Kontaktujte zástupce podpory Eaton',
        EMAIL_SENT: 'Email odeslán',
        ERROR: 'Chyba!',
        FAILURE: 'Chyba',
        INVALID_VERIFICATION_CODE: 'Ověřovací kód není platný nebo by měl být kratší než 6 znaků',
        LOADING: 'Načítání...',
        GENERIC_ERROR_MESSAGE: 'Pokud požadovanou operaci nelze dokončit, kontaktujte svého správce.',
        EMAIL_ENTRY_ERROR: 'Zadejte prosím platný e-mail',
        USER_EMAIL_INVALID: 'Zadejte prosím platnou e-mailovou adresu.',
        REQUEST_ERROR: 'Omlouváme se, při odesílání vašeho požadavku došlo k problému.',
        SUCCESS: 'Úspěch',
        WELCOME: 'Vítejte',
        LOGIN_MESSAGE: 'Jste „přihlášeni“.',
},
      CHANGE_PASSWORD: {
        PROBLEM_OCCURRED: 'Vyskytl se problém:',
        CANCEL: 'Zrušit',
        PASSWORD: 'Změnit heslo',
        CONFIRM_NEW_PASSWORD: 'Potvrďte nové heslo',
        OLD_PASSWORD: 'Staré heslo',
        PASSWORD_CHANGED: 'Heslo změněno',
        PASSWORD_INFO: 'Heslo musí být dlouhé alespoň 8 znaků, obsahovat alespoň jedno velké písmeno, jedno malé písmeno, jedno číslo a jeden speciální znak.',
        UPDATE: 'Aktualizovat',
        EMAIL_CONFIRM_MESSAGE: 'Poslali jsme potvrzovací e-mail na adresu <b>{{email}}</b>',
        ERROR_MESSAGE: 'Vaše informace neodpovídaly našim záznamům. Chcete-li to zkusit znovu, zadejte své údaje znovu.',
        SUCCESS_MESSAGE: 'Vaše heslo bylo úspěšně aktualizováno! Pro zajištění bezpečnosti vašeho účtu se budete muset přihlásit do aplikace pomocí vašich aktualizovaných přihlašovacích údajů.',
},
      SELF_REGISTRATION: {
        VERIFY_EMAIL: {
          MESSAGE: 'Na vámi zadanou e-mailovou adresu byl odeslán ověřovací kód. Pokračujte kliknutím na odkaz nebo zadáním kódu níže. Tento kód je platný 30 minut.',
          VERIFICATION_CODE_PROMPT: 'Neobdrželi jste kód?',
          RESEND: 'Znovu odeslat ověřovací e-mail',
          VERIFICATION: 'Ověřovací kód',
},
        ALREADY_REGISTERED_USER: 'Již registrovaný uživatel',
        INSTRUCTIONS: 'Chcete-li se zaregistrovat pro účet Eaton, zadejte požadované informace níže. Abyste mohli pokračovat, budete muset ověřit svou e-mailovou adresu.',
},
      REGISTRATION: {
        STEPS: {
          COMPLETE: 'Účet vytvořen!',
          ACCOUNT_DETAILS: 'Podrobnosti o účtu',
          COMPANY_ADDRESS: 'Adresa společnosti',
          COMPANY_DETAILS: 'Podrobnosti o společnosti',
          CREATE_ACCOUNT: 'Vytvořte si účet',
          PASSWORD: 'Vytvořit heslo',
          LICENSE: 'Licenční smlouva',
          VERIFY_EMAIL: 'Ověřte email',
},
        EULA: {
          DEUTSCH: 'Němec',
          ENGLISH: 'angličtina',
          AGREE_TERMS: 'Přečetl jsem a souhlasím s podmínkami',
          LANGUAGE_SUCCESS: 'Jazyk byl úspěšně aktualizován',
          LOADING: 'Načítání licenční smlouvy s koncovým uživatelem...',
},
        INSTRUCTIONS: {
          ACCOUNT_DETAILS: 'Pro dokončení vytvoření účtu zadejte své údaje.',
          COMPANY_DETAILS: 'To pomáhá společnosti Eaton poskytovat servisní podporu pro vaše řešení nouzového osvětlení. Pokud zahajujete projekt pro svého klienta, uveďte prosím informace za svou vlastní společnost, nikoli za klienta.',
          COMPANY_ADDRESS: 'To pomáhá společnosti Eaton poskytovat servisní podporu pro vaše řešení nouzového osvětlení. Pokud zahajujete projekt pro svého klienta, uveďte prosím informace za svou vlastní společnost, nikoli za klienta.',
},
        UNKNOWN_EMAIL: 'Neznámý email',
        UNKNOWN_ORGANIZATION: '-',
        FAILURE_MESSAGE: 'Nepodařilo se nám dokončit vaši registraci. Dokončete stisknutím Pokračovat níže.',
        SUCCESS_MESSAGE_ALT: 'Váš účet byl úspěšně vytvořen pomocí e-mailu <1>{{email}}</1>."\nVáš účet již byl přidán do organizace <3>{{organization}}</3>.\nDokončete stisknutím Pokračovat níže.',
        SUCCESS_MESSAGE: 'Váš účet byl úspěšně {{state}} s e-mailem {{email}}.\n\nByli jste přidáni do {{organization}} .\',',
        SUCCESS_EXISTING: 'Váš účet byl úspěšně vytvořen. Přihlaste se prosím pomocí e-mailu a hesla svého účtu Eaton.',
        SUCCESS_SYNCED_MESSAGE: 'Váš účet EL Digital byl úspěšně synchronizován s informacemi Bright Layer Cloud přidruženými k e-mailu <b>{{email}}</b>.',
        SUCCESS_FINISH: 'Kliknutím na „Dokončit“ se přihlaste a získejte přístup ke svému účtu.',
        SUCCESS_DASHBOARD: 'Chcete-li pokračovat ve svém účtu, klikněte na „Přejít na můj řídicí panel“.',
},
      ACTIONS: {
        BACK: 'Zpět',
        CANCEL: 'Zrušit',
        CHANGE_LANGUAGE: 'Změňte jazyk zde!',
        CLICK_BUTTON: 'Klepněte na tlačítko',
        UPDATE_REDUX: 'Kliknutím na tlačítko aktualizujte hodnotu redux store!',
        CONTINUE: 'Pokračovat',
        DONE: 'Hotovo',
        FINISH: 'Dokončit',
        GO_HOME: 'Přejít na domovskou stránku',
        GO_DASHBOARD: 'Přejít na můj řídicí panel',
        GO_TEST: 'Přejděte na testovací stránku',
        LOG_IN: 'Přihlaste se',
        LOG_OUT: 'Odhlásit se',
        NEXT: 'Další',
        OKAY: 'Dobře',
        REMEMBER: 'Pamatuj si mě',
        RESEND: 'Odeslat znovu',
        SEND_AGAIN: 'Odeslat znovu',
        SEND_EMAIL: 'Odeslat e-mail',
        CREATE_ACCOUNT: 'Zaregistrujte se',
        UPDATE: 'Aktualizovat',
},
      FORMS: {
        COMPANY_NAME: 'Název společnosti',
        CONFIRM_PASSWORD: 'Potvrďte heslo',
        COUNTRY: 'Země',
        CURRENT_PASSWORD_ERROR: 'Aktuální heslo se neshoduje',
        FIRST_NAME: 'Křestní jméno',
        RESET_PASSWORD: 'Zapomenuté heslo',
        LAST_NAME: 'Příjmení',
        ORGANAIZATION_ADRESS: '1. řádek adresy organizace*',
        PASSWORD: 'Heslo',
        PASS_MATCH_ERROR: 'Hesla se neshodují',
        PHONE_NUMBER: 'Telefonní číslo',
        TOGGLE_PASSWORD_VISIBILITY: 'Přepnout viditelnost hesla',
},
      LABELS: {
        CURRENT_PASSWORD: 'Aktuální heslo',
        EMAIL: 'E-mailová adresa',
        FORGOT_PASSWORD: 'Zapomněli jste heslo?',
        NEED_ACCOUNT: 'Potřebujete účet?',
        NEW_PASSWORD: 'Nové heslo',
        OPTIONAL: 'Volitelný',
        PASSWORD: 'Heslo',
        USERNAME: 'Uživatelské jméno',
},
      LOGIN: {
        INCORRECT_CREDENTIALS: 'Nesprávný e-mail nebo heslo',
        GENERIC_ERROR: 'Váš požadavek v tuto chvíli nelze zpracovat.',
        INVALID_CREDENTIALS: 'Vaše kombinace uživatelského jména a hesla nebyla rozpoznána.',
},
      GATEWAY_COMMISSION_STEP: {
        STEP_NUMBER: 'Krok {{stepNo}} ze 4',
},
},
    REGISTRATION: {
      STEPS_MESSAGE: {
        CREATE_ACCOUNT_VERIFY_EMAIL: 'Na vámi zadanou e-mailovou adresu byl odeslán ověřovací kód. Pokračujte kliknutím na odkaz nebo zadáním kódu níže. Tento kód je platný 30 minut.',
        CREATE_ACCOUNT_USER_DETAILS: 'Pro dokončení vytvoření účtu zadejte své údaje.',
        CREATE_ACCOUNT_COMPANY_DETAILS: 'To pomáhá společnosti Eaton poskytovat servisní podporu pro vaše řešení nouzového osvětlení. Pokud zahajujete projekt pro svého klienta, uveďte prosím informace za svou vlastní společnost, nikoli za klienta.',
        CREATE_ACCOUNT_ENTER_EMAIL: 'Chcete-li si zaregistrovat účet pro systém řízení bezpečnosti, zadejte níže požadované informace. Chcete-li pokračovat, budete muset ověřit svou e-mailovou adresu.',
},
      STEPS: {
        COMPLETE_OTHER_ADOPTER: 'Účet potvrzen!',
        COMPLETE: 'Účet vytvořen!',
        ACCOUNT_DETAILS: 'Podrobnosti o účtu',
        COMPANY_ADDRESS: 'Adresa společnosti',
        COMPANY_DETAILS: 'Podrobnosti o společnosti',
        CREATE_ACCOUNT: 'Vytvořte si účet',
        PASSWORD: 'Vytvořit heslo',
        FORGOT_PASSWORD: 'Zapomenuté heslo',
        LICENSE: 'Licenční smlouva',
        VERIFY_EMAIL: 'Ověřte email',
},
      STEPS_ERROR_MESSAGE: {
        USER_ALREADY_EXIST_MESSAGE: 'Již registrovaný uživatel',
        USER_INVALID_ENTRY: 'Vstupní parametry nemohou být 0 ani prázdné.',
        GENERIC_ERROR_MESSAGE: 'Pokud požadovanou operaci nelze dokončit, kontaktujte svého správce.',
        USER_EMAIL_INVALID: 'Zadejte prosím platnou e-mailovou adresu.',
        VERIFICATION_CODE_EXPIRED_MESSAGE: 'Platnost kódu vypršela. Chcete-li požádat o další ověřovací e-mail, klikněte na tlačítko níže.',
},
      EULA: {
        LOADING: 'Načítání licenční smlouvy s koncovým uživatelem...',
        LANGUAGE: 'Vyberte prosím preferovaný jazyk',
        FRENCH: 'Français',
},
      FAILURE_MESSAGE: 'Nepodařilo se nám dokončit vaši registraci. Stisknutím tlačítka Pokračovat níže pokračujte do sady Eaton ELDigital',
      SUCCESS_MESSAGE: 'Váš účet byl úspěšně vytvořen pomocí e-mailu {{email}}.',
      SUCCESS_MESSAGE_OTHER_ADOPTER: 'Váš účet EL Digital byl úspěšně synchronizován s informacemi Bright Layer Cloud přidruženými k e-mailu <2>{{email}}</2>.',
},
    USER_INVITATION_REGISTRATION: {
      ACCEPT: 'Přijmout',
      DENY: 'Denny',
      INSTRUCTIONS: 'Pokud má tento e-mail účet u společnosti Eaton, obdržíte odpověď do <3>jednoho pracovního dne</3>.<br/><br/>V případě naléhavých problémů s účtem volejte',
      TITLE: 'Systém řízení bezpečnosti – pozvánka uživatele',
      INVITATION_VALIDATION_ERROR: 'Došlo k chybě s kódem pozvánky.',
},
    DASHBORAD: {
      ACCEPT_BUTTON: 'Přijměte pozvání',
      ACCEPT_HEADER: 'Přijmout pozvání?',
      ACCEPTED_INVITATION: 'Přijatá pozvání',
      ACCEPT_TITLE: 'Přijetím pozvánky se do vašeho profilu přidá následující položka:',
      ADD_NEW_ORGANIZATION: 'Přidat novou organizaci...',
      ADD_ANOTHER_ORGANIZATION: 'Přidat další organizaci',
      ALL_BUILDINGS: 'Všechny budovy',
      ALL_CITIES: 'Všechna města',
      ALL_COMPANIES: 'Všechny společnosti',
      ALL_COUNTRIES: 'Všechny země',
      ALL_CUSTOMER_ID: 'Všechna ID zákazníka',
      ALL_GATEWAYS: 'Všechny brány',
      ALL_ORGANIZATIONS: 'Všechny organizace',
      ALL_STATUSES: 'Stav všech',
      ALL_STATUS: 'Všechny stavy',
      ALL_TYPES: 'Všechny typy',
      BLOCKED: 'Blokováno',
      BUILD_DETAILS: 'Podrobnosti o budově',
      BUILDINGS: 'Budovy',
      CUSTOMERS: 'Zákazníci',
      DECLINE: 'Pokles',
      DECLINED_INVITATION: 'Odmítnuté pozvánky',
      DISPLAY_ADDRESS_ON_MAP: 'Zobrazit adresu na mapě',
      MAP_DRAG_TITLE: 'Špendlík umístěte přetažením na mapu',
      REQUEST_ACCESS_SENT: 'Uživateli byla odeslána e-mailová žádost o přístup',
      ERROR: 'Chyba',
      EVENT: 'Událost',
      EXPIRED_INVITATION: 'Platnost pozvánek vypršela',
      EXPORT_REPORT: 'Exportovat sestavu',
      GATEWAY: 'Brány',
      IN_ANOMALY: 'V anomálii',
      INFORMATION: 'Informace',
      INVITATION_HISTORY: 'Historie pozvánek',
      ISSUES: 'problémy',
      JOIN: 'Připojte se',
      LIST_VIEW: 'Zobrazení seznamu',
      MAP_VIEW: 'Zobrazení mapy',
      MONTHLY_REPORT: 'Měsíční zpráva',
      NO_ISSUES_DURING_THIS_PERIOD: 'Během tohoto období žádné problémy',
      ORG_DETAILS: 'Podrobnosti o organizaci',
      PENDING_INVITATION: 'Nevyřízené pozvánky',
      CHOOSE_REPORT_YOU_WOULD_LIKE_TO_SAVE_SHARE: 'Vyberte prosím zprávu, kterou chcete\nuložit nebo sdílet.',
      PLEASE_MAKE_A_SELECTIONS: 'Proveďte prosím výběr',
      REQUEST_SUBTITLE: 'Požádejte o přístup od osoby, která poslala pozvánku k přidání této položky do vašeho profilu.',
      INVITATION_BODY: 'Vyberte položky, které chcete přidat do svého profilu nebo odmítnout pozvánku.',
      READY: 'Připraveno',
      NO_CONTENT: 'Nahraďte tuto stránku svým vlastním obsahem',
      REPORTS: 'Zprávy',
      REQUEST_BUTTON: 'Žádost o přístup',
      REQUEST_HEADER: 'Požádat o přístup?',
      CHECK_INVITATIONS: 'Vyhledávání pozvánek...',
      SELECT_ALL: 'Vyberte Vše',
      SELECTIONS_CONFIRMED: 'Výběry potvrzeny',
      SERVICE_MANAGERS: 'Manažeři služeb',
      SYSTEMS: 'Systémy',
      TECHNICIANS: 'Technici',
      EMPTY_ACCEPTED_INVITATION: 'Momentálně nejsou žádné přijaté pozvánky',
      EMPTY_DECLINED_INVITATION: 'V tuto chvíli nejsou žádné odmítnuté pozvánky',
      EMPTY_EXPIRED_INVITATION: 'V tuto chvíli nejsou žádné pozvánky, jejichž platnost vypršela',
      EMPTY_REQUESTED_INVITATION: 'V tuto chvíli nejsou žádné požadované pozvánky',
      REQUEST_TITLE: 'Platnost této pozvánky vypršela a již ji nelze přidat do vašeho profilu.',
      TOTAL_ACCEPTED_INVITATIONS: 'Celkový počet přijatých pozvánek',
      TOTAL_LUMINAIRES: 'Celkem svítidel',
      TOTAL_SYSTEMS: 'Total Systems',
      UPDATING_PROFILE: 'Aktualizace vašeho profilu...',
      VIEW_ALL: 'Zobrazit vše',
      VIEW_ALL_ACCESS_RIGHTS: 'Zobrazit Naplno',
      VIEW_ALL_BUIDINGS: 'Zobrazit všechny budovy',
      VIEW_ALL_SYSTEM: 'Zobrazit všechny systémy',
      WARNING: 'Varování',
      INVITATION_SUB_HEADING: 'Byli jste pozváni do následujících projektů:',
      REPORTS_BUILDINGS: 'Budovy',
      REPORTS_SYSTEMS: 'Systémy',
      EMPTY_ZONE: 'Prázdný',
      TEST_ZONE: 'Test',
},
    TRANSFER_BUILDINGS: {
      PASSWORD: 'Heslo účtu',
      ERRORMESSAGE: 'Byly překročeny limity přihlášení. zkuste to prosím znovu po nějaké době',
      HEADER: 'Trvale převeďte všechny {{buildingCount}} budovy, včetně všech X bran a {{systemCount}} systémů pod nimi, do jiné organizace. Abyste mohli akci provést, musíte být správci organizace v obou organizacích.',
      ACTION: 'Pro potvrzení akce zadejte heslo svého účtu.',
      TRANSFER_TO: 'Přenést do…',
},
    MERGE_ASSETS: {
      PASSWORD: 'Heslo účtu',
      MERGE_DELETE: 'Sloučit a smazat',
      MERGE_ASSETS_TITLE: 'Sloučit aktiva do jiné budovy',
      SUCCESS: 'Sloučená aktiva budovy byla úspěšně sloučena',
      ACTION: 'Pro potvrzení akce zadejte heslo svého účtu.',
      HEADER: 'Přeneste všechny {{gatewayCount}} brány a {{systemCount}} systémy pod ní do jiné budovy a trvale smažte tu aktuální.',
      TRANSFER_TO: 'Přenést do...',
},
    DRAWER: {
      ACCOUNTPREFERENCES: 'Předvolby účtu',
      RIGHTS_RESERVED: 'Všechna práva vyhrazena',
      ASSETS: 'Aktiva',
      COPYRIGHT: 'Copyright © Eaton',
      DASHBOARD: 'Dashboard',
      OVERVIEW: 'Dashboard',
      DEVICES: 'Zařízení',
      HELP: 'Pomoc',
      HELPANDFEEDBACK: 'Nápověda a zpětná vazba',
      LEGAL: 'Právní',
      LOCATIONS: 'Místa',
      LOGBOOK: 'Deník',
      MAINTENANCE: 'Údržba',
      MANAGELOCATION: 'Správa umístění a webů',
      MANAGEUSER: 'Správa uživatelů',
      ORGSETTINGS: 'Moje organizace',
      MYPROFILE: 'Můj profil',
      REPORTS: 'Zprávy',
      ELDIGITAL: 'Systém řízení bezpečnosti',
      SELECT_ACCOUNT: 'Vyberte Účet',
      SETTINGS: 'Nastavení',
      TIMELINE: 'Časová osa',
      USERS: 'Uživatelé',
},
    SETTINGS: {
      TITLE: 'Předvolby účtu',
      SUBTITLE: 'Úroveň správce – uživatelé',
},
    NAVIGATION_DRAWER: {
      ACCOUNT_PREFERENCES: 'Předvolby účtu',
      ALL_RIGHTS_RESERVED: 'Všechna práva vyhrazena',
      CHANGE_PASSWORD: 'Změnit heslo',
      COPYRIGHT: 'Copyright',
      HELP_AND_FEEDBACK: 'Nápověda a zpětná vazba',
      LEGAL: 'Právní',
      LOGOUT: 'Odhlášení',
      PROJECT_SETTINGS: 'Moje organizace',
      REPORTS: 'Zprávy',
      USERS: 'Uživatelé',
},
    USER_MENU: {
      ACCOUNT_SETTING: 'Nastavení účtu',
      CONTACT_US: 'Kontaktujte nás',
      LOG_OUT: 'Odhlásit se',
},
    EVENT_DETAILS: {
      ACKNOWLEDGE: 'Potvrdit',
      ACKNOWLEDGED: 'Potvrzeno',
      ACKNOWLEDGE_BY: 'Potvrzeno přes {{user}} na',
      ACKNOWLWEGED_ERROR: 'Potvrzení se nezdařilo komunikovat s koncovým zařízením v {{errorDate}}. Pokud tento problém přetrvává, zavolejte našemu týmu podpory na číslo {{phoneno}} nebo napište e-mail',
      DEVICE_MODEL: 'Model zařízení',
      DEVICE_SERIAL: 'Sériové číslo zařízení',
      ERROR_LOADING_DEVICE_DETAILS: 'Chyba při načítání podrobností o zařízení',
      ERROR_LOADING_EVENT_DETAILS: 'Chyba při načítání podrobností události',
      TITLE: 'Podrobnosti o události',
      ALARM_STATUS: 'Počáteční stav alarmu',
      LAST_DATA_RECEIVED: 'Poslední aktualizace alarmu přijata',
      NO_DEVICE_DETAILS: 'Žádné podrobnosti o zařízení',
      NO_EVENT_DETAILS: 'Žádné podrobnosti o události',
      PLEASE_RETRY: 'Zkuste to znovu:',
      SENDING: 'Odesílání…',
      SET_POINT: 'Nastavená hodnota (práh)',
      THRESHOLD: 'Prahová hodnota',
      TIME_ALARM_SENT: 'Čas odeslání počátečního alarmu',
},
    USER_DETAIL: {
      ACTIVE: 'AKTIVNÍ',
      COMPANY_ADRESS: 'Adresa společnosti',
      COMPANY_DETAIL: 'Podrobnosti o společnosti',
      COMPANY_NAME: 'Název společnosti',
      COMPANY_PHONE_NUMBER: 'Telefonní číslo společnosti',
      EMAIL_ID: 'E-mailová adresa',
      INACTIVE: 'NEAKTIVNÍ',
      PERSONAL_ADRESS: 'pracovní titul',
      LEAVE_ORGANISATION: 'Opustit organizaci',
      JOB_TITLE: 'Osobní adresa',
      PERSONAL_PHONE_NUMBER: 'Osobní telefonní číslo',
      PHONE_NUMBER: 'Telefonní číslo',
      REMOVE_USER: 'Odebrat uživatele',
      USER_NAME: 'Uživatelské jméno',
},
    FILTER: {
      ACTIVE_LOGS_ONLY: 'Pouze aktivní protokoly',
      ALL: 'Vše',
      ALL_LOG_TYPES: 'Všechny typy protokolů',
      CUSTOM: 'Zvyk...',
      PAST_TWELVE_MONTHS: 'Posledních 12 měsíců',
      PAST_SIX_MONTHS: 'Posledních 6 měsíců',
      SINCE_THE_BEGINNING_OF_YEAR: 'Od začátku {{currentyear}}',
},
    LOGBOOK: {
      LOGBOOK_ACTIVELOG: 'Pouze aktivní protokoly',
      LOGBOOK_ALL: 'Vše',
      LOGBOOK_ALLLOG: 'Všechny typy protokolů',
      CUSTOM_LOGBOOK_RANGE: 'Vlastní sortiment deníku',
      CUSTOM: 'Zvyk...',
      END_DATE: 'Datum ukončení',
      LOGBOOK_GROUPBY: 'Seskupit podle:',
      PAST_TWELVE_MONTHS: 'Posledních 12 měsíců',
      PAST_SIX_MONTHS: 'Posledních 6 měsíců',
      FILTER_DOWNLOAD_TEXT: 'Pro stažení deníku použijte filtr.',
      LOGBOOK_SHOW: 'Zobrazit :',
      SINCE_THE_BEGINNING_OF_YEAR: 'Od začátku {{currentyear}}',
      START_DATE: 'Datum zahájení',
      LOGBOOK_TIME_RANGE: 'Časový rozsah:',
},
    BUILDING_DETAILS: {
      ADD_BUILDING: 'Přidat budovu do',
      ALL_SYSTEMS: 'Všechny systémy',
      VIEW_ALL_GATEWAYS: 'Zobrazit všechny brány',
},
    ADD_ORGANIZATION: {
      ORG_ADD_DESCRIPTION: 'Přidejte volitelné další komentáře, které pomohou vašemu servisnímu týmu.',
      ADDITIONAL_DESC: 'Další popis',
      ORG_ADD_BLDG_BELONGS: 'patří.',
      CREATE_ORGANIZATION_TITLE: 'Vytvořit organizaci',
      ORG_SUBTITLE: 'Vytvoření organizace vám umožní seskupovat budovy a koordinovat dohled nad EL Systems.',
      DETAILS_FOR: 'Podrobnosti pro',
      ORG_FOR: 'pro',
      INVALID_CHARACTER: 'Neplatný znak',
      ORG_NAMELENGTH: 'Pouze písmena(+), číslice(_), podtržítka a pomlčky(-)',
      ORG_ADD_BLDG: 'Nyní přidejte budovu, kde je',
      ORGANIZATION_CREATED: 'Organizace vytvořena',
      VALID_EMAIL_ERROR: 'Zadejte prosím platný e-mail',
      ORG_PRIMARYCONTACT: 'Primární kontakt',
      ORG_PROVIDED_DETAILS: 'Uveďte podrobnosti v případě, že je třeba xxx.',
      ORG_SECONDARYCONTACT: 'Sekundární kontakt (volitelné)',
      ORG_SKIPBUTTON: 'Prozatím přeskočit',
      ORG_SKIPMESSAGE: 'Přeskočte na vyplnění kontaktních údajů individuálně pro každou budovu.',
      ORG_SUCCESS: 'Organizace byla úspěšně vytvořena',
      ALPHABET_INPUT: 'Vezme abecedu jako vstup',
      ALPHANUMERIC_INPUT: 'Vezme alfanumerický jako vstup',
      ALPHANUMERIC_DASH_UNDERSCORE_INPUT: 'Jako vstup se použije alfanumerický, pomlčka, podtržítko',
      ORG_HELPTEXT: 'To pomáhá elektrikářům z Eatonu a dalším mimo vaši společnost rychle dorazit na místo.',
      ORGANIZATION_DETAILS: 'Na koho se mají elektrikáři obrátit',
},
    MANAGE_USERS: {
      ADVANCED_INVITE_USER_ORGANIZATION_SELECTION: 'Přidejte je do organizací:',
      INVITE_USER_ORGANIZATION_LABEL: 'Přidat do organizace... *',
      USER_ROLE_ADMIN: 'Admin',
      ADVANCED_INVITE_ADMIN: 'správce:',
      ADVANCED_INVITE: 'Pokročilá pozvánka',
      INVITE_USER_ADVANCE: 'Pokročolý…',
      INVITE_USER_AS: 'Jak',
      ADVANCED_INVITE_USER_SELECTION: 'Vyberte nového nebo stávajícího uživatele:',
      INVITE_USER_EMAIL_NAME: 'E-mail *',
      INVITE_USER_EMAIL: 'E-mail *',
      INVITE_USER_EMAIL_USER_NAME: 'Email nebo uživatelské jméno *',
      INVITE_USER_SUBTITLE: 'Udělte přístup novým nebo stávajícím uživatelům',
      ADVANCED_INVITE_SUBTITLE: 'Udělte přístup konkrétním organizacím, budovám a systémům.',
      ADVANCED_INVITE_ADMIN_DESCRIPTION: 'udělit plný přístup ke všemu v rámci přidělené úrovně.',
      ADVANCED_INVITE_LIMITED_DESCRIPTION: 'udělte minimální práva pro prohlížení, aby uživatel viděl pouze základní informace o tom, co je pro jeho roli kritické. To je užitečné, když někdo potřebuje sledovat pouze jeden systém v budově.',
      ADVANCED_INVITE_VIEWER_DESCRIPTION: 'udělte oprávnění ke sledování všemu v rámci přiřazené úrovně.',
      INVITATION_FAIL_HEADER: 'Platnost pozvánky vypršela',
      INVITE_USER_AS_COLLEAGUE: 'Pozvat jako kolegu',
      INVITE_USER: 'Pozvat uživatele',
      INVITE_SUCCESS_MESSAGE_SINGLE: 'Pozvali {{email}} do {{organization}}.',
      INVITE_SUCCESS_MESSAGE_MULTIPLE: 'Pozval(a) {{email}} do {{organizationCount}} organizací.',
      USER_ROLE_LIMITED: 'Omezený',
      ADVANCED_INVITE_LIMITED: 'Omezený:',
      MY_DETAILS_HEADER: 'Moje podrobnosti',
      OTHER_USER_LIST_HEADER: 'Ostatní uživatelé',
      ADVANCED_INVITE_PLEASE_ASSIGN_ROLES: 'Přidělte prosím role pro {{email}} přístup k organizacím, budovám a systémům.',
      REMOVE_USER: 'Odebrat {{name}} z „{{title}}“?',
      INVITATION_REQUEST_ACTION: 'Požádejte o další pozvánku',
      INVITE_USER_ORGANIZATION_SELECT_ALL: 'Vyberte Vše',
      INVITE_USER_SEND_INVITE: 'Odeslat pozvánku',
      INVITATION_FAIL_BODY: 'Platnost tohoto e-mailového odkazu s pozvánkou vypršela. Chcete-li získat další e-mailovou pozvánku, kontaktujte svého správce systému.',
      USERS_IN_HEADER: 'Uživatelé v',
      USER_ROLE_VIEWER: 'Prohlížeč',
      ADVANCED_INVITE_VIEWER: 'Prohlížeč:',
},
    ORGANIZATION_DETAILS: {
      ADDRESS: 'Adresa',
      BUILDING_DETAILS: 'Podrobnosti o budově',
      DELETE_FOREVER: 'Smazat navždy',
      EDIT_BUILDING: 'Upravit budovu',
      EDIT_ORGANIZATION: 'Upravit organizaci',
      EMAIL_ADDRESS: 'E-mailová adresa',
      MERGE_ASSETS: 'Sloučit aktiva do jiné budovy',
      ORGANIZATION: 'Organizace',
      ORGANIZATION_DETAILS: 'Podrobnosti o organizaci',
      PHONE_NUMBER: 'Telefonní číslo',
      PRIMARY_CONTACT: 'Primární kontakt',
      PRIMARY_CONTACT_EMAIL_ADDRESS: 'E-mailová adresa primárního kontaktu',
      PRIMARY_CONTACT_PHONE_NUMBER: 'Telefonní číslo primárního kontaktu',
      SECONDARY_CONTACT: 'Sekundární kontakt',
      SECONDARY_CONTACT_EMAIL_ADDRESS: 'Sekundární kontaktní e-mailová adresa',
      SECONDARY_CONTACT_PHONE_NUMBER: 'Sekundární kontaktní telefonní číslo',
      TRANSFER_BUILDINGS: 'Převeďte budovy do jiné organizace',
      USERS: 'Uživatelé',
},
    COMMON_INPUT: {
      COMMON_ADDRESS: 'Adresa',
      COMMON_ADDRESSLINE2: '2. řádek adresy (volitelné)',
      COMMON_BUILDINGNAME: 'Název budovy',
      COMMON_CITY: 'Město',
      COMMON_COUNTRY: 'Země',
      COMMON_OPTIONALDESC: 'Popis (volitelné)',
      COMMON_EMAIL_ADDRESS: 'E-mailová adresa',
      COMMON_NAME: 'Název organizace',
      COMMON_PHONENUMBER: 'Telefonní číslo',
      VALID_ADDRESS: 'Zadejte prosím platnou adresu',
      VALID_PHONE_ERROR: 'Zadejte prosím platné telefonní číslo',
      VALID_POSTAL_CODE: 'Zadejte prosím platné PSČ',
      VALID_CITY_ERROR: 'Zadejte prosím platné město',
      VALID_COMPANY_ERROR: 'Zadejte platnou společnost',
      VALID_FIRSTNAME_ERROR: 'Zadejte prosím platné křestní jméno',
      VALID_LASTNAME_ERROR: 'Zadejte prosím platné příjmení',
      VALID_VERIFICATION_CODE: 'Zadejte prosím platný ověřovací kód',
      COMMON_POSTALCODE: 'PSČ',
},
    TOAST_MSG: {
      CREATE_CUSTOMER_ERROR_CODE_9069: 'Adresa není platná nebo délka by měla být menší nebo rovna 250 znakům',
      CREATE_CUSTOMER_ERROR_CODE_9070: 'Adresa2 není platná nebo délka by měla být menší nebo rovna 250 znakům',
      INVITE_TECHNICIAN_ERROR_CODE_9130: 'K pozvání uživatele jsou vyžadována administrátorská práva',
      INVITE_USER_ERROR_CODE_9130: 'K pozvání uživatele jsou vyžadována administrátorská práva.',
      TOAST_ERROR_MERGE_ASSET_9213: 'Ke sloučení děl jsou vyžadována administrátorská práva',
      TOAST_SUCCESS_BUILDING_CREATE: 'Budova byla úspěšně vytvořena',
      BUILDING_LIST_API_FAILURE: 'Výpis budovy se nezdařil',
      BUILDING_TRANSFER_FAILURE: 'Při přenosu budovy došlo k chybě',
      BUILDING_TRANSFER_SUCCESS: 'Přenos budovy byl úspěšný',
      TOAST_SUCCESS_BUILDING_UPDATE: 'Budova byla úspěšně aktualizována',
      INVITE_USER_ERROR_CODE_9143: 'Nelze snížit roli uživatele.',
      CREATE_CUSTOMER_ERROR_CODE_9072: 'Město není platné nebo délka by měla být menší nebo rovna 50 znakům',
      CREATE_CUSTOMER_ERROR_CODE_9164: 'Komentář společnosti není platný nebo by délka měla být menší nebo rovna 255 znakům.',
      CREATE_CUSTOMER_ERROR_CODE_9040: 'Kód země společnosti není platný',
      CREATE_CUSTOMER_ERROR_CODE_9170: 'Název společnosti je již k dispozici.',
      CREATE_CUSTOMER_ERROR_CODE_9023: 'Telefonní číslo společnosti není platné nebo by mělo být mezi 8 a 10',
      CREATE_CUSTOMER_ERROR_CODE_9073: 'Kód země není platný nebo délka by měla být menší nebo rovna 4 znakům',
      CREATE_CUSTOMER_ERROR_CODE_9068: 'Země není platná nebo délka by měla být menší nebo rovna 50 znakům',
      CREATE_MAINTAINANCE_API_FAILURE: 'Vytvoření API údržby se nezdařilo',
      TOAST_SUCCESS_CUSTOMER_CREATED: 'Zákazník byl úspěšně vytvořen',
      CUSTOMER_DETAIL_SUCCESS: 'Podrobnosti zákazníka byly úspěšně načteny',
      TOAST_ERROR_GET_CUSTOMER_INFO: 'Načtení údajů o zákazníkovi se nezdařilo',
      CREATE_CUSTOMER_ERROR_CODE_9225: 'Zákaznické číslo je již k dispozici.',
      CREATE_CUSTOMER_ERROR_CODE_9172: 'Zákaznické číslo není platné nebo by mělo mít délku 8 až 16 znaků.',
      CREATE_MAINTAINANCE_ERROR_CODE_9078: 'Popis není platný nebo délka by měla být menší nebo rovna 255 znakům',
      DEVICE_LIST_API_FAILURE: 'Výpis zařízení se nezdařil',
      ACKNOWLEDGE_LOG_SUCCESS: 'Podrobnosti protokolu zařízení byly úspěšně potvrzeny',
      CREATE_CUSTOMER_ERROR_CODE_9043: 'E-mail není platný nebo by jeho délka měla být menší nebo rovna 75 znakům',
      INVITE_TECHNICIAN_ERROR_CODE_9043: 'E-mail není platný nebo by jeho délka měla být menší nebo rovna 75 znakům',
      INVITE_USER_ERROR_CODE_9043: 'E-mail není platný nebo by jeho délka měla být menší nebo rovna 75 znakům',
      INVITE_TECHNICIAN_ERROR_CODE_9136: 'Typ entity nebo role není platným vstupem nebo se neshoduje v typu entity a typu role',
      INVITE_USER_ERROR_CODE_9136: 'Typ entity nebo role není platným vstupem nebo se neshoduje v typu entity a typu role.',
      INVITE_TECHNICIAN_ERROR_CODE_9127: 'EntityId je duplicitní nebo neplatný vstup',
      INVITE_USER_ERROR_CODE_9127: 'EntityId je duplicitní nebo neplatný vstup',
      TOAST_ERROR_BUILDING_UPDATE: 'Aktualizaci budovy se nepodařilo provést',
      CREATE_MAINTAINANCE_ERROR_CODE_9219: 'Název souboru není platný nebo délka by měla být menší nebo rovna 50 znakům',
      TOAST_ERROR_GET_PASS_DETAILS: 'Získat podrobnosti PAAS API se nezdařilo',
      REMOVE_ACCESS_ERROR_CODE_3057: 'Neplatné ID entity. Uveďte prosím platné ID entity',
      REMOVE_ACCESS_ERROR_CODE_3059: 'Neplatný typ entity. Zadejte prosím platný typ entity',
      TOAST_ERROR_LINK_CUSTOMER_9203: 'Neplatný výčet SLA TYPE.',
      REMOVE_ACCESS_ERROR_CODE_2007: 'Neplatné ID uživatele, zadejte prosím platný GUID',
      INVITE_TECHNICIAN_ERROR_CODE_9159: 'Pozvat a pozvat uživatelem by neměly být stejné',
      INVITE_USER_ERROR_CODE_9159: 'Pozvat a pozvat uživatelem by neměly být stejné',
      UPDATE_LOG_COMMENTS_SUCCESS: 'Komentáře protokolu byly úspěšně aktualizovány',
      ACKNOWLEDGE_LOG_API_FAILURE: 'Potvrzení protokolů se nezdařilo',
      CREATE_MAINTAINANCE_SUCCESS: 'Činnost údržby byla úspěšně vytvořena',
      TOAST_ERROR_MERGE_ASSET_9214: 'Žádná aktiva ke sloučení',
      CREATE_MAINTAINANCE_ERROR_CODE_9221: 'Počet dokumentů by měl být menší nebo roven 3',
      TOAST_SUCCESS_ORG_CREATE: 'Organizace byla úspěšně vytvořena',
      TOAST_ERROR_ORG_UPDATE: 'Organizace se nezdařila',
      TOAST_SUCCESS_ORG_UPDATE: 'Organizace byla úspěšně aktualizována',
      CREATE_CUSTOMER_ERROR_CODE_9074: 'Telefonní číslo je neplatné nebo by mělo mít délku mezi 8 a 10.',
      TOAST_ERROR_MESSAGE: 'Před odesláním prosím řádně vyplňte všechny údaje',
      CREATE_MAINTAINANCE_ERROR_CODE_9220: 'Uveďte prosím platné ID uživatele přiřazeno technikovi',
      TOAST_ERROR_MERGE_ASSET_9048: 'Uveďte prosím platné ID budovy.',
      CREATE_CUSTOMER_ERROR_CODE_9167: 'Uveďte prosím platný typ kontaktu.',
      CREATE_MAINTAINANCE_ERROR_CODE_9185: 'Uveďte prosím platné číslo zákazníka',
      TOAST_ERROR_MERGE_ASSET_9210: 'Uveďte prosím platné ID cílové budovy.',
      CREATE_MAINTAINANCE_ERROR_CODE_9217: 'Uveďte prosím platný odkaz',
      CREATE_CUSTOMER_ERROR_CODE_9163: 'Zadejte prosím platný název nebo délka by měla být menší nebo rovna 24 znakům',
      CREATE_MAINTAINANCE_ERROR_CODE_9215: 'Zadejte prosím platný typ požadavku',
      CREATE_MAINTAINANCE_ERROR_CODE_9228: 'Uveďte prosím platné servisní datum',
      CREATE_MAINTAINANCE_ERROR_CODE_9216: 'Uveďte prosím platný typ služby',
      CREATE_MAINTAINANCE_ERROR_CODE_9050: 'Uveďte prosím platné ID systému',
      CREATE_CUSTOMER_ERROR_CODE_9071: 'Poštovní směrovací číslo není platné nebo by mělo mít délku 4 až 10 znaků',
      CREATE_CUSTOMER_ERROR_CODE_9165: 'Komentář primárního kontaktu není platný nebo by délka měla být menší nebo rovna 255 znakům.',
      CREATE_CUSTOMER_ERROR_CODE_9175: 'Primární kód země2 není platný nebo by délka měla být menší nebo rovna 4 znakům',
      CREATE_CUSTOMER_ERROR_CODE_9150: 'Primární křestní jméno není platné nebo by mělo mít délku 1 až 50 znaků',
      CREATE_CUSTOMER_ERROR_CODE_9151: 'Primární příjmení není platné nebo by mělo mít délku 1 až 50 znaků',
      CREATE_CUSTOMER_ERROR_CODE_9173: 'Primární telefon2 je neplatný nebo by délka měla být mezi 8 a 10.',
      REMOVE_ACCESS_SUCCESS: 'Odebrání uživatele bylo úspěšně dokončeno',
      TOAST_ERROR_MERGE_ASSET_9004: 'Požadovaná data nebyla nalezena',
      CREATE_CUSTOMER_ERROR_CODE_9166: 'Komentář sekundárního kontaktu není platný nebo délka by měla být menší nebo rovna 255 znakům.',
      CREATE_CUSTOMER_ERROR_CODE_9076: 'Sekundární kód země není platný nebo délka by měla být menší nebo rovna 4 znakům',
      CREATE_CUSTOMER_ERROR_CODE_9176: 'Sekundární kód země2 není platný nebo by délka měla být menší nebo rovna 4 znakům',
      CREATE_CUSTOMER_ERROR_CODE_9077: 'Sekundární e-mail není platný nebo by měl být kratší nebo roven 75 znakům',
      CREATE_CUSTOMER_ERROR_CODE_9152: 'Sekundární křestní jméno není platné nebo by mělo mít délku 1 až 50 znaků',
      CREATE_CUSTOMER_ERROR_CODE_9153: 'Sekundární příjmení není platné nebo by mělo mít délku 1 až 50 znaků',
      CREATE_CUSTOMER_ERROR_CODE_9147: 'Sekundární telefonní číslo je neplatné nebo by mělo mít délku mezi 8 a 10.',
      CREATE_CUSTOMER_ERROR_CODE_9174: 'Sekundární telefonní číslo2 je neplatné nebo délka by měla být mezi 8 a 10.',
      CREATE_MAINTAINANCE_ERROR_CODE_9009: 'Bezpečnostní token nesmí být prázdný ani prázdný',
      CREATE_MAINTAINANCE_ERROR_CODE_9222: 'K vytvoření činnosti údržby jsou vyžadována práva správce služeb',
      CREATE_MAINTAINANCE_ERROR_CODE_9162: 'Číslo SLA není platné nebo by mělo mít délku 6 až 12 znaků',
      INVITE_TECHNICIAN_ERROR_CODE_9158: 'Některé entity mají omezenou roli z pozvaných rolí',
      INVITE_USER_ERROR_CODE_9158: 'Některé entity mají omezenou roli z pozvaných rolí.',
      INVITE_TECHNICIAN_ERROR_CODE_9160: 'Některé entity mají v žádosti o pozvání omezenou roli',
      INVITE_USER_ERROR_CODE_9160: 'Některé entity mají v žádosti o pozvání omezenou roli.',
      TOAST_ERROR_MERGE_ASSET_9211: 'ID zdrojové a cílové budovy jsou stejné',
      TOAST_ERROR_MERGE_ASSET_9212: 'Budování zdroje a budování cíle nejsou pod stejnou organizací',
      TOAST_ERROR_LINK_CUSTOMER_9204: 'Systém je již propojen s platnou SLA',
      INVITE_USER_ERROR_CODE_9223: 'Aktuální uživatel může poslat pozvánku pouze normálnímu uživateli.',
      INVITE_USER_ERROR_CODE_9224: 'Aktuální uživatel nemůže poslat pozvánku správci služeb a správci PAAS.',
      CREATE_MAINTAINANCE_ERROR_CODE_9218: 'Dokument je větší než 2 MB nebo je duplicitní či neplatný ve formátu PDF, JPEG nebo PNG s kódováním Base64',
      REMOVE_ACCESS_ERROR_CODE_9001: 'Neoprávněný přístup',
      CREATE_CUSTOMER_ERROR_CODE_9001: 'Neoprávněný přístup',
      CREATE_MAINTAINANCE_ERROR_CODE_9001: 'Neoprávněný přístup',
      CREATE_CUSTOMER_ERROR_CODE_9000: 'Neoprávněný přístup k funkcím',
      UPDATE_LOG_COMMENTS_API_FAILURE: 'Aktualizace komentářů protokolu se nezdařila',
      REMOVE_ACCESS_ERROR_CODE_3060: 'Uživatel nemůže odebrat vlastní přístup',
      TOAST_ERROR_UPDATE_USER_DETAILS: 'Aktualizace podrobností uživatele se nezdařila',
      INVITE_USER_ERROR_CODE_9142: 'Uživatel byl pozván na stejnou roli.',
      INVITE_TECHNICIAN_SUCCESS: 'Pozvánka uživatele Odeslat úspěšně',
      TOAST_ERROR_MERGE_ASSET_9044: 'Heslo uživatele není platné nebo by mělo mít délku 8 až 16 znaků',
      INVITE_TECHNICIAN_ERROR_CODE_9190: 'Typ uživatelské role není platný vstup',
      INVITE_USER_ERROR_CODE_9190: 'Typ uživatelské role není platný vstup.',
      TOAST_SUCCESS_UPDATE_USER_DETAILS: 'Uživatel byl úspěšně aktualizován',
      UPDATE_MAINTAINANCE_SUCCESS: 'Činnost údržby byla úspěšně aktualizována',
      UPDATE_MAINTAINANCE_ERROR_CODE_9001: 'Neoprávněný přístup',
      UPDATE_MAINTAINANCE_ERROR_CODE_9009: 'Bezpečnostní token nesmí být prázdný ani prázdný',
      UPDATE_MAINTAINANCE_ERROR_CODE_9078: 'Popis není platný nebo délka by měla být menší nebo rovna 255 znakům.',
      UPDATE_MAINTAINANCE_ERROR_CODE_9222: 'K provedení této operace jsou vyžadována práva správce služeb nebo technika',
      UPDATE_MAINTAINANCE_ERROR_CODE_9227: 'Uveďte prosím platné ID údržby',
      UPDATE_MAINTAINANCE_ERROR_CODE_9245: 'Aktivita údržby již má stejný aktuální stav lístku, jaký byl požadován pro aktualizaci',
      UPDATE_MAINTAINANCE_ERROR_CODE_9246: 'Byl dosažen limit znovuotevření činnosti údržby',
      UPDATE_MAINTAINANCE_API_FAILURE: 'Aktualizace API údržby se nezdařila',
      TICKET_CLOSED_SUCCESS: 'Servisní lístek byl úspěšně uzavřen',
},
    MY_ORGANIZATION_DETAILS: {
      ADDRESS_Line1: 'Řádek adresy 1',
      ADMINS: 'Správci',
      DELETE_FOREVER: 'Smazat navždy',
      DESCRIPTION: 'Popis (volitelné)',
      EDIT_BUILDING: 'Upravit budovu',
      EDIT_ORGANIZATION: 'Upravit organizaci',
      NAME_DESCRIPTION: 'Název a popis',
      SAVE_ORGANIZATION: 'Uložit organizaci',
      TRANSFER_BULDING_ANOTHER_ORGANIZATION: 'Převeďte budovy do jiné organizace',
      VIEWER: 'Diváci',
},
    INVITE_USER: {
      ADMIN: 'Admin',
      ADVANCE_INVITATION: 'Pozvánka pro pokročilé',
      ADVANCE_INVITE: 'Pokročolý…',
      ADVANCE_INVITE_CLOSE: 'Opravdu chcete ukončit pokročilé pozvání?',
      AS_ADMIN: 'Jako správce',
      AS_VIEWER: 'Jako uživatel',
      BUILDING_ACCESS: 'Přístup do budovy',
      ENTER_USER_EMAIL: 'Email nebo uživatelské jméno',
      GRANT_ACCESS_HEADER: 'Udělte přístup novým nebo stávajícím uživatelům.',
      ADVANCE_DES_CONTENT: 'Udělte přístup uživatelům pro konkrétní přístup k organizacím, budovám a systémům.',
      GRANT_ADMIN_ACCESS: 'Udělte plný přístup ke všemu v rámci přidělené úrovně.',
      GRANT_VIEW_ACCESS: 'Udělte oprávnění ke sledování všemu v rámci přiřazené úrovně.',
      SEND_INVITE_FAILURE: 'Odeslání pozvánky se nezdařilo',
      SEND_INVITE_SUCCESS: 'Pozvánka byla úspěšně odeslána',
      INVITATION_ACCEPTED: 'Pozvánka byla úspěšně přijata.',
      INVITATION_DENIED: 'Pozvánka byla úspěšně zamítnuta.',
      INVITE_AND_ASSIGN: 'Pozvat a přiřadit',
      INVITE_AS_COLLEGUE: 'Pozvat jako kolegu',
      INVITE_USER: 'Pozvat uživatele',
      LIMITED: 'Omezený',
      GRANT_LIMITED_ACCESS: 'Minimální oprávnění, to je užitečné pro uživatele, který potřebuje sledovat pouze jeden systém v budově.',
      NOBUILDING_AVAILABLE: 'Nejsou k dispozici žádné budovy',
      NOSYSTEMS_AVAILABLE: 'Žádné dostupné systémy',
      ORGANIZATION_ACCESS: 'Přístup organizace',
      SELECT_ORGANIZATION: 'Vyberte organizaci',
      PRIVILEGES: 'privilegia',
      RECEIVED: 'Přijato',
      SEND_INVITE: 'Odeslat pozvánku',
      SENT_BY: 'Odeslal',
      SYSTEM_ACCESS: 'Systémový přístup',
      VIEWER: 'Prohlížeč',
      ERROR_MESSAGE: 'Vaše žádost se nezdařila',
},
    DISCLAMIER: {
      OVERVIEW: 'Alarm Count představuje všechny aktivní alarmy',
      TIMELINE: 'Zobrazené alarmy představují všechny alarmy za posledních 90 dní',
},
    LUMINARY_DETAILS: {
      ALL_ATSD: 'Všechny ATSD',
      ALL_CIRCUIT: 'Celý okruh',
      ALL_STATUSES: 'Všechny stavy',
      ATSD: 'ATSD #',
      CIRCUIT: 'Obvod',
      LUMINAIRE_ADDRESS: 'Adresa svítidla',
      MODEL: 'Model',
      TYPE: 'Typ',
      TESTS: 'Testy',
      CIRCUIT_TITLE: 'Okruh č.',
      DURATION_TEST_DURATION: 'Délka testu provozu na baterie',
      PREVIOUS_DURATION_TEST_STARTED: 'Předchozí test trvání byl zahájen',
      PREVIOUS_FUNCTIONAL_TEST_STARTED: 'Byl zahájen předchozí funkční test',
},
    SEARCH: {
      ALL_BUILDINGS: 'Všechny budovy',
      ALL_GATEWAYS: 'Všechny brány',
      ALL_ORGANIZATIONS: 'Všechny organizace',
      ALL_STATUSES: 'Všechny stavy',
      ALL_SYSTEMS: 'Všechny systémy',
      ALL_TYPES: 'Všechny typy',
},
    CUSTOMER_DETAILS: {
      ALL_USERS: 'Všichni uživatelé',
      DELETE_SLA: 'Opravdu chcete smazat smlouvu SLA?',
      BACK_UP_PHONE: 'Záložní telefon',
      BUYER_HEADER: 'Kupující',
      BUYER: 'Kupující',
      CONTACT_TYPE: 'Typ kontaktu',
      CONTACT_PERSON_ON_SITE: 'Kontaktní osobaNa místě',
      CUSTOMER_HEADER_SUBTITLE: 'Zákazník',
      CUSTOMER_ID: 'ID zákazníka',
      CUSTOMER_NAME: 'Jméno zákazníka',
      CUSTOMER_DETAILS_HEADER: 'Jméno a adresa zákazníka',
      CUSTOMER_NAME_LABEL: 'Jméno nebo číslo zákazníka',
      CUSTOMER_NUMBER: 'Zákaznické číslo',
      DELETE_CUSTOMER: 'Smazat zákazníka',
      LUMINARY_INFO: 'Zahrnuje tato smlouva monitorování svítidel?',
      EDIT_CUSTOMER_INFO: 'Upravit informace o zákazníkovi',
      CREATE_CUSTOMER_HEADER: 'Upravit informace o zákazníkovi',
      EDIT_PLATFORM_INFO: 'Upravit informace o platformě',
      EDIT_SLA_DETAILS: '-',
      EXPIRES: 'Platnost vyprší',
      IMAGES: 'Obrázky',
      INCLUDE_LUM_MONITORING: 'Zahrnout monitorování svítidel',
      SLA_DETAILS_TEXT: 'Včetně monitorování svítidel',
      CALENDAR_HELPER_TEXT: 'mm/dd/rrrr',
      MOBILE_NUMBER: 'Mobilní číslo',
      LUMINARY_MONITORING_NO: 'Žádný',
      NO_CUSTOMER_FOUND: 'Nebyl nalezen žádný zákazník',
      NO_SERVICE_MANAGER_FOUND: 'Nebyl nalezen žádný správce služeb',
      NO_TECHNICIAN_FOUND: 'Nebyl nalezen žádný technik',
      CUSTOMER_NUMBER_HELPER_TEXT: 'Pouze abecedy a čísla',
      SLA_NUMBER_HELPER_TEXT: 'Pouze abecedy a čísla',
      OFFICE_NUMBER: 'Číslo kanceláře',
      IMAGE_REQUIREMENTS: 'PNG, JPG (100x100px), 2 MB Max.',
      PHONE_NUMBERS_HEADER: 'Primární a záložní telefonní čísla',
      PRIMARY_CONTACT_INFO: 'Primární kontaktní informace',
      PROJECT_LEAD: 'ProjectLead',
      REMOVE_IMAGE: 'Odebrat obrázek',
      SECONDARY_CONTACT_INFO: 'Sekundární kontaktní informace',
      FILE_RESOLUTION_ERROR: 'Vybraný soubor neodpovídá našemu požadovanému rozlišení',
      FILE_SIZE_ERROR: 'Vybraná velikost souboru překračuje maximální povolenou velikost souboru',
      SERVICE_MANAGER: 'Správce služeb',
      SLA_CUSTOMER_NUMBER: 'Zákaznické číslo SLA',
      SLA_DETAILS_HEADER: 'Podrobnosti SLA',
      SLA_EXPIRATION_DATE: 'Datum vypršení platnosti smlouvy SLA',
      TECH_LEAD_HEADER: 'Technické vedení',
      TECHNICAL_PERSON: 'Technická osoba',
      UPLOAD_AVATAR_LOGO: 'Nahrajte logo avatara',
      LUMINARY_MONITORING_YES: 'Ano',
      REQUIRED_FIELD_MESSAGE: 'Pole s hvězdičkou (*) jsou povinná',
},
    USER_MANAGEMENT: {
      ALL_USERS: 'Všichni uživatelé',
      INVITE_USER: 'Pozvat uživatele',
      YOUR_DETAILS: 'Vaše údaje',
},
    USERDETAILS: {
      DELETE_USER_SUBHEADER: 'Všechna vaše uživatelská data budou trvale ztracena.',
      RESET_PASSWORD_ERROR: 'V tuto chvíli nelze obnovit heslo.',
      DELETE_USER_BUTTON_TEXT: 'Smazat účet navždy',
      DELETE_USER_FAILURE_MSG: 'Smazání se nezdařilo, zkuste to za chvíli',
      DELETE_USER_POP_UP_HEADER: 'Trvale smazat účet „{{email}}“?',
      RESET_PASSWORD_SUCCESS: 'E-mail pro resetování hesla byl úspěšně odeslán.',
      EDIT_SUCCESS: 'Uživatel byl úspěšně aktualizován',
      DELETE_USER_SUCCESS_MSG: 'Váš účet byl úspěšně smazán',
},
    ATPLUS_LOGBOOK_EVENTNAME: {
      MAXIMUM_LOGIN_ATTEMPTS_EXCEDDED: 'Překročeny povolené pokusy o přihlášení',
      BATTERY_CHARGE_FAILURE: 'Bylo zjištěno selhání nabíjení baterie',
      BATTERY_DURATION_FAILURE: 'Bylo zjištěno selhání výdrže baterie',
      TLAT_PLUS_BATTERY_FAILURE: 'Selhání baterie',
      TLAT_PLUS_BATTERY_LOW: 'Baterie je vybitá',
      COMMUNICATION_FAILURE: 'Zjištěno selhání komunikace',
      DRY_CONTACT_INPUT: 'Vstup suchého kontaktu aktivován',
      DRY_CONTACT_OUTPUT: 'Výstup suchého kontaktu aktivován',
      MANUAL_DURATION_TEST: 'Začal test provozu z baterií',
      MANUAL_DURATION_TEST_CANCELED: 'Test provozu z baterií zastaven',
      FACTORY_RESET: 'Obnovení továrního nastavení',
      FAILURE_THRESHOLD_EXCEEDED: 'Překročena prahová hodnota selhání',
      FIRMWARE_UPDATE_FAILURE: 'Aktualizace firmwaru se nezdařila',
      FIRMWARE_UPDATE_SUCCESS: 'Aktualizace firmwaru úspěšná',
      MANUAL_FUNCTION_TEST: 'Funkční test zahájen',
      MODBUS_COMMUNICATION_FAILURE: 'Selhání komunikace brány',
      UART_COMMUNICATION_FAILURE: 'Vnitřní selhání',
      LAMP_FAILURE: 'Bylo zjištěno selhání lampy',
      LOCAL_MAIN_FAILURE: 'Místní porucha sítě',
      PASSWORD_CHANGE: 'Změna hesla',
      PASSWORD_RESET: 'Obnovení hesla',
      MANUAL_RELIGHT_COMMAND: 'Opětovné osvětlení aktivováno',
      MANUAL_REST_COMMAND: 'Odpočinek aktivován',
      SEARCH_ALL_LAMP_COMPLETED: 'Hledání všech lamp dokončeno',
      SEARCH_NEW_LAMP_COMPLETED: 'Hledání nové lampy dokončeno',
      MANUAL_SYNCHRONIZE_TEST_TIME_COMMAND: 'Synchronizujte testovací časy',
      ACTIVATION: 'Aktivace systému dokončena',
      SYSTEM_POWER_DOWN: 'Vypnutí systému',
      SYSTEM_POWER_UP: 'Zapnutí systému',
      DATALINE_FAILURE: 'Selhání komunikační linky TLAT+',
      MANUAL_START_VISIBILITY_PLUS: 'Viditelnost + Spuštěno',
      MANUAL_STOP_VISIBILITY_PLUS: 'Viditelnost + Zastaveno',
},
    MY_ORGANIZATION: {
      ALPHABET: 'Abeceda',
      CITY: 'Město',
      NUMBER_SYSTEM: 'Počet systémů',
},
    FIRMWARE_UPDATE: {
      FIRMWARE_UPDATE_ALERT_TITILE: 'Opravdu chcete Konec?',
      CURRENT_VERSION: 'Aktuální verze',
      FIRMWARE_ALREADY_UPDATED: 'Firmware již aktualizován',
      FIRMWARE_UPDATE_FAILED_TITLE: 'Aktualizace firmwaru se nezdařila',
      FIRMWARE_PROGRESS_MSG: 'Probíhá aktualizace firmwaru...',
      FIRMWARE_UPDATE_ALERT_SUB_TITILE: 'Aktualizace firmwaru stále probíhá. Chcete přejít na hlavní panel?',
      FIRMWARE_UPDATE_FAILED: 'Proces aktualizace firmwaru se nezdařil. Zkuste to prosím znovu.',
      FIRMWARE_VERSION_UPDATED: 'upgrade firmwaru byl úspěšně dokončen',
      FIRMWARE_ALREADY_UPDATED_TEXT: 'Verze firmwaru je již aktualizována na nejnovější verzi',
      FIRMWARE_NOT_AVAILABLE: 'Verze firmwaru nebyla správně načtena. Odhlaste se z mobilní aplikace a přihlaste se a zkuste to znovu.',
      LATEST_VERSION: 'Nejnovější verze',
      LOST_BLUETOOTH_CONNECTION: 'Ztratilo se připojení Bluetooth',
      ENTRY_PASSWORD: 'Zadejte systémové heslo pro',
      RELEASED_ON: 'Vydáno dne',
      SELECT_FIRMWARE_VERSION: 'Vyberte verzi firmwaru',
      SELECT_A_VERSION: 'Vyberte verzi',
      UPDATE_TO_LATEST: 'Aktualizovat na nejnovější',
      UPLOAD_FILE: 'Nahrát soubor',
      FIRMWARE_UPDATE_TITILE: 'Doporučujeme aktualizovat\nfirmware na nejnovější verzi.',
      FIRMWARE_UPDATEPOPUP_MSG: 'Již nejste připojeni k',
},
    ASSETS: {
      ASSETS_DETAILS: 'Podrobnosti o aktivech',
},
    SYSTEM_TYPE: {
      ATPLUS: 'AT+',
      CGLINE: 'CGLine+',
      DGS: 'DG-S',
      LPSMART: 'LPSmart',
      LPSTAR: 'LPStar',
      WIRELESS: 'Bezdrátový',
      ZBS: 'ZBS',
      ATS_PLUS: 'AT-S+',
      GATEWAY: 'Brána',
},
    DEVICE_TYPE_VALUE: {
      AT: 'AT+',
      ATS: 'AT-S+',
      CGLINE: 'CGLINE',
      DGS: 'DG-S',
      LPSMART: 'LP-SMART',
      LPSTAR: 'LP-STAR',
      WIRELESS: 'BEZDRÁTOVÝ',
      ZBS: 'ZB-S',
      ATSPLUS: 'AT+',
},
    CONTROLLER_TYPE_VALUE: {
      AT: 'AT+',
      CGLINE_PLUS: 'CGLINE+',
      DGS: 'DG-S',
      LP_SMART: 'LP-SMART',
      LP_STAR: 'LP-STAR',
      WIRELESS: 'BEZDRÁTOVÝ',
      ZBS: 'ZBS',
},
    ACTIONS: {
      BACK: 'Zpět',
      CANCEL: 'Zrušit',
      CHANGE_LANGUAGE: 'Změňte jazyk zde!',
      CLICK_BUTTON: 'Klepněte na tlačítko',
      UPDATE_REDUX: 'Kliknutím na tlačítko aktualizujte hodnotu redux store!',
      CONFIRM: 'Potvrdit',
      CONTINUE: 'Pokračovat',
      DELETE: 'Vymazat',
      RESEND_VERIFICATION_EMAIL_LABEL: 'Neobdrželi jste e-mail?',
      DISABLE: 'Zakázat',
      DONE: 'Hotovo',
      DOWNLOAD_DATA: 'Datum stažení',
      EDIT: 'Upravit',
      ENABLE: 'Umožnit',
      EXTEND: 'Rozšířit',
      FINISH: 'Dokončit',
      GO_HOME: 'Přejít na domovskou stránku',
      GO_TO_DASHBOARD: 'Přejít na můj řídicí panel',
      GO_TEST: 'Přejděte na testovací stránku',
      LOG_IN: 'Přihlaste se',
      LOG_OUT: 'Odhlásit se',
      NEXT: 'Další',
      OKAY: 'Dobře',
      QUIT: 'Přestat',
      REMEMBER: 'Pamatuj si mě',
      RETRY: 'Zkuste to znovu',
      SAVE: 'Uložit',
      SAVE_ADD_ANOTHER: 'Uložte a přidejte další',
      SEND: 'Poslat',
      RESEND: 'Odeslat znovu',
      RESEND_VERIFICATION_EMAIL: 'Odeslat znovu',
      SUBMIT: 'Předložit',
      SUBMITCHANGES: 'Odeslat změny',
      TRANSFER: 'Převod',
      UPDATE: 'Aktualizovat',
},
    NETWORK: {
      BAD_REQUEST_MESSAGE: 'Špatný požadavek',
      INTERNAL_SERVER_ERROR_MESSAGE: 'Interní chyba serveru',
      NO_DATA_FOUND: 'Nebyla nalezena žádná data',
      REQUEST_NOT_FOUND_MESSAGE: 'Nenalezeno',
      ERROR_INTERNET_CONNECTION: 'Zdá se, že jste mimo připojení k internetu a zkuste to znovu.',
      SERVICE_UNAVAILABLE: 'Služba není k dispozici',
      ERROR_NO_RESPONSE: 'Něco se pokazilo',
      ERROR_MESSAGE_SENDING_REQUEST: 'Omlouváme se, při odesílání vašeho požadavku došlo k problému.',
      ERROR_INVALID_REQUEST: 'Je nám líto, váš požadavek je neplatný.',
      NETWORK_ALERT_SUBTITILE: 'Dashboard není k dispozici\nprotože už nejste připojeni\nna internet',
      ERROR_NOT_FOUND: 'Zdroj nebyl nalezen.',
      ERROR_ALERT_TITLTE: 'Nelze připojit Dashboard',
      UNAUTHORISED_REQUEST_MESSAGE: 'Unauthorized – Autorizace byla pro tento požadavek zamítnuta',
      ERROR_RESTRICTED_USER_ACCESS: 'Uživatel nemá přístup ke zdroji.',
},
    CONNECTION_TYPE_VALUE: {
      BLE: 'BLE',
      BLUETOOTH: 'bluetooth',
      CELLULAR: 'Mobilní síť',
      ETHERNET: 'Ethernet',
      MODBUS: 'Modbus',
      MQTT: 'MQTT',
      RS485: 'RS485',
      WIFI: 'Wifi',
      WIREPAS: 'Wirepas',
},
    STATUS: {
      STATUS_BLOCK: 'Blokováno',
      BLOCKED: 'Blokováno',
      STATUS_EMPTY: 'Prázdný',
      STATUS_ERROR: 'Chyba',
      ERROR: 'Chyba',
      EVENT: 'Událost',
      DT: 'V DT',
      STATUS_DT: 'V testu',
      INTEST: 'V testu',
      STATUS_OFFLINE: 'Offline',
      STATUS_READY: 'Připraveno',
      READY: 'Připraveno',
      TOTAL_LUMINAIRES: 'Celkem svítidel',
      TOTAL_SYSTEM: 'Total Systems',
      STATUS_WARNING: 'Varování',
      WARNING: 'Varování',
},
    UNSUPPORTED_BROWSER: {
      NOT_SUPPORTED: 'Prohlížeč není podporován',
      INCOMPATIBLE_BROWSER: 'Tato webová aplikace není kompatibilní s vaším aktuálním prohlížečem.',
      RECOMMENDED_BROWSER: 'Pro použití tohoto nástroje doporučujeme upgradovat na nejnovější verzi Microsoft Edge, Safari, Firefox nebo Chrome.',
},
    ENTITY_TYPE: {
      BUILDING: 'Budova',
      DEVICE: 'Zařízení',
      DEVICE_TYPE: 'Typ zařízení',
      GATEWAY: 'Brána',
      LUMINARY: 'Světelný',
      MASTER_ROLE: 'Role mistra',
      ORGANIZATION: 'Organizace',
      ORGANIZATION_STATISTIC_DETAIL: 'Statistický detail organizace',
      PLATFORM: 'Platforma',
      SYSTEM: 'Systém',
      USER: 'Uživatel',
},
    LOGSOURSE_DEVICE_TYPE: {
      BUILDING: 'Budova',
      DEVICE: 'Zařízení',
      DEVICETYPE: 'DeviceType',
      GATEWAY: 'Brána',
      LUMINARY: 'Světelný',
      MASTERROLE: 'MasterRole',
      ORGANIZATION: 'Organizace',
      ORGANIZATIONSTATISTICALDETAIL: 'Statistické detaily organizace',
      SYSTEM: 'Systém',
      USER: 'Uživatel',
},
    TECHNICIAN_DETAILS: {
      BUILD_ADMIN: 'Správce budovy',
      BUILD_VIEWER: 'Prohlížeč budov',
      CUST_VIEWER: 'Klientský uživatel',
      INDIVIDUAL_DETAILS: 'Individuální detaily',
      LIMT_ACCESS: 'Omezený přístup',
      ORG_ADMIN: 'Správce organizace',
      ORG_VIEWER: 'Prohlížeč organizace',
      PASS_SERVICE_MANAGER: 'Pass Service Manager',
      PROJ_OWNER: 'Vlastník projektu',
      REMOVE_USER: 'Odebrat uživatele',
      SERVICE_MANAGER: 'Správce služeb',
      SYSTM_ADMIN: 'Správce systému',
      SYSTM_VIEWER: 'Prohlížeč systému',
      TECHNICIAN: 'Technik',
      USER_DETAILS: 'Podrobnosti o uživateli',
      COMPANY_DETAILS: 'Podrobnosti o společnosti',
      COMPANY: 'Společnost',
      STATUS: 'Postavení',
},
    TRANSFER_BUILDING_TO_ORGANIZATION: {
      TRANSFER_SUCCESS: 'Budova byla úspěšně převedena na jinou organizaci',
      CONFIRM_PASSWORD: 'Potvrďte heslo',
      INSTRUCTIONS: 'Trvale převeďte všechny {{buildingCount}} budovy včetně všech {{systemCount}} bran a {{gatewayCount}} systémů.',
      ORG_SELECT: 'Vyberte prosím platnou organizaci',
      INSTRUCTION_TWO: 'Potvrďte akci zadáním hesla svého účtu správce organizace',
      TRANSFER: 'Převod',
      HEADER_TITLE: 'Převést budovu do jiné organizace \n \n Organizace',
      DROPDOWN_LABEL: 'Přenést do...',
},
    CHANGE_PASSWORD_SCREEN: {
      CHANGE_PASSWORD: 'Změnit heslo',
      CONFIRM_PASSWORD: 'Potvrďte heslo',
      NEW_PASSWORD: 'Nové heslo',
},
    MESSAGES: {
      CONGRATS: 'Gratuluji!',
      CONTACT: 'Kontaktujte zástupce podpory Eaton',
      EMAIL_SENT: 'Email odeslán',
      ERROR: 'Chyba!',
      FAILURE: 'Chyba',
      LOADING: 'Načítání...',
      EMAIL_ENTRY_ERROR: 'Zadejte prosím platný e-mail',
      SUCCESS: 'Úspěch',
      WELCOME: 'Vítejte!',
      LOGIN_MESSAGE: 'Jste „přihlášeni“.',
},
    LANDING_SCREEN: {
      CONNECT_NOW: 'Připojte se nyní',
      CONNECT_TO_SYSTEM: 'Připojit k systémům',
      CONTINUE_TO_DASHBOARD: 'Pokračujte na Dashboard',
      DASHBOARD_UNAVAILABLE: 'Dashboard nedostupný',
      NO_INTERNET_CONNECTION: 'Žádné připojení k internetu',
      VIEW_DASHBOARD: 'Zobrazit řídicí panel',
      IN_PROGRESS: 'Probíhající práce...',
},
    USERS: {
      CREATE_NEW_CUSTOMER: 'Vytvořit nového zákazníka',
      EDIT_PLATFORM_HEADER: 'Upravit platformu',
      EDIT_PLATFORM_SUCCESS_200: 'Platforma byla úspěšně aktualizována',
      LOADER_HELPER_TEXT: 'Čekejte prosím',
      MANAGE_PLATFORM_ERROR_CODE_3047: 'Main Service Manager není registrován v BSMS. Nelze vytvořit platformu',
},
    LABELS: {
      CSV: 'CSV',
      EMAIL: 'E-mailová adresa',
      EXCEL: 'Soubor Excel',
      FORGOT_PASSWORD: 'Zapomněli jste heslo?',
      GROUP_BY: 'Seskupit podle:',
      ITEMS_PER_PAGE: 'Položky na stránku',
      LOGGING_IN: 'Přihlašování',
      NEED_ACCOUNT: 'Potřebujete účet?',
      NEW_PASSWORD: 'Nové heslo',
      PASSWORD: 'Heslo',
      PDF: 'PDF',
      SHOW: 'Show:',
      SIGN_UP: 'Zaregistrujte se',
      TIME_RANGE: 'Časový rozsah:',
      TO_BE_IMPLEMENTED: 'K provedení',
      VIEW_ALL_EVENTS: 'Zobrazit všechny {{count}} události',
      SIGN_IN_WITH_OKTA: 'Přihlaste se pomocí Okta',
},
    AUTO_LOGOUT_DISABLED: {
      AUTO_LOGOUT_DISABLED: 'Zakázáno',
},
    TIMELINE_EXPORT: {
      DOWNLOAD_TITLE: 'Stáhnout datum časové osy',
      DOWNLOAD_SUBTITLE_SITE: 'Vyberte časové období historie alarmů, které chcete exportovat.',
      DOWNLOAD_SUBTITLE_TIMELINE: 'Vyberte umístění a časové období historie alarmů, které chcete exportovat.',
},
    AUTO_LOGOUT_ENABLED: {
      AUTO_LOGOUT_ENABLED: 'Povoleno (doporučeno)',
},
    LEAGAL: {
      END_USER_AGREEMENT: 'Smlouva s koncovým uživatelem',
      LICENCE_AGREEMENT: 'Licenční smlouva s koncovým uživatelem',
      LEAGAL: 'Právní',
      MANUALS: 'PŘÍRUČKY',
      OPEN_SOURCE: 'Open Source licence',
      INSTRUCTION_EATON_BSMS_GATEWAY: 'Návod k obsluze Eaton BSMS Gateway',
      QUICK_START_GUIDE: 'Rychlý průvodce',
      REMOTE_MONITORING_GUIDE: 'Průvodce vzdáleného monitorování',
      TERMS_CONDITIONS: 'Smluvní podmínky',
},
    LEGAL: {
      EULA: 'Licenční smlouva s koncovým uživatelem',
      TITLE: 'Právní',
      OPENSOURCELICENSES: 'Open Source licence',
      TERMSANDCONDITIONS: 'Smluvní podmínky',
      REACT_NATIVE: 'Reagovat Native',
      EULA_WIRELESS: 'EULA - Eaton Wireless Controller',
      OSS: 'Open source licensing - Eaton Wireless Controller',
      OPEN_SOURCE_BSM: 'Open source licensing - Building Safety Manager',
},
    EVENT_TIMELINE: {
      ERROR_LOADING_MORE_EVENTS: 'Chyba při načítání dalších událostí',
      LOAD_MORE_EVENTS: 'Načíst {{count}} dalších událostí',
},
    ASSETS_SCREEN: {
      FAVORITE_LIMIT_REACHED: 'Oblíbený limit dosažen',
      NOBUILDINGFOUND: 'Nebyly nalezeny žádné budovy',
      NOGATEWAYFOUND: 'Nebyly nalezeny žádné brány',
      NOORGANIZATIONFOUND: 'Nebyla nalezena žádná organizace',
      NOREPORTFOUND: 'Nebyly nalezeny žádné zprávy',
      NOSYSTEMS: 'Nebyly nalezeny žádné systémy',
      OTHERS: 'OSTATNÍ',
      SHOW_ONLY_STARRED_BUILDING: 'Zobrazit pouze budovy označené hvězdičkou',
      STARRED: 'S HVĚZDIČKOU',
      MARK_AS_FAV_API_SUCCESS: 'Úspěšně přidáno do oblíbených',
      REMOVE_MARK_AS_FAV_API_SUCCESS: 'Úspěšně odebráno z oblíbených',
      MARK_AS_FAV_API_FAILURE_MESSAGE: 'Před přidáním nových prosím odeberte některé ze svých stávajících oblíbených, protože maximální limit je 10',
},
    ADDLOCATION: {
      ASTERIKSINFO: 'Pole označená hvězdičkou (*) jsou povinná pole {{entity}}.',
      ADDLOCATIONINFORMATION: 'Informace o profilu umístění',
},
    HEADER: {
      FORGOT_PASSWORD: 'Zapomenuté heslo',
},
    LOGIN: {
      INVALID_CREDENTIALS: 'Vaše kombinace uživatelského jména a hesla nebyla rozpoznána.',
      GENERIC_ERROR: 'Váš požadavek v tuto chvíli nelze zpracovat.',
      UNAUTHORIZED_ACCESS: 'Neoprávněný přístup',
      UNAUTHORIZED_ACCESS_MESSAGE: 'Nemáte oprávnění k přístupu k této aplikaci. Prosím zaregistrujte se',
},
    TABS: {
      LIST_VIEW: 'Zobrazení seznamu',
      SUMMARY_VIEW: 'Souhrnný pohled',
},
    NAVIGATION_TABS: {
      LOGBOOK: 'DENÍK',
      STATUS: 'POSTAVENÍ',
},
    HELPANDFEEDBACK: {
      MANUALS: 'Příručky',
      TITLE: 'Návod k obsluze Eaton BSMS Gateway',
},
    OPERATING_SYSTEM_THEME: {
      OPERATING_SYSTEM_THEME: 'Téma operačního systému',
},
    EULA: {
      OTHER_LANGUAGE: 'Jiný jazyk EULA',
},
    LOCATIONS: {
      SITES: 'Weby',
},
    COUNTER: 'Hodnota je: {{count}}',
    RESPONSE: {
      USER_REGISTERED: 'Uživatel může být registrován',
},
    PASSWORD_RESET: {
      SUCCESS_MESSAGE: 'Vaše heslo bylo úspěšně resetováno.',
      FAILURE_MESSAGE: 'Vaše heslo se nepodařilo obnovit. Zkuste to znovu později.',
},
    LICENCE: {
       LICENCE_AGREEMENT: 'Licenční smlouva',
      OPEN_SOURCE: 'Open Source licence',
      REACT_NATIVE_LICENCE: {
        MIT_LICENSE: 'Licence MIT',
        COPYRIGHT_TEXT: 'Copyright (c) Facebook, Inc. a její přidružené společnosti.',
        MIT_LICENSE_TEXT: 'Tímto se bezplatně uděluje povolení jakékoli osobě, která získá kopii tohoto softwaru a souvisejících souborů dokumentace ("Software"), nakládat se Softwarem bez omezení, včetně, bez omezení, práv používat, kopírovat, upravovat, slučovat, publikovat, distribuovat, udělovat sublicence a/nebo prodávat kopie Softwaru a umožnit osobám, kterým je Software poskytnut, aby tak činily, za následujících podmínek:',
        MIT_LICENSE_TEXT_ONE: 'Výše uvedené upozornění na autorská práva a toto upozornění na povolení budou součástí všech kopií nebo podstatných částí Softwaru.',
        MIT_LICENSE_TEXT_TWO: 'SOFTWARE JE POSKYTOVÁN „TAK, JAK JE“, BEZ ZÁRUKY JAKÉHOKOLI DRUHU, VÝSLOVNÉ NEBO PŘEDPOKLÁDANÉ, VČETNĚ ZÁRUK PRODEJNOSTI, VHODNOSTI PRO KONKRÉTNÍ ÚČEL A NEPORUŠENÍ PRÁV. V ŽÁDNÉM PŘÍPADĚ NENESOU AUTOŘI NEBO NOSITELÉ AUTORSKÝCH PRÁV ODPOVĚDNÍ ZA JAKÉKOLI NÁROKY, ŠKODY NEBO JINÉ ODPOVĚDNOSTI, AŤ JIŽ PŘI SMLUVNÍ AKCI, deliktu ČI JINAK, VYPLÝVAJÍCÍ Z TOHOTO POUŽÍVÁNÍ NEBO V SOUVISLOSTI S NÍM SOFTWARE.',
},
},
    WIRELESS_GATEWAY: {
      WIRELESS_SEARCHLUMINAIRE_HEADLINE: 'Funkce Search for All Luminaires vytvoří novou konfiguraci následujícím způsobem:',
      WIRELESS_SEARCHLUMINAIRE_PAGE_CONTAINT_TEXT_ONE: 'Vyhledejte všechna nainstalovaná a adresovaná svítidla',
      WIRELESS_SEARCHLUMINAIRE_PAGE_CONTAINT_TEXT_TWO: 'Spuštěním vyhledávání odstraníte všechna aktivovaná, vadná svítidla z vaší konfigurace',
      WIRELESS_SEARCH_ALL_LUMINARIES_WARNING: 'Pokud potřebujete pouze přidat svítidla, použijte prosím možnost Hledat nová svítidla.',
      WIRELESS_SEARCH_ALL_LUMINARIES_ACTION_NON_CANCELLABLE: 'Tuto akci nelze vrátit zpět.',
      WIRELESS_SEARCH_ALL_LUMINARIES_DIALOG_TEXT: 'Spuštěním vyhledávání se z vaší konfigurace odstraní všechna aktivovaná svítidla s vadou',
      WIRELESS_RETRY_SEARCH: 'Zkuste hledat znovu',
      WIRELESS_CONFIGURE_LUMINARIES: 'Konfigurace svítidel',
      CONFIGURE_LUMINAIRES: 'Konfigurace svítidel',
      ZONE_DESCRIPTION: 'Popis',
},
    STAGE_GROUP: {
      SELECT_STAGE_GROUP: 'Vyberte Stage Group',
},
    NOTIFICATION_KEYS: {
      NOTIFICATION_ALARM_BODY: 'U následujícího systému došlo k {{logType}}',
      NOTIFICATION_HEALTH_REPORT_TITLE: 'K dispozici je nový přehled – {{org}}',
      NOTIFICATION_HEALTH_REPORT_BODY: 'Je k dispozici nový měsíční přehled pro {{building}}',
},
    DRY_CONTACT: {
      DRY_CONTACT: 'Suchý kontakt',
      DRY_CONTACT_STATUS: 'Stav suchého kontaktu',
      DEFAULT_SETTINGS: 'Výchozí nastavení',
      IOSTATUS: {
        START_FUNCTIONAL_TEST: 'Spusťte funkční test',
},
      START_FUNCTIONAL_TEST: 'Spusťte funkční test',
      NORMALLY_OPEN: 'Normálně otevřeno',
      BATTERY_OPERATION: 'Provoz na baterie',
},
    ACCOUNT_PREFERENCES: {
      CEST: 'Středoevropský čas (GMT-1:00)',
},
    SLA: {
      TECHNICIAN: 'Technik',
      UNASSIGNED: 'Nepřiřazeno',
      STATUS_TODAY: 'Dnes',
      STATUS_SCHEDULED: 'Naplánováno',
      STATUS_DUE: 'Po splatnosti',
},
},
};
 export default resources;
